import React, { useCallback, useState, useRef, useEffect, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import ReactFlow, {
  MiniMap,
  Controls,
  addEdge,
  useNodesState,
  useEdgesState,
  Handle,
  Position,
  useReactFlow,
  Background,
} from "reactflow";
import "reactflow/dist/style.css";
import {
  Box, Button, Popover, RadioGroup, FormControlLabel, Radio, IconButton, Menu, MenuItem, Dialog, DialogTitle, DialogContent, DialogActions, Avatar, Tooltip, Slide, Chip, useMediaQuery, Paper
} from "@mui/material";
import TextField from "@mui/material/TextField"; // <-- AGREGA ESTA LÍNEA
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import AddCommentIcon from "@mui/icons-material/AddComment";
import QuestionAnswerIcon from "@mui/icons-material/QuestionAnswer";
import ListAltIcon from "@mui/icons-material/ListAlt";
import SaveIcon from "@mui/icons-material/Save";
import AddBoxIcon from "@mui/icons-material/AddBox";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import ZoomInIcon from "@mui/icons-material/ZoomIn";
import ZoomOutIcon from "@mui/icons-material/ZoomOut";
import CenterFocusStrongIcon from "@mui/icons-material/CenterFocusStrong";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline"; // al inicio de tus imports
import InsightsIcon from "@mui/icons-material/Insights";
import CloudSyncIcon from "@mui/icons-material/CloudSync";
import EditNoteIcon from "@mui/icons-material/EditNote";
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import TuneIcon from "@mui/icons-material/Tune";
import "./Constructor.css";
import { auth } from "../firebase";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import FolderSpecialIcon from "@mui/icons-material/FolderSpecial";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import CancelIcon from "@mui/icons-material/Cancel";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import { Grid, Typography } from "@mui/material";
import { Checkbox, FormGroup, FormControl, InputLabel, Select } from "@mui/material";
import Autocomplete from "@mui/material/Autocomplete";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';

import ForumIcon from '@mui/icons-material/Forum';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import CircularProgress from '@mui/material/CircularProgress';

import Switch from '@mui/material/Switch';
import InfoIcon from '@mui/icons-material/Info';
// 3. ChatIcon - un ícono de chat
import ChatIcon from '@mui/icons-material/Chat';
import LanguageIcon from '@mui/icons-material/Language';
import DataObjectIcon from '@mui/icons-material/DataObject';
import ContentPasteIcon from '@mui/icons-material/ContentPaste';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import LibraryBooksIcon from '@mui/icons-material/LibraryBooks';
import { List, ListItem, ListItemText, ListItemIcon } from "@mui/material";
import DeleteIcon from '@mui/icons-material/Delete';
import { EdgeText, getBezierPath, getSmoothStepPath, BaseEdge } from 'reactflow';
import Stack from "@mui/material/Stack";
import HistoryIcon from '@mui/icons-material/History';
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import SupportAgentIcon from "@mui/icons-material/SupportAgent";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import ScheduleIcon from "@mui/icons-material/Schedule";
import EditIcon from "@mui/icons-material/Edit";
import AddIcon from "@mui/icons-material/Add";
import TouchAppIcon from "@mui/icons-material/TouchApp";
import TimerIcon from "@mui/icons-material/Timer";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import LogoutIcon from "@mui/icons-material/Logout";
import Divider from "@mui/material/Divider";
import Fade from "@mui/material/Fade";
import HomeIcon from "@mui/icons-material/Home";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import AccountTreeIcon from "@mui/icons-material/AccountTree";
import LocalHospitalIcon from "@mui/icons-material/LocalHospital";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import AnalyticsIcon from "@mui/icons-material/Analytics";
import AppsIcon from "@mui/icons-material/Apps";
import MicIcon from "@mui/icons-material/Mic";
import ImageIcon from "@mui/icons-material/Image";
import SendIcon from "@mui/icons-material/Send";
import BuildIcon from "@mui/icons-material/Build";
import FactCheckIcon from "@mui/icons-material/FactCheck";
import QueryStatsIcon from "@mui/icons-material/QueryStats";
import KeyboardIcon from "@mui/icons-material/Keyboard";
import SearchIcon from "@mui/icons-material/Search";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";



// Importacion de minicomponentes
//import PreguntasPredefinidas from './minicomponents/PreguntasPredefinidas';
//import GuardarFlujoDialog from './minicomponents/GuardarFlujoDialog';
//import CargarFlujoDialog from './minicomponents/CargarFlujoDialog';
//import EliminarFlujoDialog from './minicomponents/EliminarFlujoDialog';
//import EliminarPreguntaDialog from './minicomponents/EliminarPreguntaDialog';
//import ContextosPreguntaPopover from './minicomponents/ContextosPreguntaPopover';
//import EliminarMensajeDialog from './minicomponents/EliminarMensajeDialog';
//import AdministrarMensajesDialog  from './minicomponents/AdministrarMensajesDialog';

//import { AdministrarMensajesDialog } from './minicomponents/constructor';
// Importación simplificada de minicomponentes
import {
  PreguntasPredefinidas,
  GuardarFlujoDialog,
  CargarFlujoDialog,
  EliminarFlujoDialog,
  EliminarPreguntaDialog,
  ContextosPreguntaPopover,
  EliminarMensajeDialog,
  AdministrarMensajesDialog,
  EliminarTipoMensajeDialog,
  AdministrarTiposMensajeDialog,
  AdministrarContextosDialog,
  EmojiPicker,
  AsistenteFlujosDialog,
} from './minicomponents/constructor';

let nodeIdCounter = Date.now();

const CONTEXTO_DESCRIPCION_TEMPLATE =
  "Eres un asistente [tema]. Solo responde preguntas sobre [temas]. Si la pregunta no es relevante, indica amablemente que solo puedes responder sobre temas [tema].";



const assistantSteps = [
  {
    label: "¿Quieres que agregue un saludo inicial y pregunte el nombre de la persona?",
    node: {
      type: "open",
      label: "¿Cuál es tu nombre?",
      variable: "nombre"
    },
    confirmText: "Sí, agregar saludo y pedir nombre",
    nextDelay: 3000,
    next: 1
  },
  {
    label: "¿Quieres que también agregue una pregunta para pedir el correo electrónico de la persona?",
    node: {
      type: "open",
      label: "¿Cuál es tu correo electrónico?",
      variable: "correo"
    },
    confirmText: "Sí, agregar pregunta de correo",
    nextDelay: 3000,
    next: 2
  },
  {
    label: "¿Te gustaría agregar una pregunta para saber de qué empresa nos escribe?",
    node: {
      type: "open",
      label: "¿De cuál empresa nos escribes?",
      variable: "empresa"
    },
    confirmText: "Sí, agregar pregunta de empresa",
    nextDelay: 3000,
    next: 3
  },
  {
    label: "¿Quieres agregar una pregunta para el número de teléfono?",
    node: {
      type: "open",
      label: "¿Cuál es tu número de teléfono?",
      variable: "telefono"
    },
    confirmText: "Sí, agregar pregunta de teléfono",
    nextDelay: 3000,
    next: 4 // Fin de los pasos sugeridos
  },
  {
    label: "¿Quieres agregar una pregunta para el motivo de su contacto?",
    node: {
      type: "open",
      label: "¿Cuál es el motivo de tu contacto?",
      variable: "motivo"
    },
    confirmText: "Sí, agregar pregunta de motivo de contacto",
    nextDelay: 3000,
    next: null // Fin de los pasos sugeridos
  }
];

// ...tus imports...

// ...resto del código, incluyendo export default function Constructor()...

function ScrollableTextField({ value, onChange, showArrows = true, inputRef, showEmojiPicker = true, ...props }) {
  const localRef = React.useRef();
  const ref = inputRef || localRef; // Usa el ref externo si lo hay
  const [showUp, setShowUp] = React.useState(false);
  const [showDown, setShowDown] = React.useState(false);
  const [emojiAnchorEl, setEmojiAnchorEl] = React.useState(null);

  React.useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const check = () => {
      setShowUp(el.scrollTop > 0);
      setShowDown(el.scrollTop + el.clientHeight < el.scrollHeight - 1);
    };
    check();
    el.addEventListener("scroll", check);
    return () => el.removeEventListener("scroll", check);
  }, [value]);

  const scrollBy = (delta) => {
    if (ref.current) ref.current.scrollBy({ top: delta, behavior: "smooth" });
  };

  const handleEmojiButtonClick = (event) => {
    event.stopPropagation();
    setEmojiAnchorEl(event.currentTarget);
  };

  const handleEmojiClose = () => {
    setEmojiAnchorEl(null);
  };

  const handleEmojiSelect = (emoji) => {
    const input = ref.current;
    if (input) {
      const start = input.selectionStart || value?.length || 0;
      const end = input.selectionEnd || value?.length || 0;
      const newValue = (value || '').substring(0, start) + emoji + (value || '').substring(end);

      const syntheticEvent = {
        target: { value: newValue },
        currentTarget: { value: newValue }
      };
      onChange(syntheticEvent);

      setTimeout(() => {
        if (input) {
          input.focus();
          const newPosition = start + emoji.length;
          input.setSelectionRange(newPosition, newPosition);
        }
      }, 10);
    }
    handleEmojiClose();
  };

  return (
    <Box sx={{ position: "relative", width: "100%", minWidth: 32 }}>
      <Box sx={{ width: "100%", overflow: "hidden", borderRadius: 2 }}>
        <TextField
          {...props}
          value={value}
          onChange={onChange}
          inputRef={ref}
          multiline
          maxRows={4}
          sx={{
            ...props.sx,
            width: "100%",
            "& .MuiInputBase-input": {
              overflowY: "auto",
              scrollbarWidth: "none",
              msOverflowStyle: "none",
              fontSize: 6,
              lineHeight: 1.1,
              textAlign: "left",
              padding: "2.5px 3px !important", // Aumenta el padding lateral
              boxSizing: "border-box",
              wordBreak: "break-word",
              display: "flex",
              justifyContent: "flex-start",
              alignItems: "flex-start",
            },
            "& .MuiInputBase-root": {
              padding: "0 4px", // Agrega padding lateral al contenedor raíz
              display: "flex",
              justifyContent: "flex-start",
              alignItems: "flex-start",
            },
            "& .MuiInputBase-input::placeholder": {
              color: "#cbd5e1",
              opacity: 1,
              fontSize: 6,
              lineHeight: 1.1,
              textAlign: "left",
              display: "flex",
              justifyContent: "flex-start",
              alignItems: "flex-start",
              padding: "0 3px", // Padding para el placeholder
            },
          }}
          InputProps={{
            ...props.InputProps,
            disableUnderline: true,
            style: { 
              textAlign: "left", 
              fontSize: 6, 
              lineHeight: 1.1, 
              padding: "0 4px", // Padding consistente
              display: "flex",
              justifyContent: "flex-start",
              alignItems: "flex-start",
            },
          }}
          inputProps={{
            ...props.inputProps,
            style: { 
              textAlign: "left", 
              fontSize: 6, 
              lineHeight: 1.1, 
              padding: "0 3px", // Padding consistente
              wordBreak: "break-word",
              display: "flex",
              justifyContent: "flex-start",
              alignItems: "flex-start",
            }
          }}
        />
        <style>
          {`
            textarea::-webkit-scrollbar { display: none !important; }
            textarea.MuiInputBase-input { 
              display: flex !important; 
              justify-content: center !important; 
              align-items: center !important; 
              text-align: center !important;
              padding: 0 4px !important; /* Padding lateral consistente */
            }
          `}
        </style>
      </Box>
      {/* Flechas ABSOLUTAS fuera del nodo */}
      {showArrows && showUp && (
        <IconButton
          size="small"
          sx={{
            position: "absolute",
            top: -10,
            right: -10,
            zIndex: 10,
            bgcolor: "#fff",
            color: "#6366f1",
            boxShadow: 1,
            "&:hover": { bgcolor: "#e0e7ef" },
            p: 0.1,
            fontSize: 2,
            width: 8,
            height: 8,
          }}
          onClick={() => scrollBy(-24)}
        >
          <KeyboardArrowUpIcon fontSize="inherit" sx={{ fontSize: 12 }} />
        </IconButton>
      )}
      {showArrows && showDown && (
        <IconButton
          size="small"
          sx={{
            position: "absolute",
            bottom: -10,
            right: -10,
            zIndex: 10,
            bgcolor: "#fff",
            color: "#6366f1",
            boxShadow: 1,
            "&:hover": { bgcolor: "#e0e7ef" },
            p: 0.1,
            fontSize: 2,
            width: 8,
            height: 8,
          }}
          onClick={() => scrollBy(24)}
        >
          <KeyboardArrowDownIcon fontSize="inherit" sx={{ fontSize: 12 }} />
        </IconButton>
      )}
      {/* Botón de Emoji */}
      {showEmojiPicker && (
        <IconButton
          size="small"
          onClick={handleEmojiButtonClick}
          sx={{
            position: "absolute",
            top: -12,
            left: -12,
            zIndex: 100,
            bgcolor: "#fbbf24",
            color: "#000",
            boxShadow: "0 2px 8px rgba(0,0,0,0.3)",
            "&:hover": { bgcolor: "#f59e0b", transform: "scale(1.1)" },
            p: 0,
            width: 14,
            height: 14,
            minWidth: 14,
            borderRadius: "50%",
            border: "1px solid #f59e0b",
          }}
          title="Insertar emoji"
        >
          <span style={{ fontSize: 10, lineHeight: 1 }}>😊</span>
        </IconButton>
      )}
      {/* EmojiPicker Popover */}
      <EmojiPicker
        anchorEl={emojiAnchorEl}
        open={Boolean(emojiAnchorEl)}
        onClose={handleEmojiClose}
        onEmojiSelect={handleEmojiSelect}
      />
    </Box>
  );
}



// Nodo personalizado vacío
function CustomNode({ id, data, selected, isConnectable, flowContext, variablesList, predefinedQuestions = [], contextOptions = [], flowContextId, setEdges, filteredPredefinedQuestions = [], loadingQuestions, userName, user }) {
  console.log("Renderizando CustomNode", variablesList);
  const [anchorEl, setAnchorEl] = useState(null);
  const [menuAnchor, setMenuAnchor] = useState(null);
  const [editingOptionIdx, setEditingOptionIdx] = useState(null);
  const [localFilteredPredefinedQuestions, setLocalFilteredPredefinedQuestions] = useState([]);

  
  const [mensajesList, setMensajesList] = useState([]);
  const [loadingMensajes, setLoadingMensajes] = useState(false);

   useEffect(() => {
    setLocalFilteredPredefinedQuestions([]);
  }, [flowContextId, id]);
  
  
  
  const handleSelectMensaje = (mensaje) => {
    if (data.onChange) {
      data.onChange(id, { ...data, label: mensaje });
    }
    handleMenuClose();
  };
  
const textFieldRef = useRef();
const [variableMenuAnchor, setVariableMenuAnchor] = useState(null);

const handleInsertVariable = (variable) => {
  const input = textFieldRef.current;
  if (!input) return;
  const start = input.selectionStart || 0;
  const end = input.selectionEnd || 0;
  const value = data.label || "";
  const variableText = `{${variable}}`;
  const newValue = value.slice(0, start) + variableText + value.slice(end);
  if (data.onChange) data.onChange(id, { ...data, label: newValue });
  setVariableMenuAnchor(null);
  setTimeout(() => {
    input.focus();
    input.setSelectionRange(start + variableText.length, start + variableText.length);
  }, 0);
};

  const handleFilterMensajes = (contextoId) => {
    fetchMensajes(contextoId);
  };
  
 const fetchMensajes = useCallback(async () => {
  setLoadingMensajes(true);
  try {
    // Si no hay flowContextId definido, mostrar mensaje apropiado
    if (!flowContextId) {
      setMensajesList([]);
      setLoadingMensajes(false);
      return;
    }
    
    // Asegurarse de usar el ID del contexto actual del flujo
    const url = `/api/mensajes/?id_contexto=${flowContextId}`;
    
    console.log("Consultando mensajes para contexto:", flowContextId);
    const response = await fetch(url, {
      headers: {
        "X-User-Id": flowContext ? String(flowContext) : ""
      }
    });
    
    if (response.ok) {
      const data = await response.json();
      console.log("Mensajes recibidos:", data.length);
      setMensajesList(data);
    } else {
      console.error("Error en respuesta al cargar mensajes");
      setMensajesList([]);
    }
  } catch (error) {
    console.error("Error al cargar mensajes:", error);
    setMensajesList([]);
  } finally {
    setLoadingMensajes(false);
  }
}, [flowContextId, flowContext]);

// Actualizar el efecto para volver a cargar mensajes cuando cambia el contexto
useEffect(() => {
  if (menuAnchor && data.type === "message") {
    fetchMensajes();
  }
}, [menuAnchor, data.type, fetchMensajes, flowContextId]); // Asegura que flowContextId esté en las dependencias




  function suggestVariableFromQuestion(question, variablesList) {
    const lower = question.toLowerCase();
    for (const v of variablesList) {
      if (lower.includes(v.nombre_variable)) return v.nombre_variable;
    }
    if (lower.includes("nombre")) return "nombre";
    if (lower.includes("correo")) return "correo";
    if (lower.includes("empresa")) return "empresa";
    if (lower.includes("teléfono") || lower.includes("telefono")) return "telefono";
    return "";
  }

  const handleDoubleClick = (event) => {
  // Agregar input_ia a la condición
  if (data.type === "input" || data.type === "input_ia") {
    if (data.onChange) data.onChange(id, { ...data, editingLabel: true });
  }
};

  const handleClose = () => setAnchorEl(null);

  const handleVariableChange = (e) => {
    if (data.onChange) {
      data.onChange(id, { ...data, variable: e.target.value });
    }
    handleClose();
  };

  const handleLabelChange = (e) => {
    const value = e.target.value;
    let variable = data.variable || "";
    variable = suggestVariableFromQuestion(value, variablesList);
    if (data.onChange) {
      data.onChange(id, { ...data, label: value, variable });
    }
  };

const handleMenuOpen = async (event) => {
  setMenuAnchor(event.currentTarget); // Abre el menú inmediatamente

  if (!flowContextId) {
    setLocalFilteredPredefinedQuestions([]);
    return;
  }

  if (data.type === "open" && flowContextId) {
    setLocalFilteredPredefinedQuestions([]); // Limpia antes de cargar
    try {
      const res = await fetch(`/api/variable/?id_contexto=${flowContextId}`);
      const relaciones = await res.json();
      const preguntaIds = relaciones.map(rel => rel.id_pregunta);
      const preguntasFiltradas = predefinedQuestions.filter(q => preguntaIds.includes(q.id));
      setLocalFilteredPredefinedQuestions(preguntasFiltradas);
    } catch (err) {
      setLocalFilteredPredefinedQuestions([]);
    }
  }
};


  const handleMenuClose = () => setMenuAnchor(null);

  const handlePredefinedSelect = (q) => {
    let pregunta = typeof q === "string" ? q : q.pregunta;
    let variable = typeof q === "string"
      ? suggestVariableFromQuestion(q, variablesList)
      : (q.variable || suggestVariableFromQuestion(q.pregunta, variablesList));
    let tipo_dato = typeof q === "string" ? "texto" : (q.tipo_dato || "texto");
    if (data.onChange) {
      data.onChange(id, { ...data, label: pregunta, variable, tipo_dato });
    }
    setMenuAnchor(null);
  };

  console.log("predefinedQuestions:", predefinedQuestions);
  console.log("flowContextId:", flowContextId);
  console.log("localFilteredPredefinedQuestions:", localFilteredPredefinedQuestions);

  return (
    <Box
      onDoubleClick={handleDoubleClick}
      sx={{
        p: 0,
        background: id === "1" ? "transparent" : (selected ? "#f1f5f9" : "#fff"),
        border: id === "1" ? "none" : "1px solid #e2e8f0",
        borderRadius: id === "1" ? 2 : 1.5,
        minWidth: 18,
        maxWidth: 65,
        width: 65,
        minHeight: 8,
        height: "auto",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        fontSize: 6,
        fontWeight: 600,
        color: "#334155",
        boxShadow: selected ? "0 0 0 2px #6366f1, 0 4px 12px rgba(99, 102, 241, 0.25)" : (id === "1" ? "none" : "0 2px 6px rgba(0,0,0,0.06)"),
        textAlign: "center",
        wordBreak: "break-word",
        cursor: data.type === "open" ? "pointer" : "default",
        px: 0,
        py: 0,
        transition: "all 0.2s ease",
        "&:hover": {
          boxShadow: id === "1" ? "0 4px 12px rgba(16, 185, 129, 0.35)" : "0 4px 12px rgba(0,0,0,0.1)",
        }
      }}
    >
      {/* Handle izquierdo */}
      {id !== "1" && (
        <Handle
          type="target"
          position={Position.Left}
          isConnectable={isConnectable}
          style={{
            background: "#22c55e",
            border: "1.2px solid #16a34a",
            width: 4,
            height: 4,
            minWidth: 4,
            minHeight: 4,
          }}
        />
      )}
      {/* Nodo de inicio - Rediseñado */}
      {id === "1" ? (
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            width: "100%",
            background: "linear-gradient(135deg, #10b981 0%, #059669 100%)",
            borderRadius: 1.5,
            py: 0.8,
            px: 0.5,
            boxShadow: "0 2px 8px rgba(16, 185, 129, 0.3)",
          }}
        >
          <Box sx={{
            width: 16,
            height: 16,
            borderRadius: "50%",
            background: "rgba(255,255,255,0.25)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            mb: 0.3,
          }}>
            <PlayArrowIcon sx={{ fontSize: 12, color: "#fff" }} />
          </Box>
          <Typography sx={{
            fontSize: 5.5,
            fontWeight: 700,
            color: "#fff",
            letterSpacing: 0.3,
            textAlign: "center",
            lineHeight: 1.1,
            textShadow: "0 1px 2px rgba(0,0,0,0.15)"
          }}>
            INICIO
          </Typography>
        </Box>
        
          ) : data.type === "input_ia" ? (
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "stretch",
              width: "100%",
              overflow: "hidden",
              borderRadius: 1.5,
              background: "linear-gradient(180deg, #14b8a6 0%, #0d9488 100%)",
              boxShadow: "0 2px 8px rgba(20, 184, 166, 0.25)",
            }}
          >
            {/* Header compacto */}
            <Box sx={{
              py: 0.3,
              px: 0.4,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: 0.3,
              borderBottom: "1px solid rgba(255,255,255,0.15)",
            }}>
              <AutoAwesomeIcon sx={{ fontSize: 8, color: "#fff" }} />
              <Typography sx={{
                fontSize: 5,
                color: "#fff",
                fontWeight: 700,
                letterSpacing: 0.3,
              }}>
                CAPTURA IA
              </Typography>
            </Box>

            {/* Campo de instrucción */}
            <Box sx={{
              px: 0.3,
              py: 0.3,
              background: "rgba(255,255,255,0.95)",
            }}>
              {data.editingLabel ? (
                <TextField
                  autoFocus
                  multiline
                  maxRows={4}
                  value={data.label || ""}
                  onChange={handleLabelChange}
                  onBlur={() => {
                    if (data.onChange) data.onChange(id, { ...data, editingLabel: false });
                  }}
                  onKeyDown={e => {
                    if (e.key === "Escape") {
                      if (data.onChange) data.onChange(id, { ...data, editingLabel: false });
                    }
                  }}
                  placeholder="Instrucción para capturar datos..."
                  variant="standard"
                  size="small"
                  sx={{
                    width: "100%",
                    "& .MuiInputBase-root": {
                      fontSize: 5,
                      lineHeight: 1.2,
                      color: "#0f766e",
                      fontWeight: 500,
                    },
                    "& .MuiInputBase-input": {
                      textAlign: "center",
                      padding: 0,
                    },
                    "& .MuiInputBase-input::placeholder": {
                      color: "#5eead4",
                      opacity: 0.8,
                    },
                  }}
                  InputProps={{
                    disableUnderline: true,
                  }}
                />
              ) : (
                <Box
                  sx={{
                    cursor: "pointer",
                    textAlign: "center",
                    py: 0.2,
                    "&:hover": { background: "rgba(20,184,166,0.05)" },
                  }}
                  onDoubleClick={handleDoubleClick}
                  title="Doble clic para editar"
                >
                  <Typography sx={{
                    fontSize: 5,
                    color: "#0f766e",
                    fontWeight: 500,
                    lineHeight: 1.2,
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    display: "-webkit-box",
                    WebkitLineClamp: 3,
                    WebkitBoxOrient: "vertical",
                  }}>
                    {data.label || "Doble clic para editar..."}
                  </Typography>
                </Box>
              )}
            </Box>

            {/* Variables capturadas */}
            {Array.isArray(data.variables) && data.variables.length > 0 && (
              <Box sx={{
                px: 0.3,
                py: 0.2,
                background: "rgba(255,255,255,0.9)",
                borderTop: "1px solid rgba(20,184,166,0.1)",
              }}>
                <Box sx={{
                  display: "flex",
                  flexWrap: "wrap",
                  gap: 0.2,
                  justifyContent: "center",
                }}>
                  {data.variables.slice(0, 4).map((v, i) => (
                    <Box key={i} sx={{
                      px: 0.3,
                      py: 0.1,
                      background: "linear-gradient(135deg, #99f6e4 0%, #5eead4 100%)",
                      borderRadius: 0.5,
                      fontSize: 4,
                      color: "#0f766e",
                      fontWeight: 600,
                    }}>
                      {v}
                    </Box>
                  ))}
                  {data.variables.length > 4 && (
                    <Box sx={{
                      px: 0.3,
                      py: 0.1,
                      background: "#f0fdfa",
                      borderRadius: 0.5,
                      fontSize: 4,
                      color: "#0d9488",
                      fontWeight: 600,
                    }}>
                      +{data.variables.length - 4}
                    </Box>
                  )}
                </Box>
              </Box>
            )}

            {/* Footer con acción */}
            <Tooltip title="Configurar variables a extraer" arrow placement="top">
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  py: 0.2,
                  background: "rgba(255,255,255,0.95)",
                  borderTop: "1px solid rgba(20,184,166,0.1)",
                  borderRadius: "0 0 6px 6px",
                  cursor: "pointer",
                  transition: "all 0.15s ease",
                  "&:hover": {
                    background: "#fff",
                    "& .config-icon": { color: "#0d9488" },
                    "& .config-text": { color: "#0d9488" },
                  },
                }}
                onClick={e => setAnchorEl(e.currentTarget)}
              >
                <DataObjectIcon className="config-icon" sx={{ fontSize: 7, color: "#14b8a6", mr: 0.2, transition: "color 0.15s" }} />
                <Typography className="config-text" sx={{ fontSize: 4.5, color: "#14b8a6", fontWeight: 600, transition: "color 0.15s" }}>
                  Variables
                </Typography>
              </Box>
            </Tooltip>
          </Box>
        
      ) : data.type === "open" ? (
        <Box sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "stretch",
          width: "100%",
          overflow: "hidden",
          borderRadius: 1.5,
          background: "linear-gradient(180deg, #3b82f6 0%, #2563eb 100%)",
          boxShadow: "0 2px 8px rgba(59, 130, 246, 0.25)",
        }}>
          {/* Header compacto */}
          <Box sx={{
            py: 0.3,
            px: 0.4,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: 0.3,
            borderBottom: "1px solid rgba(255,255,255,0.15)",
          }}>
            <QuestionAnswerIcon sx={{ fontSize: 8, color: "#fff" }} />
            <Typography sx={{
              fontSize: 5,
              color: "#fff",
              fontWeight: 700,
              letterSpacing: 0.3,
            }}>
              PREGUNTA
            </Typography>
          </Box>

          {/* Campo de pregunta */}
          <Box sx={{
            px: 0.3,
            py: 0.3,
            background: "rgba(255,255,255,0.95)",
          }}>
            <TextField
              value={data.label || ""}
              onChange={handleLabelChange}
              placeholder="¿Tu pregunta?"
              variant="standard"
              size="small"
              multiline
              maxRows={3}
              sx={{
                width: "100%",
                "& .MuiInputBase-root": {
                  fontSize: 5,
                  lineHeight: 1.2,
                  color: "#1e40af",
                  fontWeight: 500,
                },
                "& .MuiInputBase-input": {
                  textAlign: "center",
                  padding: 0,
                },
                "& .MuiInputBase-input::placeholder": {
                  color: "#93c5fd",
                  opacity: 0.9,
                },
              }}
              InputProps={{
                disableUnderline: true,
              }}
            />
          </Box>

          {/* Footer con botón de preguntas predefinidas - Alta visibilidad */}
          <Tooltip title="Elegir pregunta prediseñada" arrow placement="top">
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                py: 0.25,
                background: "rgba(255,255,255,0.95)",
                borderTop: "1px solid rgba(255,255,255,0.3)",
                cursor: "pointer",
                transition: "all 0.15s ease",
                borderRadius: "0 0 6px 6px",
                "&:hover": {
                  background: "#fff",
                  "& .predefinidas-icon": { color: "#1d4ed8" },
                  "& .predefinidas-text": { color: "#1d4ed8" },
                },
              }}
              onClick={handleMenuOpen}
            >
              <MenuBookIcon className="predefinidas-icon" sx={{ fontSize: 8, color: "#2563eb", mr: 0.3, transition: "color 0.15s" }} />
              <Typography className="predefinidas-text" sx={{ fontSize: 5, color: "#2563eb", fontWeight: 700, transition: "color 0.15s" }}>
                Predefinidas
              </Typography>
            </Box>
          </Tooltip> 
          
          <Menu
          anchorEl={menuAnchor}
          open={Boolean(menuAnchor)}
          onClose={handleMenuClose}
          PaperProps={{
            sx: {
              minWidth: 250,
              maxHeight: 280,
              borderRadius: 2,
              boxShadow: "0 4px 16px rgba(99,102,241,0.15)",
              background: "#f8fafc",
              p: 1,
            }
          }}
          MenuListProps={{
            sx: { p: 0 }
          }}
        >
          {!flowContextId ? (
            <Box sx={{ 
              p: 1,
              display: 'flex', 
              flexDirection: 'column',
              alignItems: 'flex-start', // <-- Cambia aquí
              gap: 0.5,
              width: "fit-content" // <-- El Box se ajusta al contenido
            }}>
              <InfoIcon sx={{ color: "#e11d48", fontSize: 20, mb: 0.5 }} />
              <Typography variant="body2" 
                sx={{ color: "#e11d48", fontWeight: 700, fontSize: 13, textAlign: "left" }}>
                Define un contexto para ver preguntas.
              </Typography>
              <Typography variant="caption" 
                sx={{ color: "#64748b", fontSize: 11, textAlign: "left" }}>
                Guarda el flujo y selecciona un contexto para habilitar preguntas predefinidas.
              </Typography>
            </Box>
          ) : localFilteredPredefinedQuestions.length === 0 ? (
            <Box sx={{ 
                p: 1.5,
                display: 'flex', 
                flexDirection: 'column',
                alignItems: 'center',
                gap: 0.8
              }}>
                <CircularProgress size={18} sx={{ color: "#6366f1", opacity: 0.7 }} />
                <Typography variant="body2" sx={{ color: "#64748b", fontStyle: "italic", fontSize: 13 }}>
                  {loadingQuestions ? "Cargando preguntas..." : "No hay preguntas predefinidas"}
                </Typography>
              </Box>
          ) : (
            <List sx={{ p: 0 }}>
              {localFilteredPredefinedQuestions.map((q, index) => {
                // Colores alternados para los iconos
                const iconColors = ["#6366f1", "#f472b6", "#34d399", "#fb7185", "#a78bfa", "#fbbf24"];
                const colorIndex = index % iconColors.length;
                const iconColor = iconColors[colorIndex];
                
                return (
                  <ListItem
                    key={q.id || q.pregunta || q}
                    onClick={() => handlePredefinedSelect(q)}
                    sx={{
                      borderRadius: 1,
                      m: 0.3,
                      py: 0.5,
                      transition: "all 0.2s",
                      "&:hover": {
                        background: "#e0e7ef",
                        "& .use-button": {
                          opacity: 1,
                          transform: "translateX(0)",
                        }
                      },
                      cursor: "pointer",
                      position: "relative",
                      pr: 10,
                    }}
                    dense
                  >
                    <ListItemIcon sx={{ minWidth: 28 }}>
                      <QuestionAnswerIcon sx={{ fontSize: 16, color: iconColor }} />
                    </ListItemIcon>
                    <ListItemText 
                      primary={q.pregunta || q} 
                      primaryTypographyProps={{ 
                        fontSize: 12,
                        fontWeight: 500,
                        color: "#334155",
                        lineHeight: 1.2,
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                      }}
                    />
                    <Button
                      className="use-button"
                      variant="contained"
                      size="small"
                      sx={{
                        position: "absolute",
                        right: 8,
                        minWidth: "auto",
                        fontSize: 11,
                        py: 0.2,
                        px: 1,
                        height: 24,
                        background: "#6366f1",
                        color: "#fff",
                        boxShadow: "none",
                        opacity: 0,
                        transform: "translateX(10px)",
                        transition: "opacity 0.2s, transform 0.2s",
                        "&:hover": {
                          background: "#4f46e5",
                        }
                      }}
                      onClick={(e) => {
                        e.stopPropagation();
                        handlePredefinedSelect(q);
                      }}
                    >
                      Usar
                    </Button>
                  </ListItem>
                );
              })}
            </List>
          )}
        </Menu>


        </Box>

    ) : data.type === "verificar_cliente" ? (
    <>
      <Box sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "stretch",
        width: "100%",
        overflow: "hidden",
        borderRadius: 1.5,
        background: "linear-gradient(180deg, #0ea5e9 0%, #0284c7 100%)",
        boxShadow: "0 2px 8px rgba(14, 165, 233, 0.25)",
      }}>
        {/* Header compacto */}
        <Box sx={{
          py: 0.3,
          px: 0.4,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: 0.3,
          borderBottom: "1px solid rgba(255,255,255,0.15)",
        }}>
          <HelpOutlineIcon sx={{ fontSize: 8, color: "#fff" }} />
          <Typography sx={{
            fontSize: 5,
            color: "#fff",
            fontWeight: 700,
            letterSpacing: 0.3,
          }}>
            VERIFICAR
          </Typography>
        </Box>

        {/* Campo de mensaje */}
        <Box sx={{
          px: 0.3,
          py: 0.3,
          background: "rgba(255,255,255,0.95)",
        }}>
          <TextField
            value={data.label || ""}
            onChange={handleLabelChange}
            placeholder="Mensaje de verificación..."
            variant="standard"
            size="small"
            multiline
            maxRows={2}
            sx={{
              width: "100%",
              "& .MuiInputBase-root": {
                fontSize: 5,
                lineHeight: 1.2,
                color: "#0369a1",
                fontWeight: 500,
              },
              "& .MuiInputBase-input": {
                textAlign: "center",
                padding: 0,
              },
              "& .MuiInputBase-input::placeholder": {
                color: "#7dd3fc",
                opacity: 0.8,
              },
            }}
            InputProps={{
              disableUnderline: true,
            }}
          />
        </Box>

        {/* Indicadores de salida */}
        <Box sx={{
          display: "flex",
          flexDirection: "column",
          gap: 0.2,
          px: 0.3,
          py: 0.25,
          background: "rgba(255,255,255,0.9)",
          borderRadius: "0 0 6px 6px",
        }}>
          {/* Salida: Existe */}
          <Box sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-end",
            gap: 0.3,
            pr: 0.5,
          }}>
            <Box sx={{
              px: 0.4,
              py: 0.1,
              background: "linear-gradient(135deg, #dcfce7 0%, #bbf7d0 100%)",
              borderRadius: 0.5,
              display: "flex",
              alignItems: "center",
              gap: 0.2,
            }}>
              <CheckCircleIcon sx={{ fontSize: 6, color: "#16a34a" }} />
              <Typography sx={{ fontSize: 4, color: "#166534", fontWeight: 700 }}>
                Existe
              </Typography>
            </Box>
          </Box>

          {/* Salida: No existe */}
          <Box sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-end",
            gap: 0.3,
            pr: 0.5,
          }}>
            <Box sx={{
              px: 0.4,
              py: 0.1,
              background: "linear-gradient(135deg, #fee2e2 0%, #fecaca 100%)",
              borderRadius: 0.5,
              display: "flex",
              alignItems: "center",
              gap: 0.2,
            }}>
              <CancelIcon sx={{ fontSize: 6, color: "#dc2626" }} />
              <Typography sx={{ fontSize: 4, color: "#991b1b", fontWeight: 700 }}>
                No existe
              </Typography>
            </Box>
          </Box>
        </Box>
      </Box>

      {/* Handle para "Cliente EXISTE" */}
      <Handle
        type="source"
        position={Position.Right}
        id="cliente-existe"
        isConnectable={isConnectable}
        style={{
          top: "62%",
          background: "#22c55e",
          border: "1.5px solid #16a34a",
          width: 5,
          height: 5,
          minWidth: 5,
          minHeight: 5,
        }}
      />

      {/* Handle para "Cliente NO EXISTE" */}
      <Handle
        type="source"
        position={Position.Right}
        id="cliente-no-existe"
        isConnectable={isConnectable}
        style={{
          top: "82%",
          background: "#ef4444",
          border: "1.5px solid #dc2626",
          width: 5,
          height: 5,
          minWidth: 5,
          minHeight: 5,
        }}
      />
    </>

    ) : data.type === "image_analysis" ? (
      <Box sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "stretch",
        width: "100%",
        overflow: "hidden",
        borderRadius: 1.5,
        background: "linear-gradient(180deg, #f59e0b 0%, #d97706 100%)",
        boxShadow: "0 2px 8px rgba(245, 158, 11, 0.25)",
      }}>
        {/* Header compacto */}
        <Box sx={{
          py: 0.3,
          px: 0.4,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: 0.3,
          borderBottom: "1px solid rgba(255,255,255,0.15)",
        }}>
          <VisibilityIcon sx={{ fontSize: 8, color: "#fff" }} />
          <Typography sx={{
            fontSize: 5,
            color: "#fff",
            fontWeight: 700,
            letterSpacing: 0.3,
          }}>
            ANÁLISIS IA
          </Typography>
        </Box>

        {/* Campo de mensaje */}
        <Box sx={{
          px: 0.3,
          py: 0.3,
          background: "rgba(255,255,255,0.95)",
        }}>
          <TextField
            value={data.label || ""}
            onChange={handleLabelChange}
            placeholder="Solicitar imagen médica..."
            variant="standard"
            size="small"
            multiline
            maxRows={3}
            sx={{
              width: "100%",
              "& .MuiInputBase-root": {
                fontSize: 5,
                lineHeight: 1.2,
                color: "#92400e",
                fontWeight: 500,
              },
              "& .MuiInputBase-input": {
                textAlign: "center",
                padding: 0,
              },
              "& .MuiInputBase-input::placeholder": {
                color: "#fcd34d",
                opacity: 0.8,
              },
            }}
            InputProps={{
              disableUnderline: true,
            }}
          />
        </Box>

        {/* Footer indicador */}
        <Box sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          py: 0.2,
          background: "rgba(255,255,255,0.9)",
          borderTop: "1px solid rgba(245,158,11,0.1)",
          borderRadius: "0 0 6px 6px",
          gap: 0.3,
        }}>
          <Box sx={{
            display: "flex",
            alignItems: "center",
            gap: 0.2,
            px: 0.3,
            py: 0.1,
            background: "linear-gradient(135deg, #fef3c7 0%, #fde68a 100%)",
            borderRadius: 0.5,
          }}>
            <AutoAwesomeIcon sx={{ fontSize: 6, color: "#d97706" }} />
            <Typography sx={{ fontSize: 4, color: "#92400e", fontWeight: 700 }}>
              Claude Vision
            </Typography>
          </Box>
        </Box>
      </Box>

    ) : data.type === "agendar_cita" ? (
      <Box sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "stretch",
        width: "100%",
        overflow: "hidden",
        borderRadius: 1.5,
        background: "linear-gradient(180deg, #10b981 0%, #059669 100%)",
        boxShadow: "0 2px 8px rgba(16, 185, 129, 0.25)",
      }}>
        {/* Header compacto */}
        <Box sx={{
          py: 0.3,
          px: 0.4,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: 0.3,
          borderBottom: "1px solid rgba(255,255,255,0.15)",
        }}>
          <InsightsIcon sx={{ fontSize: 8, color: "#fff" }} />
          <Typography sx={{
            fontSize: 5,
            color: "#fff",
            fontWeight: 700,
            letterSpacing: 0.3,
          }}>
            AGENDAR CITA
          </Typography>
        </Box>

        {/* Campo de fecha */}
        <Box sx={{
          px: 0.3,
          py: 0.3,
          background: "rgba(255,255,255,0.95)",
        }}>
          <TextField
            size="small"
            placeholder="YYYY-MM-DD HH:MM"
            value={data.fechaCita || ""}
            onChange={e => {
              if (data.onChange) data.onChange(id, { ...data, fechaCita: e.target.value });
            }}
            variant="standard"
            sx={{
              width: "100%",
              "& .MuiInputBase-root": {
                fontSize: 5,
                color: "#065f46",
                fontWeight: 500,
              },
              "& .MuiInputBase-input": {
                textAlign: "center",
                padding: 0,
              },
              "& .MuiInputBase-input::placeholder": {
                color: "#6ee7b7",
                opacity: 0.8,
              },
            }}
            InputProps={{
              disableUnderline: true,
            }}
          />
        </Box>

        {/* Estado de cita agendada */}
        {data.citaAgendada && (
          <Box sx={{
            px: 0.3,
            py: 0.2,
            background: "#ecfdf5",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: 0.2,
          }}>
            <CheckCircleIcon sx={{ fontSize: 7, color: "#10b981" }} />
            <Typography sx={{ fontSize: 4, color: "#065f46", fontWeight: 600 }}>
              Cita agendada
            </Typography>
          </Box>
        )}

        {/* Footer con botón de agendar */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            py: 0.25,
            background: data.fechaCita ? "rgba(255,255,255,0.95)" : "rgba(255,255,255,0.7)",
            borderTop: "1px solid rgba(16,185,129,0.1)",
            borderRadius: "0 0 6px 6px",
            cursor: data.fechaCita ? "pointer" : "not-allowed",
            transition: "all 0.15s ease",
            "&:hover": {
              background: data.fechaCita ? "#fff" : "rgba(255,255,255,0.7)",
            },
          }}
          onClick={async () => {
            if (!data.fechaCita) return;
            try {
              const res = await fetch("/api/agendar_cita_usuario/", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                  nombre: userName || "Paciente",
                  correo: user?.email || "",
                  fecha: data.fechaCita,
                })
              });
              const result = await res.json();
              if (result.success) {
                if (data.onChange) data.onChange(id, { ...data, citaAgendada: true });
              } else {
                alert(result.detail || "No se pudo agendar la cita.");
              }
            } catch (err) {
              alert("Error al agendar cita");
            }
          }}
        >
          <CheckCircleIcon sx={{ fontSize: 7, color: data.fechaCita ? "#10b981" : "#94a3b8", mr: 0.2 }} />
          <Typography sx={{ fontSize: 4.5, color: data.fechaCita ? "#10b981" : "#94a3b8", fontWeight: 700 }}>
            Confirmar
          </Typography>
        </Box>
      </Box>

    ) : data.type === "verificar_datos" ? (
      <Box sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "stretch",
        width: "100%",
        overflow: "hidden",
        borderRadius: 1.5,
        background: "linear-gradient(180deg, #22c55e 0%, #16a34a 100%)",
        boxShadow: "0 2px 8px rgba(34, 197, 94, 0.25)",
      }}>
        {/* Header compacto */}
        <Box sx={{
          py: 0.3,
          px: 0.4,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: 0.3,
          borderBottom: "1px solid rgba(255,255,255,0.15)",
        }}>
          <CheckCircleIcon sx={{ fontSize: 8, color: "#fff" }} />
          <Typography sx={{
            fontSize: 5,
            color: "#fff",
            fontWeight: 700,
            letterSpacing: 0.3,
          }}>
            VERIFICAR DATOS
          </Typography>
        </Box>

        {/* Campo de mensaje */}
        <Box sx={{
          px: 0.3,
          py: 0.3,
          background: "rgba(255,255,255,0.95)",
        }}>
          <TextField
            value={data.label || ""}
            onChange={e => {
              if (data.onChange) data.onChange(id, { ...data, label: e.target.value });
            }}
            placeholder="Mensaje de confirmación..."
            variant="standard"
            size="small"
            multiline
            maxRows={3}
            sx={{
              width: "100%",
              "& .MuiInputBase-root": {
                fontSize: 5,
                lineHeight: 1.2,
                color: "#166534",
                fontWeight: 500,
              },
              "& .MuiInputBase-input": {
                textAlign: "center",
                padding: 0,
              },
              "& .MuiInputBase-input::placeholder": {
                color: "#86efac",
                opacity: 0.8,
              },
            }}
            InputProps={{
              disableUnderline: true,
            }}
          />
        </Box>

        {/* Footer informativo */}
        <Box sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          py: 0.2,
          background: "rgba(255,255,255,0.9)",
          borderTop: "1px solid rgba(34,197,94,0.1)",
          borderRadius: "0 0 6px 6px",
          gap: 0.3,
        }}>
          <VisibilityIcon sx={{ fontSize: 6, color: "#22c55e" }} />
          <Typography sx={{ fontSize: 4, color: "#166534", fontWeight: 600 }}>
            Confirma datos capturados
          </Typography>
        </Box>
      </Box>

    ) : data.type === "escalacion_humano" ? (
      <Box sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "stretch",
        width: "100%",
        overflow: "hidden",
        borderRadius: 1.5,
        background: "linear-gradient(180deg, #f59e0b 0%, #d97706 100%)",
        boxShadow: "0 2px 8px rgba(245, 158, 11, 0.25)",
      }}>
        {/* Header compacto */}
        <Box sx={{
          py: 0.3,
          px: 0.4,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: 0.3,
          borderBottom: "1px solid rgba(255,255,255,0.15)",
        }}>
          <SupportAgentIcon sx={{ fontSize: 8, color: "#fff" }} />
          <Typography sx={{
            fontSize: 5,
            color: "#fff",
            fontWeight: 700,
            letterSpacing: 0.3,
          }}>
            ESCALACIÓN HUMANO
          </Typography>
        </Box>

        {/* Campo de mensaje */}
        <Box sx={{
          px: 0.3,
          py: 0.3,
          background: "rgba(255,255,255,0.95)",
        }}>
          <TextField
            value={data.label || ""}
            onChange={handleLabelChange}
            placeholder="Mensaje de transferencia..."
            variant="standard"
            size="small"
            multiline
            maxRows={3}
            sx={{
              width: "100%",
              "& .MuiInputBase-root": {
                fontSize: 5,
                lineHeight: 1.2,
                color: "#92400e",
                fontWeight: 500,
              },
              "& .MuiInputBase-input": {
                textAlign: "center",
                padding: 0,
              },
              "& .MuiInputBase-input::placeholder": {
                color: "#fcd34d",
                opacity: 0.8,
              },
            }}
            InputProps={{
              disableUnderline: true,
            }}
          />
        </Box>

        {/* Footer indicador */}
        <Box sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          py: 0.2,
          background: "rgba(255,255,255,0.9)",
          borderTop: "1px solid rgba(245,158,11,0.1)",
          borderRadius: "0 0 6px 6px",
          gap: 0.3,
        }}>
          <Box sx={{
            display: "flex",
            alignItems: "center",
            gap: 0.2,
            px: 0.3,
            py: 0.1,
            background: "linear-gradient(135deg, #fef3c7 0%, #fde68a 100%)",
            borderRadius: 0.5,
          }}>
            <SupportAgentIcon sx={{ fontSize: 6, color: "#d97706" }} />
            <Typography sx={{ fontSize: 4, color: "#92400e", fontWeight: 700 }}>
              Transferir a Agente
            </Typography>
          </Box>
        </Box>
      </Box>

      ) : data.type === "options" ? (
        <Box sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "stretch",
          width: "100%",
          overflow: "hidden",
          borderRadius: 1.5,
          background: "linear-gradient(180deg, #7c3aed 0%, #6d28d9 100%)",
          boxShadow: "0 2px 8px rgba(124, 58, 237, 0.25)",
        }}>
          {/* Header compacto */}
          <Box sx={{
            py: 0.3,
            px: 0.4,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: 0.3,
            borderBottom: "1px solid rgba(255,255,255,0.15)",
          }}>
            <ListAltIcon sx={{ fontSize: 8, color: "#fff" }} />
            <Typography sx={{
              fontSize: 5,
              color: "#fff",
              fontWeight: 700,
              letterSpacing: 0.3,
            }}>
              OPCIONES
            </Typography>
          </Box>

          {/* Campo de pregunta - compacto */}
          <Box sx={{
            px: 0.3,
            py: 0.25,
            background: "rgba(255,255,255,0.95)",
          }}>
            <TextField
              value={data.label || ""}
              onChange={handleLabelChange}
              placeholder="¿Pregunta?"
              variant="standard"
              size="small"
              multiline
              maxRows={2}
              sx={{
                width: "100%",
                "& .MuiInputBase-root": {
                  fontSize: 5,
                  lineHeight: 1.2,
                  color: "#5b21b6",
                  fontWeight: 500,
                },
                "& .MuiInputBase-input": {
                  textAlign: "center",
                  padding: 0,
                },
                "& .MuiInputBase-input::placeholder": {
                  color: "#a78bfa",
                  opacity: 0.8,
                },
              }}
              InputProps={{
                disableUnderline: true,
              }}
            />
          </Box>

          {/* Lista de opciones */}
          <Box sx={{
            display: "flex",
            flexDirection: "column",
            gap: "2px",
            p: 0.3,
            background: "rgba(255,255,255,0.9)",
          }}>
            {(data.options || []).map((opt, idx) => (
              <Box
                key={idx}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  position: "relative",
                  width: "100%",
                }}
              >
              {editingOptionIdx === idx ? (
                <TextField
                  autoFocus
                  value={(() => {
                    const match = opt.match(/^(\d+)\.\s?(.*)$/);
                    return match ? match[2] : opt;
                  })()}
                  onChange={e => {
                    const newOptions = [...data.options];
                    newOptions[idx] = `${idx + 1}. ${e.target.value}`;
                    if (data.onChange) data.onChange(id, { ...data, options: newOptions });
                  }}
                  onBlur={() => setEditingOptionIdx(null)}
                  onKeyDown={e => { if (e.key === "Enter") setEditingOptionIdx(null); }}
                  placeholder="opción"
                  variant="standard"
                  size="small"
                  sx={{
                    flex: 1,
                    "& .MuiInputBase-root": {
                      fontSize: 5,
                      background: optionColors[idx % optionColors.length],
                      borderRadius: 0.5,
                      px: 0.3,
                      py: 0.1,
                    },
                    "& .MuiInputBase-input": {
                      color: "#fff",
                      fontWeight: 500,
                      padding: 0,
                    },
                  }}
                  InputProps={{ disableUnderline: true }}
                />
              ) : (
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    flex: 1,
                    minWidth: 0,
                    background: optionColors[idx % optionColors.length],
                    borderRadius: 0.5,
                    px: 0.3,
                    py: 0.1,
                    cursor: "pointer",
                    transition: "all 0.12s ease",
                    "&:hover": {
                      filter: "brightness(1.1)",
                      transform: "scale(1.01)",
                    },
                  }}
                  onDoubleClick={() => setEditingOptionIdx(idx)}
                  title={opt}
                >
                  <Typography sx={{
                    fontSize: 5,
                    fontWeight: 700,
                    color: "#fff",
                    mr: 0.2,
                    minWidth: 8,
                  }}>
                    {idx + 1}.
                  </Typography>
                  <Typography sx={{
                    fontSize: 5,
                    color: "#fff",
                    fontWeight: 500,
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    flex: 1,
                  }}>
                    {(() => {
                      const match = opt?.match(/^(\d+)\.\s?(.*)$/);
                      const text = match ? match[2] : opt;
                      return text || "...";
                    })()}
                  </Typography>
                </Box>
              )}
                {/* Botón eliminar - más pequeño */}
                <IconButton
                  size="small"
                  sx={{
                    p: 0,
                    ml: "1px",
                    width: 7,
                    height: 7,
                    minWidth: 7,
                    minHeight: 7,
                    color: "#ef4444",
                    opacity: 0.6,
                    "&:hover": { opacity: 1, background: "rgba(239,68,68,0.1)" },
                  }}
                  onClick={() => {
                    let newOptions = [...data.options];
                    newOptions.splice(idx, 1);
                    newOptions = newOptions.map((opt, i) => {
                      const match = opt.match(/^(\d+)\.\s?(.*)$/);
                      return match ? `${i + 1}. ${match[2]}`.trim() : `${i + 1}. ${opt}`.trim();
                    });
                    if (typeof setEdges === "function") {
                      setEdges(eds => {
                        let filtered = eds.filter(e => !(e.source === id && e.sourceHandle === `option-${idx}`));
                        return filtered.map(e => {
                          if (e.source === id && e.sourceHandle?.startsWith("option-")) {
                            const optionNum = parseInt(e.sourceHandle.replace("option-", ""));
                            if (optionNum > idx) return { ...e, sourceHandle: `option-${optionNum - 1}` };
                          }
                          return e;
                        });
                      });
                    }
                    if (data.onChange) data.onChange(id, { ...data, options: newOptions });
                  }}
                  title="Eliminar"
                >
                  <DeleteOutlineIcon sx={{ fontSize: 6 }} />
                </IconButton>
                {/* Handle de conexión */}
                <Handle
                  type="source"
                  position={Position.Right}
                  id={`option-${idx}`}
                  isConnectable={isConnectable}
                  style={{
                    top: "50%",
                    right: -6,
                    transform: "translateY(-50%)",
                    background: "#22c55e",
                    border: "1px solid #16a34a",
                    width: 4,
                    height: 4,
                    minWidth: 4,
                    minHeight: 4,
                    position: "absolute",
                    zIndex: 2,
                  }}
                />
              </Box>
            ))}
          </Box>
          {/* Botón agregar - integrado en el footer */}
          <Box sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            py: 0.2,
            background: "rgba(124,58,237,0.08)",
            borderTop: "1px solid rgba(124,58,237,0.1)",
            cursor: (data.options?.length || 0) >= 7 ? "not-allowed" : "pointer",
            transition: "all 0.15s ease",
            "&:hover": {
              background: (data.options?.length || 0) >= 7 ? "rgba(124,58,237,0.08)" : "rgba(124,58,237,0.15)",
            },
          }}
          onClick={() => {
            if ((data.options?.length || 0) < 7) {
              const newOptions = [...(data.options || []), `${(data.options?.length || 0) + 1}.`];
              if (data.onChange) data.onChange(id, { ...data, options: newOptions });
            }
          }}
          >
            <AddCircleOutlineIcon sx={{ fontSize: 7, color: (data.options?.length || 0) >= 7 ? "#cbd5e1" : "#7c3aed", mr: 0.2 }} />
            <Typography sx={{ fontSize: 4.5, color: (data.options?.length || 0) >= 7 ? "#cbd5e1" : "#7c3aed", fontWeight: 600 }}>
              {(data.options?.length || 0) >= 7 ? "Máx 7" : "Agregar"}
            </Typography>
          </Box>
        </Box>
      ) : data.type === "ia" ? (
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            width: 65,
            mx: 0.2,
            py: 0.2,
            background: "#e0f7fa",
            border: "1.5px solid #10b981"
          }}>
          {/* ...IA render igual que antes... */}
        </Box>
      
            ) : data.type === "message" ? (
        <Box sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "stretch",
          width: "100%",
          overflow: "hidden",
          borderRadius: 1.5,
          background: "linear-gradient(180deg, #f59e0b 0%, #d97706 100%)",
          boxShadow: "0 2px 8px rgba(245, 158, 11, 0.25)",
        }}>
          {/* Header compacto */}
          <Box sx={{
            py: 0.3,
            px: 0.4,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: 0.3,
            borderBottom: "1px solid rgba(255,255,255,0.15)",
          }}>
            <ChatIcon sx={{ fontSize: 8, color: "#fff" }} />
            <Typography sx={{
              fontSize: 5,
              color: "#fff",
              fontWeight: 700,
              letterSpacing: 0.3,
            }}>
              MENSAJE
            </Typography>
          </Box>

          {/* Campo de mensaje */}
          <Box sx={{
            px: 0.3,
            py: 0.3,
            background: "rgba(255,255,255,0.95)",
          }}>
            <TextField
              value={data.label || ""}
              onChange={handleLabelChange}
              placeholder="Escribe el mensaje..."
              variant="standard"
              size="small"
              multiline
              maxRows={4}
              inputRef={textFieldRef}
              sx={{
                width: "100%",
                "& .MuiInputBase-root": {
                  fontSize: 5,
                  lineHeight: 1.2,
                  color: "#92400e",
                  fontWeight: 500,
                },
                "& .MuiInputBase-input": {
                  textAlign: "center",
                  padding: 0,
                },
                "& .MuiInputBase-input::placeholder": {
                  color: "#fbbf24",
                  opacity: 0.8,
                },
              }}
              InputProps={{
                disableUnderline: true,
              }}
            />
          </Box>

          {/* Footer con botones de acción */}
          <Box sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            py: 0.2,
            gap: 0.5,
            background: "rgba(255,255,255,0.95)",
            borderTop: "1px solid rgba(245,158,11,0.1)",
            borderRadius: "0 0 6px 6px",
          }}>
            {/* Insertar variable */}
            <Tooltip title="Insertar variable" arrow placement="top">
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 0.2,
                  px: 0.4,
                  py: 0.15,
                  borderRadius: 0.5,
                  cursor: "pointer",
                  transition: "all 0.15s ease",
                  "&:hover": { background: "rgba(99,102,241,0.1)" },
                }}
                onClick={e => setVariableMenuAnchor(e.currentTarget)}
              >
                <DataObjectIcon sx={{ fontSize: 7, color: "#6366f1" }} />
                <Typography sx={{ fontSize: 4, color: "#6366f1", fontWeight: 600 }}>Var</Typography>
              </Box>
            </Tooltip>

            {/* Separador */}
            <Box sx={{ width: "1px", height: 8, background: "rgba(0,0,0,0.1)" }} />

            {/* Mensajes predefinidos */}
            <Tooltip title="Mensajes predefinidos" arrow placement="top">
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 0.2,
                  px: 0.4,
                  py: 0.15,
                  borderRadius: 0.5,
                  cursor: "pointer",
                  transition: "all 0.15s ease",
                  "&:hover": { background: "rgba(251,113,133,0.1)" },
                }}
                onClick={handleMenuOpen}
              >
                <ForumIcon sx={{ fontSize: 7, color: "#f43f5e" }} />
                <Typography sx={{ fontSize: 4, color: "#f43f5e", fontWeight: 600 }}>Predef</Typography>
              </Box>
            </Tooltip>
          </Box>

          {/* Menu de variables */}
          <Menu
            anchorEl={variableMenuAnchor}
            open={Boolean(variableMenuAnchor)}
            onClose={() => setVariableMenuAnchor(null)}
            PaperProps={{
              sx: {
                minWidth: 120,
                maxWidth: 180,
                borderRadius: 2,
                boxShadow: "0 4px 16px rgba(99,102,241,0.15)",
                background: "#fff",
                p: 0.5,
                maxHeight: 250,
                overflowY: 'auto'
              }
            }}
          >
            {variablesList.length === 0 ? (
              <Box sx={{ p: 1, textAlign: 'center', color: '#94a3b8', fontSize: 11 }}>
                No hay variables
              </Box>
            ) : (
              variablesList.map(v => (
                <MenuItem
                  key={v.nombre_variable}
                  onClick={() => handleInsertVariable(v.nombre_variable)}
                  sx={{ fontSize: 11, py: 0.5, borderRadius: 1 }}
                >
                  <DataObjectIcon sx={{ fontSize: 12, mr: 0.5, color: "#6366f1" }} />
                  {v.nombre_variable}
                </MenuItem>
              ))
            )}
          </Menu>
          {/* Menú para seleccionar mensajes predefinidos */}
          <Menu
            anchorEl={menuAnchor}
            open={Boolean(menuAnchor)}
            onClose={handleMenuClose}
            PaperProps={{
              sx: {
                minWidth: 100,
                maxWidth: 150,
                width: 150,
                borderRadius: 2,
                boxShadow: "0 4px 16px rgba(99,102,241,0.10)",
                background: "#f8fafc",
                p: 0.5,
                maxHeight: 300,
                overflowY: 'auto'
              }
            }}
            MenuListProps={{
              sx: { p: 0 }
            }}
          >
           {!flowContextId ? (
            <Box sx={{ 
              p: 1.5,
              display: 'flex', 
              flexDirection: 'column', 
              alignItems: 'center', 
              gap: 0.8
            }}>
              <Box sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 0.5,
                color: '#e11d48',
                fontWeight: 600,
                fontSize: 12,
                mb: 0.3
              }}>
                <InfoIcon sx={{ fontSize: 14 }} />
                Contexto no definido
              </Box>
              <Typography variant="body2" sx={{ 
                color: '#64748b', 
                fontSize: 10,
                textAlign: 'left',
                fontWeight: 400,
                lineHeight: 1.2
              }}>
                Para utilizar mensajes predefinidos, primero debes guardar este flujo y asignarle un contexto.
              </Typography>
              <Button
                variant="outlined"
                size="small"
                sx={{
                  mt: 0.8,
                  fontSize: 9,
                  textTransform: 'none',
                  borderRadius: 1,
                  borderColor: '#e11d48',
                  color: '#e11d48',
                  py: 0.2,
                  px: 0.8,
                  '&:hover': { 
                    borderColor: '#b91c1c',
                    background: '#fee2e2'
                  }
                }}
                onClick={() => {
                  handleMenuClose();
                  if (data.onSaveToDB) {
                    data.onSaveToDB();
                  }
                }}
              >
                Guardar flujo
              </Button>
            </Box>
          ) : loadingMensajes ? (       
            <Box sx={{ p: 2, textAlign: 'center' }}>
              <CircularProgress size={20} sx={{ color: "#6366f1" }} />
            </Box>
          ) : mensajesList.length === 0 ? (
            <Box sx={{ p: 2, textAlign: 'center', color: '#64748b' }}>
              No hay mensajes definidos para el contexto {
                contextOptions.find(opt => opt.id === flowContextId)?.nombre || "actual"
              }
            </Box>
          ) : (
            mensajesList
              .filter(m => m.activo)
              .map((mensaje) => (
                <MenuItem
                  key={mensaje.id}
                  onClick={() => handleSelectMensaje(mensaje.mensaje)}
                  sx={{
                    fontSize: 12,
                    color: "#334155",
                    borderRadius: 1,
                    m: 0.5,
                    px: 1.5,
                    py: 1,
                    transition: "background 0.2s",
                    "&:hover": {
                      background: "#e0e7ef",
                      color: "#6366f1",
                    },
                  }}
                >
                  <Box>
                    <Box sx={{ fontWeight: 600, color: "#6366f1", fontSize: 11 }}>
                      {mensaje.tipo_mensaje?.nombre || "Sin tipo"}
                    </Box>
                    <Box sx={{ fontSize: 12 }}>{mensaje.mensaje}</Box>
                  </Box>
                </MenuItem>
              ))
          )}
          </Menu>
        </Box>
      
      ) : data.type === "end" ? (
        <Box sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "stretch",
          width: "100%",
          overflow: "hidden",
          borderRadius: 1.5,
          background: "linear-gradient(180deg, #ef4444 0%, #dc2626 100%)",
          boxShadow: "0 2px 8px rgba(239, 68, 68, 0.25)",
        }}>
          {/* Header compacto */}
          <Box sx={{
            py: 0.3,
            px: 0.4,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: 0.3,
            borderBottom: "1px solid rgba(255,255,255,0.15)",
          }}>
            <CancelIcon sx={{ fontSize: 8, color: "#fff" }} />
            <Typography sx={{
              fontSize: 5,
              color: "#fff",
              fontWeight: 700,
              letterSpacing: 0.3,
            }}>
              FINALIZAR
            </Typography>
          </Box>

          {/* Campo de mensaje de despedida */}
          <Box sx={{
            px: 0.3,
            py: 0.3,
            background: "rgba(255,255,255,0.95)",
          }}>
            <TextField
              value={data.label || "¡Gracias por contactarnos!"}
              onChange={handleLabelChange}
              placeholder="Mensaje de despedida..."
              variant="standard"
              size="small"
              multiline
              maxRows={3}
              sx={{
                width: "100%",
                "& .MuiInputBase-root": {
                  fontSize: 5,
                  lineHeight: 1.2,
                  color: "#991b1b",
                  fontWeight: 500,
                },
                "& .MuiInputBase-input": {
                  textAlign: "center",
                  padding: 0,
                },
                "& .MuiInputBase-input::placeholder": {
                  color: "#fca5a5",
                  opacity: 0.8,
                },
              }}
              InputProps={{
                disableUnderline: true,
              }}
            />
          </Box>

          {/* Footer indicador */}
          <Box sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            py: 0.2,
            background: "rgba(255,255,255,0.9)",
            borderTop: "1px solid rgba(239,68,68,0.1)",
            borderRadius: "0 0 6px 6px",
            gap: 0.2,
          }}>
            <Box sx={{
              width: 6,
              height: 6,
              borderRadius: "50%",
              background: "#ef4444",
              boxShadow: "0 0 4px rgba(239,68,68,0.5)",
            }} />
            <Typography sx={{ fontSize: 4, color: "#991b1b", fontWeight: 600 }}>
              Fin del flujo
            </Typography>
          </Box>
        </Box>
      
      ) : data.type === "menu" ? (
        <Box sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "stretch",
          width: "100%",
          overflow: "hidden",
          borderRadius: 1.5,
          background: "linear-gradient(180deg, #8b5cf6 0%, #7c3aed 100%)",
          boxShadow: "0 2px 8px rgba(139, 92, 246, 0.25)",
        }}>
          {/* Header compacto */}
          <Box sx={{
            py: 0.3,
            px: 0.4,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: 0.3,
            borderBottom: "1px solid rgba(255,255,255,0.15)",
          }}>
            <MenuBookIcon sx={{ fontSize: 8, color: "#fff" }} />
            <Typography sx={{
              fontSize: 5,
              color: "#fff",
              fontWeight: 700,
              letterSpacing: 0.3,
            }}>
              MENÚ
            </Typography>
          </Box>

          {/* Campo de pregunta */}
          <Box sx={{
            px: 0.3,
            py: 0.25,
            background: "rgba(255,255,255,0.95)",
          }}>
            <TextField
              value={data.label || "¿Qué te gustaría hacer?"}
              onChange={handleLabelChange}
              placeholder="Pregunta del menú..."
              variant="standard"
              size="small"
              multiline
              maxRows={2}
              sx={{
                width: "100%",
                "& .MuiInputBase-root": {
                  fontSize: 5,
                  lineHeight: 1.2,
                  color: "#6d28d9",
                  fontWeight: 500,
                },
                "& .MuiInputBase-input": {
                  textAlign: "center",
                  padding: 0,
                },
                "& .MuiInputBase-input::placeholder": {
                  color: "#a78bfa",
                  opacity: 0.8,
                },
              }}
              InputProps={{
                disableUnderline: true,
              }}
            />
          </Box>

          {/* Lista de opciones */}
          <Box sx={{
            display: "flex",
            flexDirection: "column",
            gap: "2px",
            p: 0.3,
            background: "rgba(255,255,255,0.9)",
          }}>
            {(data.options || ["1. Volver al inicio", "2. Terminar conversación"]).map((opt, idx) => (
              <Box
                key={idx}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  position: "relative",
                  width: "100%",
                }}
              >
                {editingOptionIdx === idx ? (
                  <TextField
                    autoFocus
                    value={opt.replace(/^\d+\.\s?/, "")}
                    onChange={e => {
                      const newOptions = [...(data.options || ["1. Volver al inicio", "2. Terminar conversación"])];
                      newOptions[idx] = `${idx + 1}. ${e.target.value}`;
                      if (data.onChange) data.onChange(id, { ...data, options: newOptions });
                    }}
                    onBlur={() => setEditingOptionIdx(null)}
                    onKeyDown={e => { if (e.key === "Enter") setEditingOptionIdx(null); }}
                    placeholder="opción"
                    variant="standard"
                    size="small"
                    sx={{
                      flex: 1,
                      "& .MuiInputBase-root": {
                        fontSize: 5,
                        background: optionColors[idx % optionColors.length],
                        borderRadius: 0.5,
                        px: 0.3,
                        py: 0.1,
                      },
                      "& .MuiInputBase-input": {
                        color: "#fff",
                        fontWeight: 500,
                        textAlign: "center",
                        padding: 0,
                      },
                    }}
                    InputProps={{
                      disableUnderline: true,
                    }}
                  />
                ) : (
                  <Box
                    onDoubleClick={() => setEditingOptionIdx(idx)}
                    sx={{
                      flex: 1,
                      display: "flex",
                      alignItems: "center",
                      gap: 0.3,
                      px: 0.3,
                      py: 0.15,
                      background: optionColors[idx % optionColors.length],
                      borderRadius: 0.5,
                      cursor: "pointer",
                      transition: "all 0.15s ease",
                      "&:hover": {
                        filter: "brightness(1.1)",
                        transform: "scale(1.02)",
                      },
                    }}
                  >
                    <Box sx={{
                      width: 8,
                      height: 8,
                      borderRadius: "50%",
                      background: "rgba(255,255,255,0.3)",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      flexShrink: 0,
                    }}>
                      <Typography sx={{ fontSize: 4, color: "#fff", fontWeight: 700 }}>
                        {idx + 1}
                      </Typography>
                    </Box>
                    <Typography sx={{
                      fontSize: 5,
                      color: "#fff",
                      fontWeight: 500,
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                      flex: 1,
                    }}>
                      {opt.replace(/^\d+\.\s?/, "")}
                    </Typography>
                  </Box>
                )}

                <Handle
                  type="source"
                  position={Position.Right}
                  id={`option-${idx}`}
                  isConnectable={isConnectable}
                  style={{
                    top: "50%",
                    right: -3,
                    transform: "translateY(-50%)",
                    background: "#22c55e",
                    border: "1.2px solid #16a34a",
                    width: 4,
                    height: 4,
                    position: "absolute",
                    zIndex: 2,
                  }}
                />
              </Box>
            ))}
          </Box>

          {/* Footer: Agregar opción */}
          <Box sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            py: 0.2,
            background: "rgba(255,255,255,0.95)",
            borderTop: "1px solid rgba(139,92,246,0.1)",
            borderRadius: "0 0 6px 6px",
          }}>
            <Button
              variant="text"
              size="small"
              sx={{
                fontSize: 4,
                color: "#8b5cf6",
                p: 0,
                minWidth: 0,
                textTransform: "none",
                fontWeight: 600,
                "&:hover": {
                  background: "transparent",
                  color: "#6d28d9",
                },
              }}
              disabled={(data.options?.length || 2) >= 5}
              onClick={() => {
                if ((data.options?.length || 2) < 5) {
                  const currentOptions = data.options || ["1. Volver al inicio", "2. Terminar conversación"];
                  const newOptions = [...currentOptions, `${currentOptions.length + 1}. Nueva opción`];
                  if (data.onChange) data.onChange(id, { ...data, options: newOptions });
                }
              }}
            >
              + Agregar
            </Button>
          </Box>
        </Box>
              
      ) : null}

      {/* Popover para mostrar variable asociada */}
      <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "center",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "center",
          horizontal: "left",
        }}
        PaperProps={{
          sx: {
            p: 1,
            minWidth: 180,
            boxShadow: 2,
            borderRadius: 1,
            background: "#fff",
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
          }
        }}
      >
        <Box sx={{ fontSize: 11, mb: 1, color: "#10b981", fontWeight: 700 }}>
          Variable asociada a la pregunta:
        </Box>
        <Box sx={{ fontSize: 13, color: "#6366f1", fontWeight: 700 }}>
          {data.variable ? data.variable : "Sin variable asociada"}
        </Box>
        <Button
          variant="text"
          size="small"
          onClick={handleClose}
          sx={{
            color: "#e11d48",
            fontWeight: 700,
            fontSize: 12,
            mt: 1,
            alignSelf: "flex-end",
            textTransform: "none",
            minWidth: 0,
            px: 1,
            py: 0.5,
            '&:hover': {
              background: "#fee2e2",
              color: "#b91c1c"
            }
          }}
        >
          Cerrar
        </Button>
      </Popover>
      
      


            {/* Handle derecho */}
      {data.type !== "options" && data.type !== "verificar_cliente" && (
        <Handle
          type="source"
          position={Position.Right}
          isConnectable={isConnectable}
          style={{
            background: "#22c55e",
            border: "1.2px solid #16a34a",
            width: 4,
            height: 4,
            minWidth: 4,
            minHeight: 4,
          }}
        />
      )}
      {/* Barra de acciones del nodo - UX mejorada */}
      {id !== "1" && (
        <Box
          sx={{
            mt: 0.2,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            width: "100%",
            gap: 0.3,
            py: 0.15,
            borderTop: "1px solid rgba(0,0,0,0.04)",
            background: "rgba(0,0,0,0.02)",
            borderRadius: "0 0 6px 6px",
          }}
        >
          {/* Variable de contexto */}
          <Tooltip title="Variable guardada" arrow placement="top">
            <IconButton
              size="small"
              sx={{
                color: "#6366f1",
                background: "transparent",
                borderRadius: 0.5,
                p: 0.15,
                width: 11,
                height: 11,
                minWidth: 11,
                minHeight: 11,
                transition: "all 0.15s ease",
                "&:hover": {
                  background: "#eef2ff",
                  transform: "scale(1.1)",
                },
              }}
              onClick={e => {
                e.stopPropagation();
                setAnchorEl(e.currentTarget);
              }}
            >
              <DataObjectIcon sx={{ fontSize: 7 }} />
            </IconButton>
          </Tooltip>

          {/* Separador visual */}
          <Box sx={{ width: "1px", height: 6, background: "rgba(0,0,0,0.08)" }} />

          {/* Eliminar nodo */}
          <Tooltip title="Eliminar nodo" arrow placement="top">
            <IconButton
              size="small"
              sx={{
                color: "#94a3b8",
                background: "transparent",
                borderRadius: 0.5,
                p: 0.15,
                width: 11,
                height: 11,
                minWidth: 11,
                minHeight: 11,
                transition: "all 0.15s ease",
                "&:hover": {
                  color: "#ef4444",
                  background: "#fef2f2",
                  transform: "scale(1.1)",
                },
              }}
              onClick={() => data.onDelete && data.onDelete(id)}
            >
              <DeleteOutlineIcon sx={{ fontSize: 7 }} />
            </IconButton>
          </Tooltip>
        </Box>
      )}
    </Box>
  );
}

/*
function getInitialNodes() {
  return [
    {
      id: "1",
      type: "custom",
      position: { x: 20, y: 20 },
      data: { type: "message", label: "Inicio de conversación", onChange: () => {}, onDelete: () => {} },
    },
  ];
}

function getInitialEdges() {
  return [];
}
*/  

function getInitialNodes() {
  return [
    {
      id: "1",
      type: "custom",
      position: { x: 20, y: 20 },
      data: { 
        type: "message", 
        label: "Inicio de conversación", 
        onChange: () => {}, 
        onDelete: () => {} 
      },
    },
    {
      id: "2",
      type: "custom",
      position: { x: 220, y: 20 },
      data: { 
        type: "input_ia", 
        label: "Por favor, cuéntame:\n• ¿Cuál es tu nombre y apellido?\n• ¿Cuál es tu correo electrónico?\n• ¿Cuál es tu dirección?\n• ¿Un número de teléfono adicional donde poder contactarte?",
        variables: ["nombre_completo", "correo", "direccion", "telefono_adicional"],
        fieldsToExtract: [
          { name: "nombre_completo", type: "texto", description: "Nombre y apellido del usuario" },
          { name: "correo", type: "email", description: "Correo electrónico" },
          { name: "direccion", type: "texto", description: "Dirección completa" },
          { name: "telefono_adicional", type: "telefono", description: "Número de teléfono adicional" }
        ],
        onChange: () => {}, 
        onDelete: () => {} 
      },
    },
  ];
}

function getInitialEdges() {
  return [
    {
      id: "1-2",
      source: "1",
      target: "2",
      type: "custom",
      markerEnd: {
        type: "arrowclosed",
        color: "#22c55e",
        width: 9,
        height: 9,
      },
      style: { 
        stroke: "#22c55e", 
        strokeWidth: 1.0,
        filter: "drop-shadow(0 1px 2px rgba(99, 102, 241, 0.3))"
      },
      animated: false
    },
  ];
}

const initialNodes = getInitialNodes();

const initialEdges = getInitialEdges();



const simulatedAnswers = {
  nombre: "Juan Pérez",
  correo: "juan.perez@email.com",
  empresa: "Acme Corp",
  telefono: "+57 300 123 4567",
  pais: "Colombia",
  ciudad: "Bogotá",
  edad: "32",
  cargo: "Gerente de proyectos",
  producto_interes: "Chatbot empresarial",
  comentario: "No, muchas gracias.",
  documento: "123456789",
  fecha_nacimiento: "01/01/1990",
  direccion: "Calle 123 #45-67",
  usuario_redes: "@juanperez",
  presupuesto: "$5.000.000",
  horario_contacto: "Mañana",
  referencia: "Google",
};

function getSimulatedAnswer(n) {
  // Si es pregunta con opciones, retorna una opción aleatoria
  if (n.data.type === "options" && Array.isArray(n.data.options) && n.data.options.length > 0) {
    const idx = Math.floor(Math.random() * n.data.options.length);
    return n.data.options[idx];
  }
  // Si hay variable, usa la respuesta simulada
  if (n.data.variable && simulatedAnswers[n.data.variable]) {
    return simulatedAnswers[n.data.variable];
  }
  // Si la pregunta contiene ciertas palabras, responde acorde
  const l = (n.data.label || "").toLowerCase();
  if (l.includes("nombre")) return simulatedAnswers.nombre;
  if (l.includes("correo")) return simulatedAnswers.correo;
  if (l.includes("empresa")) return simulatedAnswers.empresa;
  if (l.includes("teléfono") || l.includes("telefono")) return simulatedAnswers.telefono;
  if (l.includes("ciudad")) return simulatedAnswers.ciudad;
  if (l.includes("país") || l.includes("pais")) return simulatedAnswers.pais;
  if (l.includes("edad")) return simulatedAnswers.edad;
  if (l.includes("cargo")) return simulatedAnswers.cargo;
  if (l.includes("documento")) return simulatedAnswers.documento;
  if (l.includes("fecha")) return simulatedAnswers.fecha_nacimiento;
  if (l.includes("dirección") || l.includes("direccion")) return simulatedAnswers.direccion;
  if (l.includes("usuario")) return simulatedAnswers.usuario_redes;
  if (l.includes("presupuesto")) return simulatedAnswers.presupuesto;
  if (l.includes("horario")) return simulatedAnswers.horario_contacto;
  if (l.includes("referencia")) return simulatedAnswers.referencia;
  if (l.includes("comentario")) return simulatedAnswers.comentario;
  // Por defecto
  return "Respuesta del usuario";
}

function getQuestionEmoji(label = "") {
  const l = label.toLowerCase();
  if (l.includes("nombre")) return "👩‍🦰👨‍🦱";
  if (l.includes("correo") || l.includes("email")) return "✉️";
  if (l.includes("empresa")) return "🏢";
  if (l.includes("teléfono") || l.includes("telefono")) return "📱";
  if (l.includes("país") || l.includes("pais")) return "🌎";
  if (l.includes("ciudad")) return "🏙️";
  if (l.includes("edad")) return "🎂";
  if (l.includes("cargo")) return "💼";
  if (l.includes("documento")) return "🪪";
  if (l.includes("fecha")) return "📅";
  if (l.includes("dirección") || l.includes("direccion")) return "🏠";
  if (l.includes("usuario")) return "🧑‍💻";
  if (l.includes("presupuesto")) return "💰";
  if (l.includes("horario")) return "⏰";
  if (l.includes("referencia")) return "🔗";
  if (l.includes("comentario")) return "💬";
  return "❓";
}



// Aquí coloca la función sugerida:
function suggestVariableFromQuestion(question, variablesList) {
  const lower = question.toLowerCase();
  for (const v of variablesList) {
    if (lower.includes(v.nombre_variable)) return v.nombre_variable;
  }
  if (lower.includes("nombre")) return "nombre";
  if (lower.includes("correo")) return "correo";
  if (lower.includes("empresa")) return "empresa";
  if (lower.includes("teléfono") || lower.includes("telefono")) return "telefono";
  return "";
}

// Agrega esta transición arriba de tu componente
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function Constructor() {
  // Hook para detectar tamaño de pantalla - pantallas medianas (<1920px)
  const isMediumScreen = useMediaQuery('(max-width: 1919px)');

  // --- Drag & Drop Node Type Menu ---
    const nodeTypeMenu = [
    { type: "open", label: "Pregunta Abierta", emoji: "❓" },
    { type: "options", label: "Pregunta con opciones", emoji: "🗂️" },
    { type: "message", label: "Mensaje", emoji: "💬" },
    { type: "input_ia", label: "Nodo IA", emoji: "📝" },
    { type: "verificar_cliente", label: "Verificar Cliente WhatsApp", emoji: "🔍" },
    { type: "image_input", label: "Captura de Imagen", emoji: "📷" },
    { type: "image_analysis", label: "Análisis de Imagen Médica", emoji: "🔬" },
    { type: "end", label: "Finalizar conversación", emoji: "🏁" },
    { type: "agendar_cita", label: "Agendar cita", emoji: "📅" },
    { type: "verificar_datos", label: "Verificar datos del cliente", emoji: "✅" },
    { type: "escalacion_humano", label: "Escalación a humano", emoji: "👨‍💼" },
  ];
   
  const [changelogOpen, setChangelogOpen] = useState(false);

  const handleOpenChangelogDialog = () => setChangelogOpen(true);
  const handleCloseChangelogDialog = () => setChangelogOpen(false);
  // Estado para la posición del menú
  // El menú aparecerá por defecto pegado al lado derecho, antes del simulador de celular
  // Calcula la posición inicial en el primer render
  const getInitialMenuPos = () => {
    // Offset desde el borde derecho (ajusta para mover más a la izquierda)
    const offsetRight = 550; // antes 420, ahora más a la izquierda
    const x = typeof window !== 'undefined' ? window.innerWidth - offsetRight : 0;
    return { x, y: 180 }; // antes 120, ahora más abajo
  };
  const [menuPos, setMenuPos] = React.useState(getInitialMenuPos);
  const [draggingMenu, setDraggingMenu] = React.useState(false);
  const [dragOffset, setDragOffset] = React.useState({ x: 0, y: 0 });

  // Estado para el panel de emojis
  const [showEmojiPanel, setShowEmojiPanel] = React.useState(false);
  const [emojiCopied, setEmojiCopied] = React.useState(null);

  // Emojis organizados por categorías
  const emojiCategories = [
    { name: "Saludos", emojis: ["👋", "🙋", "👍", "👎", "🤝", "🙏", "👏", "🎉", "✨"] },
    { name: "Caras", emojis: ["😊", "😃", "🙂", "😉", "🤗", "😍", "😌", "😔", "🤔", "😅", "😷", "🤒"] },
    { name: "Médico", emojis: ["🏥", "👨‍⚕️", "👩‍⚕️", "🩺", "💊", "💉", "🩹", "🦷", "❤️", "🫀", "🧠", "📋"] },
    { name: "Tiempo", emojis: ["📅", "🗓️", "⏰", "🕐", "📆", "⌛", "🔔"] },
    { name: "Chat", emojis: ["💬", "📝", "📞", "📱", "✉️", "✅", "❌", "⚠️", "❗", "❓", "💡"] },
    { name: "Números", emojis: ["1️⃣", "2️⃣", "3️⃣", "4️⃣", "5️⃣", "6️⃣", "7️⃣", "8️⃣", "9️⃣", "🔟"] },
    { name: "Flechas", emojis: ["➡️", "⬅️", "⬆️", "⬇️", "↗️", "↘️", "🔄", "🔙", "🔜"] },
    { name: "Símbolos", emojis: ["⭐", "🌟", "💫", "🔥", "💯", "✔️", "🔴", "🟢", "🟡", "🔵", "🏁"] },
  ];

  const handleCopyEmoji = (emoji) => {
    navigator.clipboard.writeText(emoji);
    setEmojiCopied(emoji);
    setTimeout(() => setEmojiCopied(null), 1500);
  };

  const [contextPopoverAnchor, setContextPopoverAnchor] = useState(null);
  const [selectedPreguntaContextos, setSelectedPreguntaContextos] = useState([]);

  const [userName, setUserName] = useState("");
  const [user, setUser] = useState(auth.currentUser);
  const [firebasePhotoURL, setFirebasePhotoURL] = useState(auth.currentUser?.photoURL || "");
  
  const handleContextIconClick = (event, preguntaId) => {
  event.stopPropagation();
  const contextosIds = preguntaContextos.filter(rel => rel.pregunta_id === preguntaId).map(rel => rel.contexto_id);
  const contextosAsociados = contextOptions.filter(opt => contextosIds.includes(opt.id));
  setSelectedPreguntaContextos(contextosAsociados);
  setContextPopoverAnchor(event.currentTarget);
};
  
  //const renderMensaje = (texto) => texto.replace("{nombre}", userName || "");
  // Handlers para arrastrar el menú
  const handleMenuMouseDown = (e) => {
    setDraggingMenu(true);
    setDragOffset({ x: e.clientX - menuPos.x, y: e.clientY - menuPos.y });
  };
  React.useEffect(() => {
    if (!draggingMenu) return;
    const handleMouseMove = (e) => {
      setMenuPos({ x: e.clientX - dragOffset.x, y: e.clientY - dragOffset.y });
    };
    const handleMouseUp = () => setDraggingMenu(false);
    window.addEventListener("mousemove", handleMouseMove);
    window.addEventListener("mouseup", handleMouseUp);
    return () => {
      window.removeEventListener("mousemove", handleMouseMove);
      window.removeEventListener("mouseup", handleMouseUp);
    };
  }, [draggingMenu, dragOffset]);

  // Handler para drop sobre el canvas
  const onDropNodeType = (event) => {
    event.preventDefault();
    const type = event.dataTransfer.getData("application/nodetype");
    if (!type || !reactFlowInstance) return;
  
    const bounds = event.target.getBoundingClientRect();
    const position = reactFlowInstance.project({
      x: event.clientX - bounds.left,
      y: event.clientY - bounds.top,
    });
  
    // Genera un id único
   const id = `n${Date.now()}_${nodeIdCounter++}`;
  
    // Define los datos según el tipo
    let defaultLabel = "";
    let options = undefined;
    if (type === "options") {
      defaultLabel = "Seleccione una opción:";
      options = [];
    } else if (type === "open") {
      defaultLabel = "Nueva pregunta";
    } else if (type === "message") {
      defaultLabel = "Mensaje";
    } else if (type === "input_ia") {
      defaultLabel = "Escribe la pregunta o instrucción…";
    }
  
    setNodes(nds => [
      ...nds,
      {
        id,
        type: "custom",
        position,
        data: {
          type,
          label: defaultLabel,
          variable: "",
          options,
          onChange: handleNodeDataChange,
          onDelete: handleDeleteNode,
        },
      },
    ]);
  };

  // Handler para permitir drop
  const onDragOverNodeType = (event) => {
    event.preventDefault();
    event.dataTransfer.dropEffect = "copy";
  };
  // Estado para el diálogo de eliminación de pregunta
  const [preguntaToDelete, setPreguntaToDelete] = useState(null);
  const navigate = useNavigate();

  const INACTIVITY_LIMIT = 30 * 60 * 1000; // 30 minutos
  const inactivityTimer = useRef();

  useEffect(() => {
    const resetTimer = () => {
      clearTimeout(inactivityTimer.current);
      inactivityTimer.current = setTimeout(() => {
        // Cierra sesión Firebase y limpia usuario tradicional
        auth.signOut();
        localStorage.removeItem("user_id");
        window.location.href = "/login";
      }, INACTIVITY_LIMIT);
    };

    // Eventos que reinician el temporizador
    const events = ["mousemove", "keydown", "click", "scroll", "touchstart"];
    events.forEach(ev => window.addEventListener(ev, resetTimer));

    resetTimer(); // inicializa

    return () => {
      clearTimeout(inactivityTimer.current);
      events.forEach(ev => window.removeEventListener(ev, resetTimer));
    };
  }, [INACTIVITY_LIMIT]);

      const CONTEXT_OPTIONS = [
      { value: "medicina", label: "Medicina" },
      { value: "legal", label: "Legal" },
      { value: "inmobiliaria", label: "Inmobiliaria" },
      { value: "estética", label: "Estética" },
      { value: "educación", label: "Educación" },
      { value: "turismo", label: "Turismo" },
      { value: "restaurante", label: "Restaurante" },
      { value: "comercio", label: "Comercio" },
      { value: "soporte_técnico", label: "Soporte Técnico" },
      { value: "recursos_humanos", label: "Recursos Humanos" },
      { value: "finanzas", label: "Finanzas" },
      { value: "seguros", label: "Seguros" },
      { value: "automotriz", label: "Automotriz" },
      { value: "eventos", label: "Eventos" },
      { value: "logística", label: "Logística" },
      { value: "deporte", label: "Deporte" },
      { value: "entretenimiento", label: "Entretenimiento" },
      { value: "bienestar", label: "Bienestar" },
      { value: "gobierno", label: "Gobierno" },
      { value: "tecnología", label: "Tecnología" },
      { value: "marketing", label: "Marketing" },
      { value: "ventas", label: "Ventas" },
      { value: "alimentación", label: "Alimentación" },
      { value: "moda", label: "Moda" },
      { value: "transporte", label: "Transporte" },
      { value: "agricultura", label: "Agricultura" },
      { value: "energía", label: "Energía" },
      { value: "mascotas", label: "Mascotas" },
      { value: "construcción", label: "Construcción" },
      { value: "seguridad", label: "Seguridad" },
      { value: "telecomunicaciones", label: "Telecomunicaciones" },
      { value: "banca", label: "Banca" },
      { value: "educación_online", label: "Educación Online" },
      { value: "viajes", label: "Viajes" },
      { value: "cultura", label: "Cultura" },
      { value: "voluntariado", label: "Voluntariado" },
      { value: "arte", label: "Arte" },
      { value: "ciencia", label: "Ciencia" },
    ];  
  
  const [flowContext, setFlowContext] = useState(CONTEXT_OPTIONS[0].value);

  // Define los tipos de edge
  const edgeTypes = useMemo(() => ({
    custom: CustomEdge,
  }), []);

  useEffect(() => {
    const userId = localStorage.getItem("user_id");
    // Si no hay usuario de Firebase y tampoco user_id en localStorage, redirige
    console.log("Constructor useEffect: user_id en localStorage:", userId, "auth.currentUser:", auth.currentUser);
    if (!auth.currentUser && !userId) {
      console.log("Redirigiendo a /login desde Constructor");
      navigate("/login");
    }
  }, [navigate]);

  useEffect(() => {
  // Si no hay usuario de Firebase, intenta cargar usuario tradicional
  if (!auth.currentUser && localStorage.getItem("user_id")) {
    const fetchUser = async () => {
      const userId = localStorage.getItem("user_id");
      const res = await fetch(`/api/users/${userId}`);
      const data = await res.json();
      setUser(data); // setUser es tu estado de usuario
    };
    fetchUser();
  }
}, []);
  // 1. Estados
const [nodes, setNodes, onNodesChange] = useNodesState(initialNodes);
const [edges, setEdges, onEdgesChange] = useEdgesState(initialEdges);
const [undoStack, setUndoStack] = useState([]);
const [redoStack, setRedoStack] = useState([]);
const [lastIaTokens, setLastIaTokens] = useState(null); // <-- aquí<<<<

const [mensajesMenuAnchor, setMensajesMenuAnchor] = useState(null);
const [openTiposMensajeDialog, setOpenTiposMensajeDialog] = useState(false);
const [tiposMensaje, setTiposMensaje] = useState([]);
const [selectedTipoMensaje, setSelectedTipoMensaje] = useState(null);
const [tipoMensajeToDelete, setTipoMensajeToDelete] = useState(null);
const [newTipoMensaje, setNewTipoMensaje] = useState({ nombre: "", descripcion: "" });
const [showTipoMensajeForm, setShowTipoMensajeForm] = useState(false);

// Añade estas nuevas variables de estado aquí
const [openMensajesDialog, setOpenMensajesDialog] = useState(false);
const [mensajes, setMensajes] = useState([]);
const [loadingMensajes, setLoadingMensajes] = useState(false);
const [selectedMensaje, setSelectedMensaje] = useState(null);
const [showMensajeForm, setShowMensajeForm] = useState(false);
const [mensajeToDelete, setMensajeToDelete] = useState(null);
const [newMensaje, setNewMensaje] = useState({
  id_contexto: "",
  id_tipo_mensaje: "",
  mensaje: "",
  activo: true
});

// Estado para abrir y cerrar el diálogo de preguntas predefinidas
const [openPreguntasDialog, setOpenPreguntasDialog] = useState(false);

//  Estados para preguntas predefinidas y carga
const [predefinedQuestions, setPredefinedQuestions] = useState([]);
const [preguntaContextos, setPreguntaContextos] = useState([]); // relaciones pregunta-contexto
const [loadingQuestions, setLoadingQuestions] = useState(false);

 const [usedVariablesList, setUsedVariablesList] = useState([]);

  // 2. Efecto para actualizar la lista cuando cambian los nodos o las preguntas
  useEffect(() => {
    const variablesEnFlujo = nodes
      .filter(n => n.data && n.data.variable)
      .map(n => n.data.variable)
      .filter(Boolean);

    const filtered = predefinedQuestions
      .filter(q => q.activa && q.variable && variablesEnFlujo.includes(q.variable))
      .map(q => ({
        nombre_variable: q.variable,
        tipo_dato: q.tipo_dato,
        descripcion: q.pregunta
      }));

    setUsedVariablesList(filtered);
  }, [nodes, predefinedQuestions]);

useEffect(() => {
  console.log("Render tokens (useEffect)", lastIaTokens);
}, [lastIaTokens]);

// Coloca el useEffect aquí:
useEffect(() => {
  console.log("usedVariablesList actualizado", usedVariablesList);
}, [usedVariablesList]);

const [preguntaVariables, setPreguntaVariables] = useState([]);

useEffect(() => {
  if (openPreguntasDialog) {
    fetch("/api/variable/")
      .then(res => res.json())
      .then(setPreguntaVariables);
  }
}, [openPreguntasDialog]);

const [flowContextId, setFlowContextId] = useState(null);
// Filtrar preguntas predefinidas según el contexto seleccionado
const filteredPredefinedQuestions = React.useMemo(() => {
  if (!flowContextId) return [];
  const preguntaIds = preguntaContextos
    .filter(rel => rel.contexto_id === flowContextId)
    .map(rel => rel.pregunta_id);
  return predefinedQuestions
    .filter(q => preguntaIds.includes(q.id))
    .sort((a, b) => a.id - b.id);
}, [flowContextId, preguntaContextos, predefinedQuestions]);

// Filtra variables de preguntas predefinidas activas y del contexto actual
const filteredVariablesList = useMemo(() => {
  return predefinedQuestions
    .filter(q => q.activa && q.variable)
    .map(q => ({
      nombre_variable: q.variable,
      tipo_dato: q.tipo_dato,
      descripcion: q.pregunta
    }));
}, [predefinedQuestions]);

const [showOnlyActive, setShowOnlyActive] = useState(true);

// <-- AQUÍ PEGA EL FRAGMENTO:
const [showPreguntaForm, setShowPreguntaForm] = useState(false);
const [editingPregunta, setEditingPregunta] = useState(null);
const [preguntaForm, setPreguntaForm] = useState({
  pregunta: "",
  variable: "",
  tipo_dato: "texto",
  activa: true
});


const [userVariables, setUserVariables] = useState({});

function renderMensaje(texto) {
  return texto.replace(/\{(\w+)\}/g, (_, variable) => userVariables[variable] || "");
}

// Estado para contextos seleccionados al crear/editar pregunta predefinida
const [selectedContextIds, setSelectedContextIds] = useState([]);

const fetchPreguntas = useCallback(() => {
  setLoadingQuestions(true);
  let url = "/api/preguntas_predefinidas/";
  if (showOnlyActive === true) url += "?activa=true";
  else if (showOnlyActive === false) url += "?activa=false";
  Promise.all([
    fetch(url).then(res => res.json()),
    fetch("/api/pregunta_contexto/").then(res => res.json())
  ])
    .then(([preguntas, relaciones]) => {
      setPredefinedQuestions(preguntas);
      setPreguntaContextos(relaciones);
    })
    .finally(() => setLoadingQuestions(false));
}, [showOnlyActive]);


useEffect(() => {
  if (flowContextId) {
    fetchPreguntas();
  }
}, [flowContextId, fetchPreguntas]);
// ...eliminado: Estado para coincidencia semántica...

// Guardar (crear o editar)
const handleSavePregunta = async (forzar = false, payloadOverride = null) => {
  // Validación para el campo variable
  const variableRegex = /^[a-z_][a-z0-9_]*$/;
  const sinAcentos = (str) => !/[áéíóúÁÉÍÓÚàèìòùÀÈÌÒÙäëïöüÄËÏÖÜñÑ]/.test(str);
  if (!variableRegex.test(preguntaForm.variable) || !sinAcentos(preguntaForm.variable)) {
    alert("El nombre de la variable debe estar en minúsculas, sin espacios, sin acentos, no puede empezar por número ni contener mayúsculas.");
    return;
  }

  const url = editingPregunta
    ? `/api/preguntas_predefinidas/${editingPregunta.id}`
    : "/api/preguntas_predefinidas/";
  const method = editingPregunta ? "PUT" : "POST";
  const userId = user?.id || localStorage.getItem("user_id");

  // Incluye contextos en el payload
  const payload = payloadOverride || { ...preguntaForm, contextos: selectedContextIds };

  const res = await fetch(url, {
    method,
    headers: {
      "Content-Type": "application/json",
      "X-User-Id": String(userId)
    },
    body: JSON.stringify(payload)
  });

  if (res.ok) {
    setLoadingQuestions(true);
    fetchPreguntas();
    setShowPreguntaForm(false);
    setEditingPregunta(null);
    setPreguntaForm({ pregunta: "", variable: "", tipo_dato: "texto", activa: true });
    setSelectedContextIds([]);
  } else {
    let error = { detail: "Error al guardar la pregunta" };
    let errorText = "";
    try {
      error = await res.json();
    } catch {
      try {
        errorText = await res.text();
        error = JSON.parse(errorText);
      } catch {
        error = { detail: errorText || "Error al guardar la pregunta" };
      }
    }
    alert((error && error.detail) || "Error al guardar la pregunta");
  }
};
// ...existing code...

// Al final del return principal del componente:
// ...dentro del JSX...
// ...eliminado: Dialogo de similitud semántica...

// Eliminar
const handleDeletePregunta = (pregunta) => {
  setPreguntaToDelete(pregunta);
};

const confirmDeletePregunta = async () => {
  if (!preguntaToDelete) return;
  const userId = user?.id || localStorage.getItem("user_id");
  const res = await fetch(`/api/preguntas_predefinidas/${preguntaToDelete.id}`, {
    method: "DELETE",
    headers: {
      "X-User-Id": String(userId)
    }
  });
  if (res.ok) {
    setLoadingQuestions(true);
    fetch(`/api/preguntas_predefinidas/`)
      .then(res => res.json())
      .then(data => setPredefinedQuestions(data))
      .finally(() => setLoadingQuestions(false));
    setPreguntaToDelete(null);
  } else {
    const error = await res.json();
    alert(error.detail || "Error al eliminar la pregunta");
    setPreguntaToDelete(null);
  }
};

const cancelDeletePregunta = () => {
  setPreguntaToDelete(null);
};

  // useEffect para cargar preguntas predefinidas al cambiar el contexto
    useEffect(() => {
    if (!flowContext) return;
    fetchPreguntas();
  }, [flowContext, fetchPreguntas]);

  const [openNewDialog, setOpenNewDialog] = useState(false);
  const [reactFlowInstance, setReactFlowInstance] = useState(null);
  const [openHelp, setOpenHelp] = useState(false);
  const [anchorUserMenu, setAnchorUserMenu] = useState(null);
  const [adminMenuAnchor, setAdminMenuAnchor] = useState(null);
  const [appsMenuAnchor, setAppsMenuAnchor] = useState(null);
  const [toolsMenuAnchor, setToolsMenuAnchor] = useState(null);
  const [openStatsDialog, setOpenStatsDialog] = useState(false);
  const [openShortcutsDialog, setOpenShortcutsDialog] = useState(false);
  const [flowValidationResults, setFlowValidationResults] = useState(null);
  const [toolsSnackbar, setToolsSnackbar] = useState({ open: false, message: "", severity: "info" });

  const [openFlowDialog, setOpenFlowDialog] = useState(false);
  const [flowName, setFlowName] = useState("");
  const [flowDescription, setFlowDescription] = useState("");
  const [flowWhatsappNumber, setFlowWhatsappNumber] = useState("");  // Número de WhatsApp/Twilio asociado

  const [showChangelogPopover, setShowChangelogPopover] = useState(() => {
  // Solo lo muestra si el usuario no lo ha cerrado antes
  return !localStorage.getItem("changelog_seen_1.0.0-alpha.1");
  });

  const [openFlowSavedDialog, setOpenFlowSavedDialog] = useState(false);
  // Estados
  const [openLoadDialog, setOpenLoadDialog] = useState(false);
  const [availableFlows, setAvailableFlows] = useState([]);
  const [flowToDelete, setFlowToDelete] = useState(null);
  // Estados para Super Admin (acceso a todos los flujos)
  const [isSuperAdmin, setIsSuperAdmin] = useState(false);
  const [empresas, setEmpresas] = useState([]);
  const [selectedEmpresaFilter, setSelectedEmpresaFilter] = useState(null);
  const [openTemplateDialog, setOpenTemplateDialog] = useState(false);
  const [publicTemplates, setPublicTemplates] = useState([]); // <-- aquí
  const [openPublishError, setOpenPublishError] = useState(false); // <-- aquí

  const [publishErrorMsg, setPublishErrorMsg] = useState(""); // <-- AGREGA AQUÍ
  // Estado para el diálogo de conexión IA
  const [openIaConnectDialog, setOpenIaConnectDialog] = useState(false);

  // 1. Estado para el ID del flujo actual
  const [currentFlowId, setCurrentFlowId] = useState(null);

  // Estados para administración de plantillas globales
  const [openAdminTemplates, setOpenAdminTemplates] = useState(false);
  const [adminTemplates, setAdminTemplates] = useState([]);
  const [selectedTemplate, setSelectedTemplate] = useState(null);

  const [tplToDelete, setTplToDelete] = useState(null);

  const [editingTemplate, setEditingTemplate] = useState(null); // <-- AQUÍ
  const [showTemplateUpdated, setShowTemplateUpdated] = useState(false);

  // Aquí agrega los nuevos estados:
  const [showUnpublishDialog, setShowUnpublishDialog] = useState(false);
  const [unpublishedTemplateName, setUnpublishedTemplateName] = useState("");

  // Estados para el diálogo de variables por contexto
  const [openVariablesDialog, setOpenVariablesDialog] = useState(false);
  const [selectedContext, setSelectedContext] = useState("");
  const [variablesList, setVariablesList] = useState([]);
  const [newVariable, setNewVariable] = useState({ nombre_variable: "", tipo_dato: "texto", descripcion: "" });
  
  const [openContextosDialog, setOpenContextosDialog] = useState(false);
  const [contextOptions, setContextOptions] = useState([]);
  const [newContext, setNewContext] = useState({ nombre: "", descripcion: "" }); // para crear/editar
  const [editingContext, setEditingContext] = useState(null); // contexto en edición
  const [contextToDelete, setContextToDelete] = useState(null); // contexto a eliminar
  const [iaLoading, setIaLoading] = useState(false); // <-- AGREGA AQUÍ
  const [variableToDelete, setVariableToDelete] = useState(null);

  // ===== ESTADOS PARA AI AGENT =====
  const [openAgentDialog, setOpenAgentDialog] = useState(false);
  const [agentConfig, setAgentConfig] = useState({
    enabled: false,
    trigger_on_invalid_input: true,
    max_agent_turns: 3,
    system_prompt: ""
  });
  const [agentLoading, setAgentLoading] = useState(false);
  const [showAgentSaved, setShowAgentSaved] = useState(false);
  const [agentSavedMessage, setAgentSavedMessage] = useState("");
  const [agentTestMessage, setAgentTestMessage] = useState("");
  const [agentTestResponse, setAgentTestResponse] = useState("");
  const [agentTestLoading, setAgentTestLoading] = useState(false);
  const [agentChatHistory, setAgentChatHistory] = useState([]);

  // ===== ESTADOS PARA KB ESTRUCTURADA =====
  const [kbEntries, setKbEntries] = useState([]);
  const [kbCategories, setKbCategories] = useState({});
  const [kbLoading, setKbLoading] = useState(false);
  const [openKbEditor, setOpenKbEditor] = useState(false);
  const [editingKbEntry, setEditingKbEntry] = useState(null);
  const [kbFormData, setKbFormData] = useState({
    category: "faq",
    title: "",
    content: "",
    keywords: "",
    priority: 0
  });
  const [kbKeywordInput, setKbKeywordInput] = useState("");  // Input temporal para agregar keywords

  // Plantillas médicas para el AI Agent (solo system_prompt - KB va en la estructurada)
  const medicalTemplates = [
    {
      id: "general",
      name: "Medicina General",
      icon: "🏥",
      system_prompt: "Eres un asistente amable de una clínica de medicina general. Responde con empatía y profesionalismo. Si preguntan sobre síntomas específicos, sugiere agendar una cita con el médico."
    },
    {
      id: "dermatologia",
      name: "Dermatología",
      icon: "🔬",
      system_prompt: "Eres un asistente de una clínica dermatológica. Puedes dar información general sobre procedimientos pero siempre aclara que el diagnóstico requiere evaluación presencial."
    },
    {
      id: "pediatria",
      name: "Pediatría",
      icon: "👶",
      system_prompt: "Eres un asistente amable de una clínica pediátrica. Usa un tono cálido y tranquilizador para los padres. Si hay síntomas de urgencia (fiebre alta, dificultad respiratoria), recomienda acudir inmediatamente."
    },
    {
      id: "ginecologia",
      name: "Ginecología",
      icon: "👩‍⚕️",
      system_prompt: "Eres un asistente de una clínica ginecológica. Mantén un tono profesional y respetuoso. La privacidad es muy importante."
    },
    {
      id: "odontologia",
      name: "Odontología",
      icon: "🦷",
      system_prompt: "Eres un asistente de una clínica dental. Puedes explicar procedimientos dentales de forma sencilla. Recomienda revisiones preventivas cada 6 meses."
    },
    {
      id: "oftalmologia",
      name: "Oftalmología",
      icon: "👁️",
      system_prompt: "Eres un asistente de una clínica oftalmológica. Puedes explicar sobre exámenes de la vista y tratamientos comunes."
    },
    {
      id: "psicologia",
      name: "Psicología/Psiquiatría",
      icon: "🧠",
      system_prompt: "Eres un asistente de una clínica de salud mental. Sé empático y no invasivo. Si detectas señales de crisis, recomienda líneas de ayuda o atención inmediata."
    }
  ];

  // Función para cargar la configuración del AI Agent
  const loadAgentConfig = async (flowId) => {
    if (!flowId) return;
    setAgentLoading(true);
    try {
      const res = await fetch(`/api/chatbots/${flowId}/agent-config`);
      if (res.ok) {
        const data = await res.json();
        setAgentConfig({
          enabled: data.enabled || false,
          trigger_on_invalid_input: data.trigger_on_invalid_input !== false,
          max_agent_turns: data.max_agent_turns || 3,
          system_prompt: data.system_prompt || ""
        });
      }
    } catch (error) {
      console.error("Error cargando config del agente:", error);
    }
    setAgentLoading(false);
  };

  // Función para aplicar plantilla médica
  const applyMedicalTemplate = (template) => {
    setAgentConfig({
      ...agentConfig,
      system_prompt: template.system_prompt
    });
  };

  // ===== FUNCIONES PARA KB ESTRUCTURADA =====
  const loadKbEntries = async (flowId) => {
    if (!flowId) return;
    setKbLoading(true);
    try {
      const res = await fetch(`/api/chatbots/${flowId}/knowledge-base`);
      if (res.ok) {
        const data = await res.json();
        setKbEntries(data.entries || []);
        setKbCategories(data.categories || {});
      }
    } catch (error) {
      console.error("Error cargando KB:", error);
    }
    setKbLoading(false);
  };

  const saveKbEntry = async () => {
    if (!currentFlowId || !kbFormData.title || !kbFormData.content) return;

    try {
      const url = editingKbEntry
        ? `/api/chatbots/${currentFlowId}/knowledge-base/${editingKbEntry.id}`
        : `/api/chatbots/${currentFlowId}/knowledge-base`;

      const res = await fetch(url, {
        method: editingKbEntry ? "PUT" : "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(kbFormData)
      });

      if (res.ok) {
        await loadKbEntries(currentFlowId);
        setOpenKbEditor(false);
        resetKbForm();
      }
    } catch (error) {
      console.error("Error guardando entrada KB:", error);
    }
  };

  const deleteKbEntry = async (entryId) => {
    if (!currentFlowId) return;

    try {
      const res = await fetch(
        `/api/chatbots/${currentFlowId}/knowledge-base/${entryId}`,
        { method: "DELETE" }
      );

      if (res.ok) {
        await loadKbEntries(currentFlowId);
      }
    } catch (error) {
      console.error("Error eliminando entrada KB:", error);
    }
  };

  const openKbEntryEditor = (entry = null) => {
    if (entry) {
      setEditingKbEntry(entry);
      setKbFormData({
        category: entry.category,
        title: entry.title,
        content: entry.content,
        keywords: entry.keywords || "",
        priority: entry.priority || 0
      });
    } else {
      resetKbForm();
    }
    setOpenKbEditor(true);
  };

  const resetKbForm = () => {
    setEditingKbEntry(null);
    setKbFormData({
      category: "faq",
      title: "",
      content: "",
      keywords: "",
      priority: 0
    });
    setKbKeywordInput("");
  };

  // Funciones para manejar keywords como chips
  const getKeywordsArray = () => {
    if (!kbFormData.keywords) return [];
    return kbFormData.keywords.split(",").map(k => k.trim()).filter(k => k.length > 0);
  };

  const addKeyword = (keyword) => {
    const trimmed = keyword.trim().toLowerCase();
    if (!trimmed) return;

    const currentKeywords = getKeywordsArray();
    if (currentKeywords.includes(trimmed)) return; // Ya existe

    const newKeywords = [...currentKeywords, trimmed].join(", ");
    setKbFormData({ ...kbFormData, keywords: newKeywords });
    setKbKeywordInput("");
  };

  const removeKeyword = (keywordToRemove) => {
    const currentKeywords = getKeywordsArray();
    const newKeywords = currentKeywords.filter(k => k !== keywordToRemove).join(", ");
    setKbFormData({ ...kbFormData, keywords: newKeywords });
  };

  // Función para probar el AI Agent
  const testAgentResponse = async () => {
    if (!agentTestMessage.trim() || !currentFlowId) return;

    setAgentTestLoading(true);
    const userMessage = agentTestMessage.trim();
    setAgentTestMessage("");

    // Agregar mensaje del usuario al historial
    setAgentChatHistory(prev => [...prev, { role: "user", content: userMessage }]);

    try {
      // Usar el agente de OpenAI directamente (clasificación 100% IA en backend)
      const res = await fetch(`/api/chatbots/${currentFlowId}/agent-test`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          message: userMessage,
          system_prompt: agentConfig.system_prompt
        })
      });

      if (res.ok) {
        const data = await res.json();
        if (data.respuesta_agente) {
          setAgentChatHistory(prev => [...prev, { role: "agent", content: data.respuesta_agente }]);
        } else if (data.error) {
          setAgentChatHistory(prev => [...prev, { role: "error", content: data.error }]);
        }
      }
    } catch (error) {
      console.error("Error probando agente:", error);
      setAgentChatHistory(prev => [...prev, { role: "error", content: "Error de conexión" }]);
    }
    setAgentTestLoading(false);
  };

  // Limpiar chat de prueba
  const clearAgentChat = () => {
    setAgentChatHistory([]);
    setAgentTestMessage("");
  };

  // Función para guardar la configuración del AI Agent
  const saveAgentConfig = async () => {
    if (!currentFlowId) {
      alert("Primero guarda el flujo antes de configurar el AI Agent");
      return;
    }
    setAgentLoading(true);
    try {
      const payload = {
        enabled: agentConfig.enabled,
        trigger_on_invalid_input: agentConfig.trigger_on_invalid_input,
        max_agent_turns: agentConfig.max_agent_turns,
        system_prompt: agentConfig.system_prompt
      };

      const res = await fetch(`/api/chatbots/${currentFlowId}/agent-config`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload)
      });
      if (res.ok) {
        setAgentSavedMessage(`AI Agent ${agentConfig.enabled ? 'activado' : 'desactivado'} correctamente`);
        setShowAgentSaved(true);
        setOpenAgentDialog(false);
      } else {
        alert("Error al guardar configuración");
      }
    } catch (error) {
      console.error("Error guardando config del agente:", error);
      alert("Error de conexión");
    }
    setAgentLoading(false);
  };

  // Abrir dialog y cargar config
  const handleOpenAgentDialog = () => {
    if (currentFlowId) {
      loadAgentConfig(currentFlowId);
      loadKbEntries(currentFlowId);  // Cargar KB estructurada
    }
    setOpenAgentDialog(true);
  };

  const handleOpenVariablesDialog = () => {
  setSelectedContext(""); // Limpia la selección
  setOpenVariablesDialog(true);
  };

  useEffect(() => {
  if (openContextosDialog && !editingContext) {
    setNewContext({
      nombre: "",
      descripcion: CONTEXTO_DESCRIPCION_TEMPLATE
    });
  }
}, [openContextosDialog, editingContext]);

  // Al montar el componente, carga los contextos
 useEffect(() => {
  fetch("/api/contextos/")
    .then(res => res.json())
    .then(data => {
      setContextOptions(data);
      // Establecer el contexto médico por defecto si existe
      const medicoContext = data.find(ctx => ctx.nombre === "medicina");
      if (medicoContext && !flowContextId) {
        setFlowContextId(medicoContext.id);
      }
    });
}, []);

  useEffect(() => {
  if (openContextosDialog) {
    fetch("/api/contextos/")
      .then(res => res.json())
      .then(setContextOptions);
  }
}, [openContextosDialog]);

  

  // Añadir estas funciones para gestionar las operaciones CRUD
const fetchTiposMensaje = useCallback(async () => {
  try {
    const userId = user?.id || localStorage.getItem("user_id");
    
    const res = await fetch("/api/tipos_mensaje/", {
      headers: {
        "X-User-Id": userId ? String(userId) : ""
      }
    });
    
    const data = await res.json();
    setTiposMensaje(data);
  } catch (error) {
    console.error("Error al cargar tipos de mensaje:", error);
  }
}, [user]);

// Luego, añadir este useEffect para cargar los tipos de mensaje al abrir el diálogo
    useEffect(() => {
    if (openTiposMensajeDialog) {
      fetchTiposMensaje();
    }
  }, [openTiposMensajeDialog, fetchTiposMensaje]);

const handleSaveTipoMensaje = async () => {
  try {
    const method = selectedTipoMensaje ? "PUT" : "POST";
    const url = selectedTipoMensaje 
      ? `/api/tipos_mensaje/${selectedTipoMensaje.id}` 
      : "/api/tipos_mensaje/";
    
    // Generar un código basado en el nombre (normalizado)
    const codigo = newTipoMensaje.nombre
      .toUpperCase()
      .replace(/[^A-Z0-9]/g, '_')
      .substring(0, 40); // Limitar a 40 caracteres
    
    // Verificar que los campos obligatorios estén presentes
    if (!newTipoMensaje.nombre || !newTipoMensaje.nombre.trim()) {
      alert("El nombre es obligatorio");
      return;
    }
    
    // Obtener el ID del usuario actual (este es el valor que necesitamos enviar)
    const userId = user?.id || localStorage.getItem("user_id");
    
    if (!userId) {
      alert("No se pudo identificar al usuario. Por favor, inicie sesión nuevamente.");
      return;
    }
    
    // Preparar el payload según la estructura esperada por el backend
    const payload = {
      codigo: selectedTipoMensaje?.codigo || codigo, // Usar código existente en edición
      nombre: newTipoMensaje.nombre.trim(),
      descripcion: newTipoMensaje.descripcion || "" // Asegurar que descripción nunca sea null
    };
    
    console.log("Enviando datos:", payload);
    console.log("Usuario ID:", userId);
    
    const res = await fetch(url, {
      method: method,
      headers: { 
        "Content-Type": "application/json",
        "X-User-Id": String(userId) // Añadir el encabezado X-User-Id
      },
      body: JSON.stringify(payload)
    });
    
    const contentType = res.headers.get("content-type");
    
    if (!res.ok) {
      // Procesamiento mejorado de errores
      if (contentType && contentType.indexOf("application/json") !== -1) {
        const errorData = await res.json();
        console.error("Error detallado:", errorData);
        
        // Si el error es un array de validaciones de Pydantic
        if (Array.isArray(errorData.detail)) {
          const errMsgs = errorData.detail.map(err => 
            `${err.loc.join('.')}: ${err.msg}`
          ).join('\n');
          alert(`Errores de validación:\n${errMsgs}`);
        } else {
          alert(`Error: ${JSON.stringify(errorData.detail) || "No se pudo guardar el tipo de mensaje"}`);
        }
      } else {
        const errorText = await res.text();
        alert(`Error: ${errorText || res.statusText}`);
      }
      return;
    }
    
    // Si la operación fue exitosa
    await fetchTiposMensaje();
    setSelectedTipoMensaje(null);
    setNewTipoMensaje({ nombre: "", descripcion: "" });
    setShowTipoMensajeForm(false);
  } catch (error) {
    console.error("Error al guardar tipo de mensaje:", error);
    alert("Error al guardar: " + error.message);
  }
};

const handleDeleteTipoMensaje = async (id) => {
  try {
    const userId = user?.id || localStorage.getItem("user_id");
    
    if (!userId) {
      alert("No se pudo identificar al usuario. Por favor, inicie sesión nuevamente.");
      return;
    }
    
    const res = await fetch(`/api/tipos_mensaje/${id}`, {
      method: "DELETE",
      headers: {
        "X-User-Id": String(userId) // Añadir el encabezado X-User-Id
      }
    });
    
    if (res.ok) {
      await fetchTiposMensaje();
      setTipoMensajeToDelete(null);
    } else {
      const error = await res.json();
      alert(`Error: ${error.detail || "No se pudo eliminar el tipo de mensaje"}`);
    }
  } catch (error) {
    console.error("Error al eliminar tipo de mensaje:", error);
    alert("Error al eliminar: " + error.message);
  }
};

// Añade estas funciones
const fetchMensajes = useCallback(async () => {
  setLoadingMensajes(true);
  try {
    const userId = user?.id || localStorage.getItem("user_id");
    
    const response = await fetch(`/api/mensajes/`, {
      headers: {
        "X-User-Id": userId ? String(userId) : ""
      }
    });
    
    if (response.ok) {
      const data = await response.json();
      setMensajes(data);
    } else {
      console.error("Error al cargar mensajes");
    }
  } catch (error) {
    console.error("Error de red:", error);
  } finally {
    setLoadingMensajes(false);
  }
}, [user]); // Dependencias de fetchMensajes


const handleEditMensaje = (mensaje) => {
  setSelectedMensaje(mensaje);
  setNewMensaje({
    id_contexto: mensaje.id_contexto,
    id_tipo_mensaje: mensaje.id_tipo_mensaje,
    mensaje: mensaje.mensaje,
    activo: mensaje.activo
  });
  setShowMensajeForm(true);
};

const handleCancelMensajeForm = () => {
  setSelectedMensaje(null);
  setNewMensaje({
    id_contexto: "",
    id_tipo_mensaje: "",
    mensaje: "",
    activo: true
  });
  setShowMensajeForm(false);
};

const handleSaveMensaje = async () => {
  if (!newMensaje.id_contexto || !newMensaje.id_tipo_mensaje || !newMensaje.mensaje.trim()) {
    alert("Todos los campos son obligatorios");
    return;
  }
  
  try {
    const userId = user?.id || localStorage.getItem("user_id");
    
    if (!userId) {
      alert("No se pudo identificar al usuario. Por favor, inicie sesión nuevamente.");
      return;
    }
    
    const url = selectedMensaje 
      ? `/api/mensajes/${selectedMensaje.id}`
      : `/api/mensajes/`;
    
    const method = selectedMensaje ? "PUT" : "POST";
    
    const response = await fetch(url, {
      method,
      headers: {
        "Content-Type": "application/json",
        "X-User-Id": String(userId)
      },
      body: JSON.stringify(newMensaje)
    });
    
    if (response.ok) {
      alert(selectedMensaje ? "Mensaje actualizado" : "Mensaje creado");
      fetchMensajes();
      handleCancelMensajeForm();
    } else {
      const error = await response.json();
      alert(error.detail || "Error al guardar el mensaje");
    }
  } catch (error) {
    console.error("Error:", error);
    alert("Error de red al guardar el mensaje");
  }
};

const handleDeleteMensaje = async (mensajeId) => {
  try {
    const userId = user?.id || localStorage.getItem("user_id");
    
    if (!userId) {
      alert("No se pudo identificar al usuario. Por favor, inicie sesión nuevamente.");
      return;
    }
    
    const response = await fetch(`/api/mensajes/${mensajeId}`, {
      method: "DELETE",
      headers: {
        "X-User-Id": String(userId)
      }
    });
    
    if (response.ok) {
      alert("Mensaje eliminado correctamente");
      fetchMensajes();
      setMensajeToDelete(null);
    } else {
      const error = await response.json();
      alert(error.detail || "Error al eliminar el mensaje");
    }
  } catch (error) {
    console.error("Error:", error);
    alert("Error de red al eliminar el mensaje");
  }
};

// Actualiza el estado activo/inactivo de un mensaje
const handleToggleActivoMensaje = async (mensaje) => {
  try {
    const userId = user?.id || localStorage.getItem("user_id");
    
    if (!userId) {
      alert("No se pudo identificar al usuario. Por favor, inicie sesión nuevamente.");
      return;
    }
    
    const endpoint = mensaje.activo 
      ? `/api/mensajes/${mensaje.id}/desactivar`
      : `/api/mensajes/${mensaje.id}/activar`;
    
    const response = await fetch(endpoint, {
      method: "POST",
      headers: {
        "X-User-Id": String(userId)
      }
    });
    
    if (response.ok) {
      alert(mensaje.activo ? "Mensaje desactivado" : "Mensaje activado");
      fetchMensajes();
    } else {
      const error = await response.json();
      alert(error.detail || "Error al cambiar estado del mensaje");
    }
  } catch (error) {
    console.error("Error:", error);
    alert("Error de red al cambiar estado del mensaje");
  }
};

// Cargar mensajes al abrir el diálogo
useEffect(() => {
  if (openMensajesDialog) {
    fetchMensajes();
  }
}, [openMensajesDialog, fetchMensajes]);

// Cargar tipos de mensaje al abrir el diálogo
// Cargar tipos de mensaje al abrir el diálogo
useEffect(() => {
  if (openMensajesDialog) {
    console.log("Cargando tipos de mensaje...");
    fetchTiposMensaje().then((result) => {
      // Usar el resultado directamente, no el estado tiposMensaje
      console.log("Tipos de mensaje cargados:", result);
    });
  }
}, [openMensajesDialog, fetchTiposMensaje]);


  // Define nodeTypes aquí, después de los estados:
    const nodeTypes = useMemo(() => ({
      custom: (props) => (
        <CustomNode
          {...props}
          flowContext={flowContext}
          //variablesList={variablesList}
          variablesList={filteredVariablesList}
          predefinedQuestions={predefinedQuestions}
          contextOptions={contextOptions}
          flowContextId={flowContextId}
          setEdges={setEdges} // <-- AGREGA ESTO
          filteredPredefinedQuestions={filteredPredefinedQuestions}
          loadingQuestions={loadingQuestions} // <-- AGREGA ESTA LÍNEA
          userName={userName} // <-- agrega aquí
          user={user}
        />
      ),
    }), [flowContext, filteredVariablesList, predefinedQuestions, contextOptions, flowContextId, setEdges, filteredPredefinedQuestions, loadingQuestions, userName, user]);

 useEffect(() => {
  if (flowContextId) {
    fetch(`/api/input_variables/?id_contexto=${flowContextId}`)
      .then(res => res.json())
      .then(setVariablesList);
  } else {
    setVariablesList([]);
  }
}, [flowContextId]);

//    useEffect(() => {
//    if (openVariablesDialog && contextOptions.length > 0 && !selectedContext) {
//      setSelectedContext(contextOptions[0].id);
//    }
//  }, [openVariablesDialog, contextOptions, selectedContext]);
  

  const assistantChatRef = useRef(null); // <-- AQUÍ

  const [assistantOpen, setAssistantOpen] = useState(false);
  
  const [assistantMessages, setAssistantMessages] = useState([
    {
      from: "bot",
      text: "¡Hola! 👋 Soy NARA, tu asistente inteligente con IA para construir flujos conversacionales.\n\n¿Cómo puedo ayudarte hoy?",
      options: [
        {
          label: "🚀 Crear un flujo nuevo",
          action: () => {
            setAssistantMessages(msgs => [
              ...msgs,
              { from: "user", text: "Quiero crear un flujo nuevo" },
              { from: "bot", text: "¡Excelente! Descríbeme qué tipo de flujo necesitas. Por ejemplo:\n\n• 'Un flujo para agendar citas médicas'\n• 'Un chatbot de atención al paciente'\n• 'Un flujo para capturar síntomas'\n\nSé lo más específico posible y yo generaré los nodos automáticamente. 🎯" }
            ]);
          }
        },
        {
          label: "💡 Ver ejemplos",
          action: () => {
            setAssistantMessages(msgs => [
              ...msgs,
              { from: "user", text: "Quiero ver ejemplos" },
              { from: "bot", text: "Aquí tienes algunas ideas de flujos que puedo crear:\n\n📅 *Agendamiento de citas*\n'Crea un flujo para agendar citas que pida nombre, motivo y fecha'\n\n🏥 *Triaje inicial*\n'Un flujo que capture síntomas del paciente y determine urgencia'\n\n📋 *Registro de pacientes*\n'Flujo para registrar nuevos pacientes con sus datos básicos'\n\n🔔 *Confirmación de citas*\n'Un flujo para confirmar o reagendar citas programadas'\n\n¡Solo escribe lo que necesitas!" }
            ]);
          }
        },
        {
          label: "❓ ¿Qué puedes hacer?",
          action: () => {
            setAssistantMessages(msgs => [
              ...msgs,
              { from: "user", text: "¿Qué puedes hacer?" },
              { from: "bot", text: "Soy un asistente potenciado con IA que puede:\n\n✨ *Generar flujos completos* desde una descripción\n🔧 *Sugerir mejoras* a tu flujo actual\n📚 *Explicar* cómo funcionan los diferentes tipos de nodos\n💬 *Responder preguntas* sobre diseño conversacional\n\nSolo descríbeme lo que necesitas en lenguaje natural y yo me encargo del resto. ¡Pruébalo!" }
            ]);
          }
        }
      ]
    }
  ]);

  // Estados para el perfil del usuario
  const [openProfileDialog, setOpenProfileDialog] = useState(false);
  const [userPlan, setUserPlan] = useState(null);
  const [userAgenda, setUserAgenda] = useState(null);

  // Estados para edición de agenda
  const [editingAgenda, setEditingAgenda] = useState(false);
  const [editAgendaDias, setEditAgendaDias] = useState([]);
  const [editAgendaHoraInicio, setEditAgendaHoraInicio] = useState("08:00");
  const [editAgendaHoraFin, setEditAgendaHoraFin] = useState("18:00");
  const [editAgendaIntervalo, setEditAgendaIntervalo] = useState(30);
  const [savingAgenda, setSavingAgenda] = useState(false);

  const [assistantInput, setAssistantInput] = useState("");
  const [assistantLoading, setAssistantLoading] = useState(false);
  const [pendingAINodes, setPendingAINodes] = useState(null); // Nodos generados por IA pendientes de agregar
  const [anchorBillingMenu, setAnchorBillingMenu] = useState(null);
  const handleBillingMenuOpen = (event) => setAnchorBillingMenu(event.currentTarget);
  const handleBillingMenuClose = () => setAnchorBillingMenu(null);

  const [openSubscriptionDialog, setOpenSubscriptionDialog] = useState(false);
  const [subscriptionInfo, setSubscriptionInfo] = useState(null);
  const [loadingSubscription, setLoadingSubscription] = useState(false);

  // Scroll automático en el panel del asistente
  useEffect(() => {
    if (assistantChatRef.current) {
      assistantChatRef.current.scrollTop = assistantChatRef.current.scrollHeight;
    }
  }, [assistantMessages]);

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged(u => {
      setUser(u);
      // Guardar photoURL de Firebase por separado para que no se pierda
      if (u?.photoURL) {
        setFirebasePhotoURL(u.photoURL);
      }
    });
    return () => unsubscribe();
  }, []);

  console.log("Usuario autenticado:", user);
  // Determina si el usuario es admin NARA
  console.log("user:", user);
  console.log("empresa id:", user?.empresa?.id);
  const isNaraAdmin = String(user?.empresa?.id) === "4";
  console.log("Render botón admin:", user?.empresa?.id, isNaraAdmin);

  // 2. Funciones primero
  const pushToUndoStack = useCallback(() => {
    setUndoStack(stack => [...stack, { nodes, edges }]);
    setRedoStack([]); // limpiar redo al hacer un nuevo cambio
  }, [nodes, edges]);

  const handleUndo = () => {
    if (undoStack.length === 0) return;
    const prev = undoStack[undoStack.length - 1];
    setRedoStack(stack => [...stack, { nodes, edges }]);
    setNodes(prev.nodes);
    setEdges(prev.edges);
    setUndoStack(stack => stack.slice(0, -1));
  };

  const handleRedo = () => {
    if (redoStack.length === 0) return;
    const next = redoStack[redoStack.length - 1];
    setUndoStack(stack => [...stack, { nodes, edges }]);
    setNodes(next.nodes);
    setEdges(next.edges);
    setRedoStack(stack => stack.slice(0, -1));
  };

  // 3. Ahora handlers que usan pushToUndoStack
  const handleNodeDataChange = (id, newData) => {
    pushToUndoStack();
    setNodes(nds =>
      nds.map(n =>
        n.id === id ? { ...n, data: { ...n.data, ...newData, onChange: handleNodeDataChange } } : n
      )
    );
  };

 const addNode = (type) => {
  pushToUndoStack();
  // Busca el nodo de inicio
  const startNode = nodes.find(n => n.id === "1");
  // Si existe, pon el nuevo nodo cerca de él, si no, usa un valor por defecto
  const baseX = startNode ? startNode.position.x : 100;
  const baseY = startNode ? startNode.position.y : 100;
  // Calcula una posición cercana (pero no encima)
  const offset = 60 + nodes.length * 10;
  const id = `n${Date.now()}_${nodeIdCounter++}`;

  // Texto predeterminado según el tipo de nodo
  let defaultLabel = "";
  if (type === "options") {
    defaultLabel = "Seleccione una opción:";
  } else if (type === "input_ia") {
    defaultLabel = "Escribe la pregunta o instrucción…";
  } else if (type === "verificar_datos") {
    defaultLabel = "Por favor verifica que tus datos sean correctos:";
  } else if (type === "escalacion_humano") {
    defaultLabel = "Tu solicitud será atendida por uno de nuestros asesores. Pronto te contactaremos.";
  }
  
  setNodes(nds => [
    ...nds,
    {
      id,
      type: "custom",
      position: { x: baseX + offset, y: baseY + offset },
      data: { 
        type, 
        label: defaultLabel, 
        variable: "", 
        options: [], 
        onChange: handleNodeDataChange, 
        onDelete: handleDeleteNode 
      },
    },
  ]);
 };

  // funcion para cargar el perfil del usuario
  const fetchUserProfile = async () => {
   console.log("Intentando cargar perfil de usuario:", user);
   let data;
   if (user?.uid) {
    // Usuario Google/Firebase
      const res = await fetch(`/api/users/by_uid/${user.uid}`);
      data = await res.json();
    } else if (user?.id) {
      // Usuario tradicional
      const res = await fetch(`/api/users/${user.id}`);
      data = await res.json();
    }
    setUserPlan(data?.empresa?.plan?.name || "Desconocido");
    setSubscriptionInfo({
    empresa: data?.empresa || {},
    plan: data?.empresa?.plan || {},
    });
    setUserAgenda(data?.agenda || null);
  };

  const fetchSubscriptionInfo = async () => {
  let userId = user?.id;
  if (!userId && user?.uid) {
    // Buscar el id tradicional usando el uid de Firebase
    const res = await fetch(`/api/users/by_uid/${user.uid}`);
    const data = await res.json();
    userId = data?.id;
  }
  if (!userId) return;
  setLoadingSubscription(true);
  try {
    const res = await fetch(`/api/users/${encodeURIComponent(String(userId))}/subscription`);
    const data = await res.json();
    setSubscriptionInfo(data);
  } catch (err) {
    setSubscriptionInfo(null);
  }
  setLoadingSubscription(false);
};

  // Funciones para edición de agenda
  const DIAS_SEMANA = [
    { id: "lunes", label: "Lun" },
    { id: "martes", label: "Mar" },
    { id: "miercoles", label: "Mié" },
    { id: "jueves", label: "Jue" },
    { id: "viernes", label: "Vie" },
    { id: "sabado", label: "Sáb" },
    { id: "domingo", label: "Dom" }
  ];

  const INTERVALOS = [
    { value: 15, label: "15 min" },
    { value: 20, label: "20 min" },
    { value: 30, label: "30 min" },
    { value: 45, label: "45 min" },
    { value: 60, label: "1 hora" }
  ];

  const startEditingAgenda = () => {
    // Parsear días existentes
    const diasActuales = userAgenda?.dias ? userAgenda.dias.split(",").map(d => d.trim().toLowerCase()) : [];
    setEditAgendaDias(diasActuales);
    setEditAgendaHoraInicio(userAgenda?.hora_inicio || "08:00");
    setEditAgendaHoraFin(userAgenda?.hora_fin || "18:00");
    setEditAgendaIntervalo(userAgenda?.intervalo || 30);
    setEditingAgenda(true);
  };

  const cancelEditingAgenda = () => {
    setEditingAgenda(false);
  };

  const toggleDia = (diaId) => {
    setEditAgendaDias(prev =>
      prev.includes(diaId)
        ? prev.filter(d => d !== diaId)
        : [...prev, diaId]
    );
  };

  const saveAgenda = async () => {
    setSavingAgenda(true);
    try {
      let userId = user?.id;
      if (!userId && user?.uid) {
        const res = await fetch(`/api/users/by_uid/${user.uid}`);
        const data = await res.json();
        userId = data?.id;
      }
      if (!userId) {
        alert("No se pudo identificar el usuario");
        return;
      }

      const diasOrdenados = DIAS_SEMANA
        .filter(d => editAgendaDias.includes(d.id))
        .map(d => d.id);

      const response = await fetch(`/api/users/${userId}/agenda`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          dias: diasOrdenados.join(", "),
          hora_inicio: editAgendaHoraInicio,
          hora_fin: editAgendaHoraFin,
          intervalo: editAgendaIntervalo
        })
      });

      if (response.ok) {
        const updatedAgenda = await response.json();
        setUserAgenda(updatedAgenda);
        setEditingAgenda(false);
      } else {
        alert("Error al guardar el horario");
      }
    } catch (err) {
      console.error("Error guardando agenda:", err);
      alert("Error al guardar el horario");
    } finally {
      setSavingAgenda(false);
    }
  };

  const handleDeleteNode = (id) => {
    pushToUndoStack();
    setNodes((nds) => nds.filter((n) => n.id !== id));
    setEdges((eds) => eds.filter((e) => e.source !== id && e.target !== id));
  };

    const onConnect = useCallback(
    (params) => {
      // No permitir dos conexiones saliendo del mismo source+sourceHandle
      if (
        edges.some(
          e =>
            e.source === params.source &&
            (e.sourceHandle || null) === (params.sourceHandle || null)
        )
      ) {
        return;
      }
  
      const sourceNode = nodes.find(n => n.id === params.source);
      const targetNode = nodes.find(n => n.id === params.target);
  
      // Permitir varios edges entrantes a nodos tipo "message"
      // Solo restringe si el target NO es "message"
      if (
        targetNode?.data?.type !== "message" &&
        targetNode?.data?.type !== "options" &&
        edges.some(
          e =>
            e.target === params.target &&
            (e.targetHandle || null) === (params.targetHandle || null)
        )
      ) {
        return;
      }
  
      // --- RESTRICCIÓN PARA NODOS IA ---
      if (targetNode?.data?.type === "ia") {
        const isFromOptions = sourceNode?.data?.type === "options" &&
          params.sourceHandle &&
          params.sourceHandle.startsWith("option-");
        const isFromIa = sourceNode?.data?.type === "ia";
        if (!isFromOptions && !isFromIa) {
          setOpenIaConnectDialog(true);
          return;
        }
      }
      // --- FIN RESTRICCIÓN ---
  
      pushToUndoStack();
      setEdges(eds => addEdge(params, eds));
    },
    [edges, setEdges, pushToUndoStack, nodes, setOpenIaConnectDialog]
  );

  // Referencia para el scroll automático en el simulador
  const chatScrollRef = useRef(null);

  // ===== ESTADO PARA EL NUEVO SIMULADOR CON BACKEND =====
  const [simuladorMode, setSimuladorMode] = useState("visual"); // "visual" o "chat"
  const [chatHistory, setChatHistory] = useState([]); // Historial de mensajes
  const [chatInput, setChatInput] = useState(""); // Input del usuario
  const [chatSessionId, setChatSessionId] = useState(null); // Session ID para mantener contexto
  const [chatLoading, setChatLoading] = useState(false); // Estado de carga
  const [simuladorVariables, setSimuladorVariables] = useState({}); // Variables recolectadas
  const [simularClienteExiste, setSimularClienteExiste] = useState(true); // Simular cliente existente

  // Función para enviar mensaje al simulador backend
  const enviarMensajeSimulador = async (mensaje, simularImagen = false, simularVoz = false) => {
    if (!currentFlowId) {
      alert("Primero debes guardar el flujo para poder probarlo");
      return;
    }

    if ((!mensaje || mensaje.trim() === "") && !simularImagen) return;

    setChatLoading(true);

    // Agregar mensaje del usuario al historial
    const tipoMensaje = simularImagen ? "imagen" : simularVoz ? "voz" : "texto";
    setChatHistory(prev => [...prev, {
      from: "user",
      text: mensaje || (simularImagen ? "📷 [Imagen enviada]" : ""),
      type: tipoMensaje,
      time: new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })
    }]);

    setChatInput("");

    try {
      const response = await fetch("/api/simulador/mensaje", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          chatbot_id: currentFlowId,
          mensaje: mensaje || "",
          session_id: chatSessionId,
          simular_imagen: simularImagen,
          simular_voz: simularVoz,
          simular_cliente_existe: simularClienteExiste
        })
      });

      const data = await response.json();

      if (data.success) {
        // Actualizar session ID si es nuevo
        if (!chatSessionId && data.session_id) {
          setChatSessionId(data.session_id);
        }

        // Agregar respuesta del bot al historial
        setChatHistory(prev => [...prev, {
          from: "bot",
          text: data.respuesta,
          type: "texto",
          time: new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }),
          nodo: data.nodo_actual
        }]);

        // Actualizar variables
        if (data.variables) {
          setSimuladorVariables(data.variables);
        }
      } else {
        setChatHistory(prev => [...prev, {
          from: "bot",
          text: `Error: ${data.error || "No se pudo procesar el mensaje"}`,
          type: "error",
          time: new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })
        }]);
      }
    } catch (error) {
      console.error("Error en simulador:", error);
      setChatHistory(prev => [...prev, {
        from: "bot",
        text: "Error de conexión con el servidor",
        type: "error",
        time: new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })
      }]);
    }

    setChatLoading(false);

    // Scroll al final
    setTimeout(() => {
      if (chatScrollRef.current) {
        chatScrollRef.current.scrollTop = chatScrollRef.current.scrollHeight;
      }
    }, 100);
  };

  // Función para resetear el simulador backend
  const resetearSimuladorBackend = async () => {
    if (!currentFlowId) return;

    try {
      await fetch(`/api/simulador/reset?chatbot_id=${currentFlowId}${chatSessionId ? `&session_id=${chatSessionId}` : ""}`, {
        method: "POST"
      });
    } catch (error) {
      console.error("Error reseteando simulador:", error);
    }

    setChatHistory([]);
    setChatSessionId(null);
    setSimuladorVariables({});
    setChatInput("");
  };

  // Efecto para hacer scroll al final cuando cambian los nodos
  useEffect(() => {
    if (chatScrollRef.current) {
      chatScrollRef.current.scrollTop = chatScrollRef.current.scrollHeight;
    }
  }, [nodes, chatHistory]);

  // Efecto para actualizar el perfil completo del usuario cuando cambia
useEffect(() => {
  async function fetchProfile() {
    let data = null;
    if (user?.uid) {
      const res = await fetch(`/api/users/by_uid/${user.uid}`);
      data = await res.json();
    } else if (user?.id) {
      const res = await fetch(`/api/users/${user.id}`);
      data = await res.json();
    }
    // Solo actualiza si el id de empresa cambió, preservando datos de Firebase
    if (data && (!user.empresa || user.empresa.id !== data.empresa?.id)) {
      setUser(prev => ({
        ...data,
        // Preservar datos de Firebase Auth (foto, nombre, etc.)
        photoURL: prev?.photoURL || data.photoURL,
        displayName: prev?.displayName || data.displayName,
        uid: prev?.uid || data.uid,
      }));
    }
  }
  if (user && (!user.empresa || !user.empresa.id)) {
    fetchProfile();
  }
}, [user]);

// ...otros useEffect...
  useEffect(() => {
    if (openTemplateDialog) {
      fetch("/api/templates/")
        .then(res => res.json())
        .then(data => {
          setPublicTemplates(data.filter(tpl => tpl.is_public));
        });
    }
  }, [openTemplateDialog]);

  useEffect(() => {
  if (openVariablesDialog && selectedContext) {
    fetch(`/api/input_variables/?id_contexto=${selectedContext}`)
      .then(res => res.json())
      .then(setVariablesList);
  }
}, [openVariablesDialog, selectedContext]);

  const handleSave = () => {
    const flow = {
      nodes,
      edges,
    };
    localStorage.setItem("chatbotFlow", JSON.stringify(flow));
    alert("¡Flujo guardado!");
  };

  const handleNewChatbot = () => {
    setOpenNewDialog(true);
  };

   const handleUseTemplate = tpl => {
    const initialNodes = (tpl.nodes || []).map(n => ({
      id: n.node_id || n.id,
      type: "custom",
      position: {
        x: n.position_x ?? (n.position?.x ?? 100),
        y: n.position_y ?? (n.position?.y ?? 100),
      },
      data: {
        type: n.type ?? n.data?.type,
        label: n.label ?? n.data?.label,
        variable: n.variable ?? n.data?.variable,
        tipo_dato: n.tipo_dato ?? n.data?.tipo_dato ?? "texto",
        options: n.options ?? n.data?.options ?? [],
        onChange: handleNodeDataChange,
        onDelete: handleDeleteNode,
      }
    }));
    const initialEdges = (tpl.edges || []).map(e => ({
      id: `${e.source_node_id || e.source}-${e.target_node_id || e.target}`,
      source: e.source_node_id || e.source,
      target: e.target_node_id || e.target,
      sourceHandle: e.source_handle ?? e.sourceHandle ?? undefined,
      label: e.label ?? "",
      type: e.edge_type ?? e.type ?? "step",
    }));
    setNodes(initialNodes.length ? initialNodes : getInitialNodes());
    setEdges(initialEdges);
    setOpenTemplateDialog(false);
    setUndoStack([]);
    setRedoStack([]);
  };

    // Alrededor de la línea 1320, actualiza confirmNewChatbot:
  
  const confirmNewChatbot = () => {
    localStorage.removeItem("chatbotFlow");
    
    // Crear nodos iniciales completamente limpios
    const initialNodes = [{
      id: "1",
      type: "custom",
      position: { x: 20, y: 20 },
      data: { 
        type: "message", 
        label: "Inicio de conversación", 
        onChange: handleNodeDataChange, 
        onDelete: handleDeleteNode,
        // Estados limpios del simulador
        selectedOption: undefined,
        userInput: "",
        respondido: false,
        error: undefined,
        iaResponse: undefined,
        iaExtracted: undefined
      },
    }];
    
    setNodes(initialNodes);
    setEdges([]);
    setUndoStack([]);
    setRedoStack([]);
    setCurrentFlowId(null);
    setOpenNewDialog(false);
    setFlowContextId(null);
    setUserName("");
    setUserVariables({});
    
    // Limpiar asistente
    setAssistantOpen(false);
    setAssistantMessages([{
      from: "bot",
      text: "¡Hola! Soy NARA, tu asistente para construir flujos conversacionales. ¿Deseas que te ayude a construir un flujo conversacional?",
      options: [
        {
          label: "Sí",
          action: () => {
            setAssistantMessages(msgs => [
              ...msgs,
              { from: "user", text: "Sí" }
            ]);
            setNodes(nds =>
              nds.map(n =>
                n.id === "1"
                  ? { ...n, data: { ...n.data, label: "¡Hola! Soy Nara, ¿en qué puedo ayudarte?" } }
                  : n
              )
            );
            runAssistantStep(0, "1");
          }
        },
        {
          label: "No",
          action: () => {
            setAssistantMessages(msgs => [
              ...msgs,
              { from: "user", text: "No" },
              { from: "bot", text: "¡Perfecto! Si necesitas ayuda más adelante, haz clic en el botón del asistente 🤖." }
            ]);
            setTimeout(() => {
              setAssistantOpen(false);
              setAssistantMessages([]);
            }, 5000);
          }
        }
      ]
    }]);
    
    setFlowName("");
    setFlowDescription("");
    setOpenFlowDialog(true);
    
    // Forzar scroll al inicio del simulador
    setTimeout(() => {
      if (chatScrollRef.current) {
        chatScrollRef.current.scrollTop = 0;
      }
    }, 100);
  };
  
    // También necesitas una función para resetear el simulador cuando se necesite
  const resetSimulator = () => {
    setUserName("");
    setUserVariables({});
    setNodes(currentNodes => 
      currentNodes.map(n => ({
        ...n,
        data: {
          ...n.data,
          selectedOption: undefined,
          userInput: "",
          respondido: false,
          error: undefined,
          iaResponse: undefined,
          iaExtracted: undefined
        }
      }))
    );
  };
  
  // También agrega un botón para resetear el simulador manualmente
    // Actualiza la función handleResetSimulator:
  
    // Actualiza la función handleResetSimulator:
  
  const handleResetSimulator = () => {
    if (window.confirm("¿Resetear el simulador? Se perderán todas las respuestas ingresadas.")) {
      setUserName("");
      setUserVariables({});
      setNodes(currentNodes => 
        currentNodes.map(n => ({
          ...n,
          data: {
            ...n.data,
            selectedOption: undefined,
            userInput: "",
            respondido: false,
            error: undefined,
            iaResponse: undefined,
            iaExtracted: undefined,
            editingLabel: false,
            // Solo el primer nodo debe estar visible después del reset
            wasShown: n.id === "1"
          }
        }))
      );
      
      // Forzar scroll al inicio
      setTimeout(() => {
        if (chatScrollRef.current) {
          chatScrollRef.current.scrollTop = 0;
        }
      }, 100);
    }
  };
  const cancelNewChatbot = () => {
    setOpenNewDialog(false);
  };

  const handleUserMenuClose = () => setAnchorUserMenu(null);

  const handleLogout = async () => {
    await auth.signOut();
    window.location.href = "/login";
  };

  const handleAvatarClick = (event) => setAnchorUserMenu(event.currentTarget);

  const handleSaveToDB = () => {
    setOpenFlowDialog(true);
  };

  const handleFlowDialogClose = () => {
    setOpenFlowDialog(false);
    setFlowName("");
    setFlowDescription("");
    setFlowWhatsappNumber("");
  };

  const getUserId = async () => {
  if (user?.id) return user.id;
  if (user?.uid) {
    const res = await fetch(`/api/users/by_uid/${user.uid}`);
    const data = await res.json();
    return data?.id;
  }
  return null;
};

// GUARDAR FLUJO EN BASE DE DATOS
 const handleFlowDialogSave = async () => {
    if (!flowName.trim()) {
      alert("El nombre del flujo es obligatorio.");
      return;
    }
    const userId = await getUserId();
    if (!userId) {
      alert("No se pudo determinar el usuario. Intenta recargar la página.");
      return;
    }
    const payload = {
      name: flowName,
      description: flowDescription,
      id_contexto: flowContextId,
      user_id: userId,
      whatsapp_number: flowWhatsappNumber || null,  // Número de WhatsApp/Twilio asociado
      nodes: nodes.map(n => ({
        node_id: n.id,
        type: n.data.type,
        label: n.data.label ?? "",
        variable: n.data.variable ?? "",
        variables: n.data.variables ?? [],
        tipo_dato: n.data.tipo_dato ?? "texto",
        options: n.data.options ?? [],
        position_x: Math.round(n.position.x),
        position_y: Math.round(n.position.y),
      })),
      edges: edges.map(e => ({
        source_node_id: e.source,
        target_node_id: e.target,
        edge_type: e.type ?? "",
        label: e.label ?? "",
        source_handle: e.sourceHandle ?? null,
      })),
      ...(currentFlowId ? { id: currentFlowId } : {}),
    };

    try {
      let res, data;
      if (currentFlowId) {
        res = await fetch(`/api/flows/${currentFlowId}`, {
          method: "PUT",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload),
        });
      } else {
        res = await fetch("/api/flows/", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload),
        });
      }
      data = await res.json();
      if (data.success) {
        setOpenFlowSavedDialog(true);
        setOpenFlowDialog(false);
        //setFlowName("");
        //setFlowDescription("");
        if (!currentFlowId && data.id) setCurrentFlowId(data.id);
      } else {
        alert("Error al guardar: " + JSON.stringify(data.detail || data.error || data));
      }
    } catch (err) {
      alert("Error de red o servidor: " + err.message);
    }
};

  // CARGAR LISTA DE FLUJOS GUARDADOS
  const fetchFlows = async (empresaId = null) => {
    let userId = user?.id;
    console.log("[SuperAdmin Debug] user object:", user);
    console.log("[SuperAdmin Debug] user.id:", user?.id);

    if (!userId && user?.uid) {
      // Si es usuario Google, busca el id tradicional usando el uid de Firebase
      const res = await fetch(`/api/users/by_uid/${user.uid}`);
      const data = await res.json();
      userId = data?.id;
      console.log("[SuperAdmin Debug] userId from Firebase:", userId);
    }
    if (!userId) {
      alert("No se pudo determinar el usuario. Intenta recargar la página.");
      return { flows: [], is_superadmin: false };
    }
    try {
      // Construir URL con filtro de empresa opcional
      let url = `/api/flows/?user_id=${userId}`;
      if (empresaId) {
        url += `&empresa_id=${empresaId}`;
      }
      console.log("[SuperAdmin Debug] Llamando a:", url);
      const res = await fetch(url);
      const data = await res.json();
      // La respuesta ahora tiene estructura: { flows: [], is_superadmin: bool, total: int }
      return data;
    } catch (err) {
      alert("Error al cargar flujos: " + err.message);
      return { flows: [], is_superadmin: false };
    }
  };

  // CARGAR LISTA DE EMPRESAS (solo para Super Admin)
  const fetchEmpresas = async () => {
    console.log("[SuperAdmin Debug] fetchEmpresas iniciado");
    let userId = user?.id;
    if (!userId && user?.uid) {
      const res = await fetch(`/api/users/by_uid/${user.uid}`);
      const data = await res.json();
      userId = data?.id;
    }
    if (!userId) {
      console.log("[SuperAdmin Debug] fetchEmpresas: no userId");
      return [];
    }
    try {
      const url = `/api/empresas/?user_id=${userId}`;
      console.log("[SuperAdmin Debug] Llamando empresas:", url);
      const res = await fetch(url);
      console.log("[SuperAdmin Debug] Respuesta empresas status:", res.status);
      if (!res.ok) {
        console.log("[SuperAdmin Debug] Respuesta no OK");
        return [];
      }
      const data = await res.json();
      console.log("[SuperAdmin Debug] Empresas recibidas:", data);
      return data.empresas || [];
    } catch (err) {
      console.error("[SuperAdmin Debug] Error al cargar empresas:", err);
      return [];
    }
  };

  // ABRIR DIALOGO DE CARGA Y TRAER FLUJOS
  const handleOpenLoadDialog = async () => {
    const data = await fetchFlows(selectedEmpresaFilter);
    console.log("[SuperAdmin Debug] Respuesta de fetchFlows:", data);
    console.log("[SuperAdmin Debug] is_superadmin:", data.is_superadmin);
    console.log("[SuperAdmin Debug] Total flows:", data.flows?.length);

    setAvailableFlows(data.flows || []);
    setIsSuperAdmin(data.is_superadmin || false);

    // Si es superadmin, cargar lista de empresas
    if (data.is_superadmin) {
      const listaEmpresas = await fetchEmpresas();
      console.log("[SuperAdmin Debug] Empresas cargadas:", listaEmpresas);
      setEmpresas(listaEmpresas);
    }

    setOpenLoadDialog(true);
  };

  // Manejar cambio de filtro de empresa (para Super Admin)
  const handleEmpresaFilterChange = async (empresaId) => {
    setSelectedEmpresaFilter(empresaId);
    const data = await fetchFlows(empresaId);
    setAvailableFlows(data.flows || []);
  };

  // CARGAR UN FLUJO SELECCIONADO
     
    
   
    
        // En handleLoadFlow, actualiza la inicialización de los nodos:
    
    const handleLoadFlow = (flow) => {
      // Primero actualiza el contexto
      setFlowContextId(flow.id_contexto || (contextOptions[0] && contextOptions[0].id));
      console.log("Cargando flujo con contexto ID:", flow.id_contexto);
      
      // RESETEAR COMPLETAMENTE EL SIMULADOR Y LA CONVERSACIÓN
      setUserName("");
      setUserVariables({});
      
      // Cargar nodos y resetear TODOS los estados del simulador
      const resetNodes = flow.nodes.map(n => {
        const isStartNode = n.node_id === "1";
        
        // Verificar si es el primer nodo después del inicio
        const isFirstAfterStart = flow.edges.some(e => 
          e.source_node_id === "1" && e.target_node_id === n.node_id
        );
        
        return {
          id: n.node_id,
          type: "custom",
          position: { x: n.position_x, y: n.position_y },
          data: {
            type: n.type,
            label: n.label,
            variable: n.variable,
            variables: n.variables ?? [],
            tipo_dato: n.tipo_dato ?? "texto",
            options: n.options,
            onChange: handleNodeDataChange,
            onDelete: handleDeleteNode,
            // RESETEAR COMPLETAMENTE TODOS LOS ESTADOS
            selectedOption: undefined,
            userInput: "",
            respondido: false,
            error: undefined,
            iaResponse: undefined,
            iaExtracted: undefined,
            editingLabel: false,
            // NUEVA LÓGICA: Marcar como mostrado el nodo inicial Y el primer nodo después del inicio
            wasShown: isStartNode || isFirstAfterStart || n.type === "end" 
          },
        };
      });
      
      setNodes(resetNodes);
      setEdges(flow.edges.map(e => ({
        id: `${e.source_node_id}-${e.target_node_id}`,
        source: e.source_node_id,
        target: e.target_node_id,
        sourceHandle: e.source_handle ?? undefined,
        label: e.label ?? "",
        type: e.edge_type ?? "step",
      })));
      setCurrentFlowId(flow.id);
      setFlowName(flow.name || "");
      setFlowDescription(flow.description || "");
      setFlowWhatsappNumber(flow.whatsapp_number || "");
      setOpenLoadDialog(false);
      
      // REINICIAR LA CONVERSACIÓN: Forzar scroll al inicio
      setTimeout(() => {
        if (chatScrollRef.current) {
          chatScrollRef.current.scrollTop = 0;
        }
      }, 100);
    };

  const handleDeleteFlow = async (flowId) => {
    if (!window.confirm("¿Seguro que deseas eliminar este flujo? Esta acción no se puede deshacer.")) return;
    await fetch(`/api/flows/${flowId}`, { method: "DELETE" });
    setAvailableFlows(flows => flows.filter(f => f.id !== flowId));
  };

  const handleConfirmDeleteFlow = async () => {
    if (!flowToDelete) return;
    await fetch(`/api/flows/${flowToDelete.id}`, { method: "DELETE" });
    setAvailableFlows(flows => flows.filter(f => f.id !== flowToDelete.id));
    setFlowToDelete(null);
  };

  const runAssistantStep = (stepIdx, prevNodeId = "1") => {
    const step = assistantSteps[stepIdx];
    if (!step) return;
  
    setAssistantMessages(msgs => [
      ...msgs,
      {
        from: "bot",
        text: step.label,
        options: [
          {
            label: step.confirmText,
            action: () => {
              setAssistantMessages(msgs => [
                ...msgs,
                { from: "user", text: step.confirmText }
              ]);
              setTimeout(() => {
                let newNodeId = null;
                setNodes(nds => {
                  newNodeId = (nds.length + 1).toString();
                  const prevNode = nds.find(n => n.id === prevNodeId) || nds[nds.length - 1];
                  const baseX = prevNode ? prevNode.position.x : 100;
                  const baseY = prevNode ? prevNode.position.y : 100;
                  return [
                    ...nds,
                    {
                      id: newNodeId,
                      type: "custom",
                      position: { x: baseX + 180, y: baseY },
                      data: {
                        type: step.node.type,
                        label: step.node.label,
                        variable: step.node.variable,
                        options: [],
                        onChange: handleNodeDataChange,
                        onDelete: handleDeleteNode,
                      },
                    },
                  ];
                });
                                setEdges(eds => [
                  ...eds,
                  {
                    id: `${prevNodeId}-${newNodeId}`,
                    source: prevNodeId,
                    target: newNodeId,
                    label: "",
                    type: "custom", // <-- Usa tu tipo personalizado
                    markerEnd: {
                      type: "arrowclosed",
                      color: "#22c55e",
                      width: 9,
                      height: 9,
                    },
                    style: { 
                      stroke: "#22c55e", 
                      strokeWidth: 1.0,
                      filter: "drop-shadow(0 1px 2px rgba(99, 102, 241, 0.3))"
                    },
                    animated: false
                  }
                ]);
                // Espera y lanza el siguiente paso si existe
                if (step.next !== null) {
                  setTimeout(() => runAssistantStep(step.next, newNodeId), step.nextDelay);
                } else {
                  setAssistantMessages(msgs => [
                    ...msgs,
                    { from: "bot", text: "¡Listo! ¿Qué deseas agregar ahora?" }
                  ]);
                }
              }, step.nextDelay);
            }
          },
          {
            label: "No, continuar sin este paso",
            action: () => {
              setAssistantMessages(msgs => [
                ...msgs,
                { from: "user", text: "No, continuar sin este paso" }
              ]);
              if (step.next !== null) {
                setTimeout(() => runAssistantStep(step.next, prevNodeId), step.nextDelay);
              } else {
                setAssistantMessages(msgs => [
                  ...msgs,
                  { from: "bot", text: "Perfecto, puedes seguir agregando más preguntas o mensajes a tu flujo." }
                ]);
              }
            }
          }
        ]
      }
    ]);
  };

  // ============================================================================
      // ASISTENTE INTELIGENTE CON IA
      // ============================================================================

      // Función para generar nodos desde la respuesta de IA
      const generateNodesFromAI = (aiNodes) => {
        if (!aiNodes || !Array.isArray(aiNodes) || aiNodes.length === 0) {
          console.warn("generateNodesFromAI: No hay nodos para agregar");
          return;
        }

        // Determinar posición base según nodos existentes
        const existingNodes = nodes || [];
        const hasExistingNodes = existingNodes.length > 0;

        let baseX = 100;
        let baseY = 100;
        let lastNodeId = null;

        if (hasExistingNodes) {
          // Encontrar el nodo más a la derecha para posicionar los nuevos después
          const rightmostNode = existingNodes.reduce((max, n) =>
            n.position.x > max.position.x ? n : max, existingNodes[0]);
          baseX = rightmostNode.position.x;
          baseY = rightmostNode.position.y;
          lastNodeId = rightmostNode.id;
        }

        const newNodes = [];
        const newEdges = [];
        const xOffset = 200; // Espacio horizontal entre nodos
        const yOffset = 15; // Pequeño offset vertical para visualización diagonal

        aiNodes.forEach((aiNode, index) => {
          const newNodeId = String(Date.now() + index + Math.random().toString(36).substr(2, 5));

          // Las opciones deben ser strings con formato "1. texto" para el CustomNode
          const formattedOptions = aiNode.options ? aiNode.options.map((opt, i) => {
            const optText = typeof opt === 'string' ? opt : (opt.label || opt.text || String(opt));
            return `${i + 1}. ${optText}`;
          }) : [];

          const nodeData = {
            type: aiNode.type || "message",
            label: aiNode.label || "",
            variable: aiNode.variable || "",
            options: formattedOptions,
            onChange: handleNodeDataChange,
            onDelete: handleDeleteNode,
          };

          newNodes.push({
            id: newNodeId,
            type: "custom",
            position: {
              x: baseX + xOffset * (index + 1),
              y: baseY + yOffset * index
            },
            data: nodeData,
          });

          // Conectar con el nodo anterior (existente o recién creado)
          const sourceId = index === 0 ? lastNodeId : newNodes[index - 1].id;

          // Solo crear edge si hay un nodo fuente
          if (sourceId) {
            newEdges.push({
              id: `edge-${sourceId}-${newNodeId}`,
              source: sourceId,
              target: newNodeId,
              type: "custom",
              markerEnd: {
                type: "arrowclosed",
                color: "#22c55e",
                width: 9,
                height: 9,
              },
              style: {
                stroke: "#22c55e",
                strokeWidth: 1.0,
                filter: "drop-shadow(0 1px 2px rgba(99, 102, 241, 0.3))"
              },
              animated: false
            });
          }
        });

        console.log(`Agregando ${newNodes.length} nodos desde IA`);
        setNodes(nds => [...nds, ...newNodes]);
        setEdges(eds => [...eds, ...newEdges]);
      };

      // Handler principal del asistente con IA
      const handleAssistantSend = async () => {
        if (!assistantInput.trim() || assistantLoading) return;

        const userMsg = { from: "user", text: assistantInput };
        setAssistantMessages(msgs => [...msgs, userMsg]);
        setAssistantInput("");
        setAssistantLoading(true);

        // Preparar datos del flujo actual para contexto
        const flujoActual = nodes.map(n => ({
          type: n.data.type,
          label: n.data.label,
          variable: n.data.variable
        }));

        try {
          // Obtener token de autenticación
          let token = null;
          if (user?.uid && user.getIdToken) {
            token = await user.getIdToken();
          }

          const headers = {
            "Content-Type": "application/json",
          };
          if (token) {
            headers["Authorization"] = `Bearer ${token}`;
          }
          if (user?.id) {
            headers["X-User-Id"] = String(user.id);
          }

          const response = await fetch("/api/asistente-flujos/", {
            method: "POST",
            headers,
            body: JSON.stringify({
              mensaje: assistantInput.trim() || userMsg.text,
              flujo_actual: flujoActual,
              historial: assistantMessages.slice(-10)
            })
          });

          const data = await response.json();

          if (data.action === "generate_flow" && data.nodes) {
            // La IA quiere generar nodos
            setAssistantMessages(msgs => [
              ...msgs,
              {
                from: "bot",
                text: data.message || "He generado el flujo que solicitaste.",
                options: [
                  {
                    label: "✅ Agregar al canvas",
                    action: () => {
                      generateNodesFromAI(data.nodes);
                      setAssistantMessages(msgs => [
                        ...msgs,
                        { from: "bot", text: `¡Listo! Se agregaron ${data.nodes.length} nodos al canvas. ¿Necesitas algo más?` }
                      ]);
                    }
                  },
                  {
                    label: "🔄 Modificar",
                    action: () => {
                      setAssistantMessages(msgs => [
                        ...msgs,
                        { from: "bot", text: "Descríbeme qué cambios te gustaría hacer al flujo propuesto." }
                      ]);
                    }
                  },
                  {
                    label: "❌ Cancelar",
                    action: () => {
                      setAssistantMessages(msgs => [
                        ...msgs,
                        { from: "bot", text: "Entendido. ¿En qué más puedo ayudarte?" }
                      ]);
                    }
                  }
                ]
              }
            ]);

            // Mostrar preview de los nodos propuestos
            if (data.nodes.length > 0) {
              const previewText = data.nodes.map((n, i) =>
                `${i + 1}. [${n.type}] ${n.label.substring(0, 50)}${n.label.length > 50 ? '...' : ''}`
              ).join('\n');

              setAssistantMessages(msgs => [
                ...msgs,
                { from: "bot", text: `📋 *Nodos propuestos:*\n${previewText}` }
              ]);
            }

          } else if (data.action === "suggest" && data.suggestions) {
            // La IA tiene sugerencias
            setAssistantMessages(msgs => [
              ...msgs,
              {
                from: "bot",
                text: data.message || "Tengo algunas sugerencias:",
                options: data.suggestions.map((sug, i) => ({
                  label: sug.length > 30 ? sug.substring(0, 30) + "..." : sug,
                  action: () => {
                    setAssistantInput(sug);
                  }
                }))
              }
            ]);

          } else if (data.action === "error") {
            // Error de la IA
            setAssistantMessages(msgs => [
              ...msgs,
              { from: "bot", text: data.message || "Hubo un error. Por favor intenta de nuevo." }
            ]);

          } else {
            // Respuesta normal de chat
            setAssistantMessages(msgs => [
              ...msgs,
              { from: "bot", text: data.message || "No entendí tu solicitud. ¿Puedes reformularla?" }
            ]);
          }

        } catch (error) {
          console.error("Error en asistente:", error);
          setAssistantMessages(msgs => [
            ...msgs,
            {
              from: "bot",
              text: "Lo siento, hubo un problema de conexión. ¿Quieres intentar de nuevo?",
              options: [
                { label: "Reintentar", action: () => handleAssistantSend() },
                { label: "Cancelar", action: () => {} }
              ]
            }
          ]);
        } finally {
          setAssistantLoading(false);
        }
      };

      const handleIaQuestion = async (nodeId, question) => {
          setNodes(nds =>
            nds.map(n =>
              n.id === nodeId
                ? { ...n, data: { ...n.data, iaResponse: "Consultando a la IA..." } }
                : n
            )
          );
          try {
            const res = await fetch("/api/chatgpt/", {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({
                prompt: question,
                history: [],
                id_contexto: flowContextId // <-- CAMBIAR DE contexto A id_contexto
              }),
            });
            const data = await res.json();
            setNodes(nds =>
              nds.map(n =>
                n.id === nodeId
                  ? { ...n, data: { ...n.data, iaResponse: data.reply || "Sin respuesta de la IA." } }
                  : n
              )
            );
            // <-- AGREGA AQUÍ LA ACTUALIZACIÓN DE TOKENS
            setLastIaTokens({
              tokens_enviados: data.tokens_enviados,
              tokens_consumidos: data.tokens_consumidos,
              tokens_total: data.tokens_total
            });
          } catch (err) {
            setNodes(nds =>
              nds.map(n =>
                n.id === nodeId
                  ? { ...n, data: { ...n.data, iaResponse: "Error al consultar la IA." } }
                  : n
              )
            );
          }
        };
      
            async function extraerVariablesConIA(texto, variables, contextId = null) {
              console.log("extraerVariablesConIA llamada", texto, variables, contextId);
            
              let token = null;
              let userId = null;
            
              // Usa el estado user, no window.auth ni localStorage
              if (user?.uid && user.getIdToken) {
                token = await user.getIdToken();
              }
              if (user?.id) {
                userId = user.id;
              }
            
              const headers = {
                "Content-Type": "application/json",
                ...(token ? { Authorization: `Bearer ${token}` } : {}),
                ...(userId ? { "X-User-Id": String(userId) } : {})
              };
            
              console.log("userId:", userId, "token:", token);
              console.log("Headers enviados:", headers);
              console.log("typeof variables:", typeof variables, "isArray:", Array.isArray(variables), variables);
              console.log("Body enviado a /extraer_variables/:", { texto, variables, id_contexto: contextId });
              const res = await fetch("/api/extraer_variables/", {
                method: "POST",
                headers,
                body: JSON.stringify({ 
                  texto, 
                  variables,
                  id_contexto: contextId
                })
              });
              const data = await res.json();
              console.log("Respuesta IA:", data);
              setLastIaTokens({
                tokens_enviados: data.tokens_enviados,
                tokens_consumidos: data.tokens_consumidos,
                tokens_total: data.tokens_total
              });
              return data;
            }
     

      // Aquí coloca la función de validación IA:
         async function validarRespuestaConIA(respuesta, tipo) {
      let token = null;
      let userId = null;
    
      // Usa el estado user, no window.auth ni localStorage
      if (user?.uid && user.getIdToken) {
        token = await user.getIdToken();
      }
      if (user?.id) {
        userId = user.id;
      }
    
      const headers = {
        "Content-Type": "application/json",
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
        ...(userId ? { "X-User-Id": String(userId) } : {})
      };
    
      console.log("userId:", userId, "token:", token);
      console.log("Headers enviados:", headers);
      console.log("Body enviado a /validar_respuesta/:", { respuesta: respuesta.trim(), tipo });
    
      const res = await fetch("/api/validar_respuesta/", {
        method: "POST",
        headers,
        body: JSON.stringify({ respuesta: respuesta.trim(), tipo }),
      });
      const data = await res.json();
      return data.valido;
    }


  return (
    <Box
      sx={{
        height: { xs: "100vh", sm: "90vh" }, // Altura adaptativa
        width: "100%",
        background: "#f8fafc",
        p: { xs: 1, sm: 2, md: 3 }, // Padding responsivo
        boxSizing: "border-box",
        overflow: "hidden",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexWrap: "nowrap",
          gap: isMediumScreen ? 0.3 : 1,
          mb: 2,
          alignItems: "center",
          px: isMediumScreen ? 0.5 : 1,
          py: isMediumScreen ? 0.3 : 0.5,
          borderRadius: 3,
          background: "rgba(30,41,59,0.98)",
          boxShadow: "0 2px 12px rgba(56,189,248,0.13)",
          border: "1px solid #334155",
          justifyContent: "flex-start",
          width: "100%",
          overflowX: "auto",
          // Reducir tamaño de elementos en pantallas medianas (< 1920px)
          ...(isMediumScreen && {
            "& .MuiIconButton-root": {
              padding: "4px",
              "& .MuiSvgIcon-root": {
                fontSize: "18px",
              },
            },
            "& .MuiButton-root": {
              padding: "3px 8px",
              fontSize: "10px",
              minHeight: "26px",
              "& .MuiSvgIcon-root": {
                fontSize: "14px",
              },
            },
            "& .MuiDivider-root": {
              mx: 0.3,
            },
          }),
          // Compactar aún más en pantallas pequeñas (<= 1366px)
          "@media (max-width:1366px)": {
            gap: 0.2,
            px: 0.2,
            py: 0.3,
            "& .MuiButton-root, & .MuiIconButton-root": {
              minWidth: 24,
              minHeight: 24,
              padding: "2px 4px",
              fontSize: "9px",
              margin: "0 1px",
            },
            "& .MuiSvgIcon-root": {
              fontSize: "16px !important",
            },
            "& .MuiButton-startIcon, & .MuiButton-endIcon": {
              marginRight: 2,
              marginLeft: 0,
            },
          },

        }}
      >
        {/* Botón de Inicio - Volver al Dashboard */}
        <Tooltip title="Inicio" arrow placement="bottom">
          <IconButton
            onClick={() => navigate("/dashboard")}
            sx={{
              color: "#a5b4fc",
              fontSize: 24,
              background: "none",
              "&:hover": { color: "#fff", background: "none" }
            }}
          >
            <HomeIcon fontSize="inherit" />
          </IconButton>
        </Tooltip>

        <Tooltip title="Deshacer" arrow placement="bottom" enterDelay={300}>
          <span>
            <IconButton
              onClick={handleUndo}
              disabled={undoStack.length === 0}
              sx={{
                color: "#f87171",
                fontSize: 26,
                background: "none",
                "&:hover": { color: "#fff", background: "none" }
              }}
            >
              <ArrowBackIosNewIcon fontSize="inherit" />
            </IconButton>
          </span>
        </Tooltip>

        <Tooltip title="Rehacer" arrow placement="bottom" enterDelay={300}>
          <span>
            <IconButton
              onClick={handleRedo}
              disabled={redoStack.length === 0}
              sx={{
                color: "#34d399",
                fontSize: 26,
                background: "none",
                "&:hover": { color: "#fff", background: "none" }
              }}
            >
              <ArrowForwardIosIcon fontSize="inherit" />
            </IconButton>
          </span>
          </Tooltip>

        {/* Separador entre navegación y operaciones */}
        <Divider orientation="vertical" flexItem sx={{ mx: 1, borderColor: "#475569", height: 24, alignSelf: "center" }} />

        {!editingTemplate && (
          <Tooltip title="Guardar" arrow placement="bottom" enterDelay={300}>
            <IconButton
              onClick={handleSaveToDB}
              sx={{
                color: "#22c55e",
                fontSize: 28,
                ml: 2,
                background: "none",
                "&:hover": { color: "#fff", background: "none" }
              }}
            >
              <SaveIcon fontSize="inherit" />
            </IconButton>
          </Tooltip>
        )}

        {/* Botón AI Agent */}
        <Tooltip title="AI Agent" arrow placement="bottom" enterDelay={300}>
          <IconButton
            onClick={handleOpenAgentDialog}
            sx={{
              color: agentConfig.enabled ? "#a855f7" : "#94a3b8",
              fontSize: 28,
              ml: 1,
              background: "none",
              "&:hover": { color: "#fff", background: "none" }
            }}
          >
            <AutoAwesomeIcon fontSize="inherit" />
          </IconButton>
        </Tooltip>

        <Tooltip title="Cargar flujo" arrow placement="bottom" enterDelay={300}>
          <IconButton
            onClick={handleOpenLoadDialog}
            sx={{
              color: "#fbbf24",
              fontSize: 28,
              ml: 1,
              background: "none",
              "&:hover": { color: "#fff", background: "none" }
            }}
          >
            <FolderSpecialIcon fontSize="inherit" />
          </IconButton>
        </Tooltip>

        <Tooltip title="Nuevo flujo" arrow placement="bottom" enterDelay={300}>
          <IconButton
            onClick={handleNewChatbot}
            sx={{
              color: "#38bdf8",
              fontSize: 28,
              background: "none",
              "&:hover": { color: "#fff", background: "none" }
            }}
          >
            <AddBoxIcon fontSize="inherit" />
          </IconButton>
        </Tooltip>

        {/* Separador entre operaciones y administración */}
        <Divider orientation="vertical" flexItem sx={{ mx: 1, borderColor: "#475569", height: 24, alignSelf: "center" }} />

        {/* === MENÚ ADMINISTRAR === */}
        <Button
          variant="contained"
          size="small"
          endIcon={<ArrowDropDownIcon sx={{ fontSize: isMediumScreen ? "12px" : "16px" }} />}
          onClick={(e) => setAdminMenuAnchor(e.currentTarget)}
          sx={{
            ml: 1,
            background: "linear-gradient(135deg, #6366f1 0%, #4f46e5 100%)",
            color: "#fff",
            fontWeight: 600,
            textTransform: "none",
            fontSize: isMediumScreen ? "9px" : "12px",
            padding: isMediumScreen ? "3px 8px" : "6px 14px",
            borderRadius: isMediumScreen ? "5px" : "8px",
            minWidth: "auto",
            minHeight: isMediumScreen ? "24px" : "32px",
            lineHeight: 1.2,
            boxShadow: "0 2px 8px rgba(99, 102, 241, 0.3)",
            display: "flex",
            alignItems: "center",
            gap: isMediumScreen ? "2px" : "4px",
            transition: "all 0.2s ease",
            "&:hover": {
              background: "linear-gradient(135deg, #4f46e5 0%, #4338ca 100%)",
              boxShadow: "0 4px 12px rgba(99, 102, 241, 0.4)",
              transform: "translateY(-1px)"
            },
            "&:active": {
              transform: "translateY(0)"
            },
            "& .MuiButton-startIcon": {
              marginRight: isMediumScreen ? "2px" : "4px"
            },
            "& .MuiButton-endIcon": {
              marginLeft: isMediumScreen ? "1px" : "2px"
            }
          }}
          startIcon={<TuneIcon sx={{ fontSize: isMediumScreen ? "12px" : "16px" }} />}
        >
          Administrar
        </Button>

        {/* Menú desplegable de Administrar */}
        <Menu
          anchorEl={adminMenuAnchor}
          open={Boolean(adminMenuAnchor)}
          onClose={() => setAdminMenuAnchor(null)}
          anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
          transformOrigin={{ vertical: "top", horizontal: "left" }}
          PaperProps={{
            sx: {
              bgcolor: "#1e293b",
              color: "#fff",
              borderRadius: 2,
              minWidth: 220,
              boxShadow: "0 8px 32px rgba(0,0,0,0.3)",
              border: "1px solid #334155",
              mt: 0.5,
            }
          }}
        >
          {/* Plantillas - siempre visible */}
          <MenuItem
            onClick={() => {
              setOpenTemplateDialog(true);
              setAdminMenuAnchor(null);
            }}
            sx={{
              py: 1.5,
              "&:hover": { bgcolor: "#334155" }
            }}
          >
            <ListItemIcon>
              <InsightsIcon sx={{ color: "#10b981", fontSize: 20 }} />
            </ListItemIcon>
            <Typography variant="body2">Plantillas</Typography>
          </MenuItem>

          {/* Plantillas Globales - solo admin */}
          {user?.empresa?.id && isNaraAdmin && (
            <MenuItem
              onClick={() => {
                fetch("/api/templates/")
                  .then(res => res.json())
                  .then(setAdminTemplates);
                setOpenAdminTemplates(true);
                setAdminMenuAnchor(null);
              }}
              sx={{
                py: 1.5,
                "&:hover": { bgcolor: "#334155" }
              }}
            >
              <ListItemIcon>
                <ContentPasteIcon sx={{ color: "#ec4899", fontSize: 20 }} />
              </ListItemIcon>
              <Typography variant="body2">Plantillas Globales</Typography>
            </MenuItem>
          )}

          <Divider sx={{ borderColor: "#334155", my: 0.5 }} />

          {/* Variables - solo admin */}
          {user?.empresa?.id && isNaraAdmin && (
            <MenuItem
              onClick={() => {
                handleOpenVariablesDialog();
                setAdminMenuAnchor(null);
              }}
              sx={{
                py: 1.5,
                "&:hover": { bgcolor: "#334155" }
              }}
            >
              <ListItemIcon>
                <DataObjectIcon sx={{ color: "#6366f1", fontSize: 20 }} />
              </ListItemIcon>
              <Typography variant="body2">Variables</Typography>
            </MenuItem>
          )}

          {/* Contextos - solo admin */}
          {user?.empresa?.id && isNaraAdmin && (
            <MenuItem
              onClick={() => {
                setOpenContextosDialog(true);
                setAdminMenuAnchor(null);
              }}
              sx={{
                py: 1.5,
                "&:hover": { bgcolor: "#334155" }
              }}
            >
              <ListItemIcon>
                <LanguageIcon sx={{ color: "#14b8a6", fontSize: 20 }} />
              </ListItemIcon>
              <Typography variant="body2">Contextos</Typography>
            </MenuItem>
          )}

          {user?.empresa?.id && isNaraAdmin && (
            <Divider sx={{ borderColor: "#334155", my: 0.5 }} />
          )}

          {/* Mensajes - solo admin */}
          {user?.empresa?.id && isNaraAdmin && (
            <MenuItem
              onClick={(e) => {
                setMensajesMenuAnchor(e.currentTarget);
                setAdminMenuAnchor(null);
              }}
              sx={{
                py: 1.5,
                "&:hover": { bgcolor: "#334155" }
              }}
            >
              <ListItemIcon>
                <ChatIcon sx={{ color: "#f59e0b", fontSize: 20 }} />
              </ListItemIcon>
              <Typography variant="body2">Mensajes</Typography>
            </MenuItem>
          )}

          {/* Preguntas - solo admin */}
          {user?.empresa?.id && isNaraAdmin && (
            <MenuItem
              onClick={() => {
                setOpenPreguntasDialog(true);
                setAdminMenuAnchor(null);
              }}
              sx={{
                py: 1.5,
                "&:hover": { bgcolor: "#334155" }
              }}
            >
              <ListItemIcon>
                <QuestionAnswerIcon sx={{ color: "#8b5cf6", fontSize: 20 }} />
              </ListItemIcon>
              <Typography variant="body2">Preguntas</Typography>
            </MenuItem>
          )}
        </Menu>

        {/* Submenú de Mensajes */}
        <Menu
          anchorEl={mensajesMenuAnchor}
          open={Boolean(mensajesMenuAnchor)}
          onClose={() => setMensajesMenuAnchor(null)}
          anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
          transformOrigin={{ vertical: "top", horizontal: "left" }}
          PaperProps={{
            sx: {
              bgcolor: "#1e293b",
              color: "#fff",
              borderRadius: 2,
              minWidth: 180,
              boxShadow: "0 8px 32px rgba(0,0,0,0.3)",
              border: "1px solid #334155",
            }
          }}
        >
          <MenuItem
            onClick={() => {
              setOpenMensajesDialog(true);
              setMensajesMenuAnchor(null);
            }}
            sx={{
              py: 1.5,
              "&:hover": { bgcolor: "#334155" }
            }}
          >
            Mensajes
          </MenuItem>
          <MenuItem
            onClick={() => {
              setOpenTiposMensajeDialog(true);
              setMensajesMenuAnchor(null);
            }}
            sx={{
              py: 1.5,
              "&:hover": { bgcolor: "#334155" }
            }}
          >
            Tipos de mensaje
          </MenuItem>
        </Menu>

        {/* === MENÚ APLICACIONES === */}
        <Button
          variant="contained"
          size="small"
          endIcon={<ArrowDropDownIcon sx={{ fontSize: isMediumScreen ? "12px" : "16px" }} />}
          onClick={(e) => setAppsMenuAnchor(e.currentTarget)}
          sx={{
            ml: 1,
            background: "linear-gradient(135deg, #0ea5e9 0%, #0284c7 100%)",
            color: "#fff",
            fontWeight: 600,
            textTransform: "none",
            fontSize: isMediumScreen ? "9px" : "12px",
            padding: isMediumScreen ? "3px 8px" : "6px 14px",
            borderRadius: isMediumScreen ? "5px" : "8px",
            minWidth: "auto",
            minHeight: isMediumScreen ? "24px" : "32px",
            lineHeight: 1.2,
            boxShadow: "0 2px 8px rgba(14, 165, 233, 0.3)",
            display: "flex",
            alignItems: "center",
            gap: isMediumScreen ? "2px" : "4px",
            transition: "all 0.2s ease",
            "&:hover": {
              background: "linear-gradient(135deg, #0284c7 0%, #0369a1 100%)",
              boxShadow: "0 4px 12px rgba(14, 165, 233, 0.4)",
              transform: "translateY(-1px)"
            },
            "&:active": {
              transform: "translateY(0)"
            },
            "& .MuiButton-startIcon": {
              marginRight: isMediumScreen ? "2px" : "4px"
            },
            "& .MuiButton-endIcon": {
              marginLeft: isMediumScreen ? "1px" : "2px"
            }
          }}
          startIcon={<AppsIcon sx={{ fontSize: isMediumScreen ? "12px" : "16px" }} />}
        >
          Apps
        </Button>

        {/* Menú desplegable de Aplicaciones */}
        <Menu
          anchorEl={appsMenuAnchor}
          open={Boolean(appsMenuAnchor)}
          onClose={() => setAppsMenuAnchor(null)}
          anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
          transformOrigin={{ vertical: "top", horizontal: "left" }}
          PaperProps={{
            sx: {
              bgcolor: "#1e293b",
              color: "#fff",
              borderRadius: 2,
              minWidth: 220,
              boxShadow: "0 8px 32px rgba(0,0,0,0.3)",
              border: "1px solid #334155",
              mt: 0.5,
            }
          }}
        >
          <MenuItem
            onClick={() => {
              navigate("/emr");
              setAppsMenuAnchor(null);
            }}
            sx={{
              py: 1.5,
              "&:hover": { bgcolor: "#334155" }
            }}
          >
            <ListItemIcon>
              <LocalHospitalIcon sx={{ color: "#10b981", fontSize: 20 }} />
            </ListItemIcon>
            <Typography variant="body2">Expediente Médico</Typography>
          </MenuItem>

          <MenuItem
            onClick={() => {
              navigate("/agenda");
              setAppsMenuAnchor(null);
            }}
            sx={{
              py: 1.5,
              "&:hover": { bgcolor: "#334155" }
            }}
          >
            <ListItemIcon>
              <CalendarMonthIcon sx={{ color: "#0ea5e9", fontSize: 20 }} />
            </ListItemIcon>
            <Typography variant="body2">Agenda de Citas</Typography>
          </MenuItem>

          <MenuItem
            onClick={() => {
              navigate("/analytics");
              setAppsMenuAnchor(null);
            }}
            sx={{
              py: 1.5,
              "&:hover": { bgcolor: "#334155" }
            }}
          >
            <ListItemIcon>
              <AnalyticsIcon sx={{ color: "#8b5cf6", fontSize: 20 }} />
            </ListItemIcon>
            <Typography variant="body2">Analíticas</Typography>
          </MenuItem>

          <Divider sx={{ borderColor: "#334155", my: 0.5 }} />

          <MenuItem
            onClick={() => {
              navigate("/whatsapp");
              setAppsMenuAnchor(null);
            }}
            sx={{
              py: 1.5,
              "&:hover": { bgcolor: "#334155" }
            }}
          >
            <ListItemIcon>
              <WhatsAppIcon sx={{ color: "#25D366", fontSize: 20 }} />
            </ListItemIcon>
            <Typography variant="body2">WhatsApp Manager</Typography>
          </MenuItem>

          <Divider sx={{ borderColor: "#334155", my: 0.5 }} />

          <MenuItem
            onClick={() => {
              navigate("/dashboard");
              setAppsMenuAnchor(null);
            }}
            sx={{
              py: 1.5,
              "&:hover": { bgcolor: "#334155" }
            }}
          >
            <ListItemIcon>
              <HomeIcon sx={{ color: "#f59e0b", fontSize: 20 }} />
            </ListItemIcon>
            <Typography variant="body2">Volver al Dashboard</Typography>
          </MenuItem>
        </Menu>

        {/* === BOTÓN HERRAMIENTAS === */}
        <Button
          variant="contained"
          size="small"
          endIcon={<ArrowDropDownIcon sx={{ fontSize: isMediumScreen ? "12px" : "16px" }} />}
          onClick={(e) => setToolsMenuAnchor(e.currentTarget)}
          sx={{
            ml: 1,
            background: "linear-gradient(135deg, #10b981 0%, #059669 100%)",
            color: "#fff",
            fontWeight: 600,
            textTransform: "none",
            fontSize: isMediumScreen ? "9px" : "12px",
            padding: isMediumScreen ? "3px 8px" : "6px 14px",
            borderRadius: isMediumScreen ? "5px" : "8px",
            minWidth: "auto",
            minHeight: isMediumScreen ? "24px" : "32px",
            lineHeight: 1.2,
            boxShadow: "0 2px 8px rgba(16, 185, 129, 0.3)",
            display: "flex",
            alignItems: "center",
            gap: isMediumScreen ? "2px" : "4px",
            transition: "all 0.2s ease",
            "&:hover": {
              background: "linear-gradient(135deg, #059669 0%, #047857 100%)",
              boxShadow: "0 4px 12px rgba(16, 185, 129, 0.4)",
              transform: "translateY(-1px)"
            },
            "&:active": {
              transform: "translateY(0)"
            },
            "& .MuiButton-startIcon": {
              marginRight: isMediumScreen ? "2px" : "4px"
            },
            "& .MuiButton-endIcon": {
              marginLeft: isMediumScreen ? "1px" : "2px"
            }
          }}
          startIcon={<BuildIcon sx={{ fontSize: isMediumScreen ? "12px" : "16px" }} />}
        >
          Herramientas
        </Button>

        {/* Menú desplegable de Herramientas */}
        <Menu
          anchorEl={toolsMenuAnchor}
          open={Boolean(toolsMenuAnchor)}
          onClose={() => setToolsMenuAnchor(null)}
          anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
          transformOrigin={{ vertical: "top", horizontal: "left" }}
          PaperProps={{
            sx: {
              bgcolor: "#1e293b",
              color: "#fff",
              borderRadius: 2,
              minWidth: 220,
              boxShadow: "0 8px 32px rgba(0,0,0,0.3)",
              border: "1px solid #334155",
              mt: 0.5,
            }
          }}
        >
          {/* Validar Flujo */}
          <MenuItem
            onClick={() => {
              // Función para validar el flujo
              const errors = [];
              const warnings = [];

              // Verificar nodos sin conexiones de entrada (excepto el nodo inicial)
              const nodesWithIncoming = new Set(edges.map(e => e.target));
              nodes.forEach(node => {
                if (node.data.type !== 'start' && !nodesWithIncoming.has(node.id)) {
                  warnings.push(`Nodo "${node.data.label || node.id}" no tiene conexiones de entrada`);
                }
              });

              // Verificar nodos sin conexiones de salida (excepto nodos finales)
              const nodesWithOutgoing = new Set(edges.map(e => e.source));
              nodes.forEach(node => {
                if (node.data.type !== 'end' && !nodesWithOutgoing.has(node.id)) {
                  warnings.push(`Nodo "${node.data.label || node.id}" no tiene conexiones de salida`);
                }
              });

              // Verificar nodos de pregunta sin variable asignada
              nodes.forEach(node => {
                if ((node.data.type === 'open' || node.data.type === 'options') && !node.data.variable) {
                  errors.push(`Nodo "${node.data.label || node.id}" no tiene variable asignada`);
                }
              });

              // Verificar nodos de opciones sin opciones definidas
              nodes.forEach(node => {
                if (node.data.type === 'options' && (!node.data.options || node.data.options.length === 0)) {
                  errors.push(`Nodo "${node.data.label || node.id}" no tiene opciones definidas`);
                }
              });

              setFlowValidationResults({ errors, warnings });
              setToolsMenuAnchor(null);
            }}
            sx={{
              py: 1.5,
              "&:hover": { bgcolor: "#334155" }
            }}
          >
            <ListItemIcon>
              <FactCheckIcon sx={{ color: "#10b981", fontSize: 20 }} />
            </ListItemIcon>
            <Typography variant="body2">Validar Flujo</Typography>
          </MenuItem>

          {/* Estadísticas del Flujo */}
          <MenuItem
            onClick={() => {
              setOpenStatsDialog(true);
              setToolsMenuAnchor(null);
            }}
            sx={{
              py: 1.5,
              "&:hover": { bgcolor: "#334155" }
            }}
          >
            <ListItemIcon>
              <QueryStatsIcon sx={{ color: "#0ea5e9", fontSize: 20 }} />
            </ListItemIcon>
            <Typography variant="body2">Estadísticas del Flujo</Typography>
          </MenuItem>

          <Divider sx={{ borderColor: "#334155", my: 0.5 }} />

          {/* Buscar Nodos */}
          <MenuItem
            onClick={() => {
              const searchTerm = prompt("Buscar nodo por texto:");
              if (searchTerm) {
                const foundNode = nodes.find(n =>
                  n.data.label?.toLowerCase().includes(searchTerm.toLowerCase()) ||
                  n.data.variable?.toLowerCase().includes(searchTerm.toLowerCase())
                );
                if (foundNode && reactFlowInstance) {
                  reactFlowInstance.setCenter(foundNode.position.x, foundNode.position.y, { zoom: 1.5, duration: 500 });
                  setToolsSnackbar({ open: true, message: `Nodo encontrado: ${foundNode.data.label || foundNode.id}`, severity: "success" });
                } else {
                  setToolsSnackbar({ open: true, message: "No se encontró ningún nodo con ese texto", severity: "warning" });
                }
              }
              setToolsMenuAnchor(null);
            }}
            sx={{
              py: 1.5,
              "&:hover": { bgcolor: "#334155" }
            }}
          >
            <ListItemIcon>
              <SearchIcon sx={{ color: "#f59e0b", fontSize: 20 }} />
            </ListItemIcon>
            <Typography variant="body2">Buscar Nodos</Typography>
          </MenuItem>

          {/* Atajos de Teclado */}
          <MenuItem
            onClick={() => {
              setOpenShortcutsDialog(true);
              setToolsMenuAnchor(null);
            }}
            sx={{
              py: 1.5,
              "&:hover": { bgcolor: "#334155" }
            }}
          >
            <ListItemIcon>
              <KeyboardIcon sx={{ color: "#8b5cf6", fontSize: 20 }} />
            </ListItemIcon>
            <Typography variant="body2">Atajos de Teclado</Typography>
          </MenuItem>
        </Menu>

      {editingTemplate && (
  <Box sx={{ display: "flex", gap: 1, ml: 2 }}>
    <Tooltip title="Guardar cambios en plantilla global" arrow>
      <IconButton
        color="success"
        onClick={async () => {
        const updatedTemplate = { ...editingTemplate, nodes, edges };

        // LIMPIA los nodos y edges igual que en el otro botón
        const cleanNodes = (updatedTemplate.nodes || []).map(n => ({
          node_id: n.id,
          type: n.data.type,
          label: n.data.label ?? "",
          variable: n.data.variable ?? "",
          tipo_dato: n.data.tipo_dato ?? "texto",
          options: n.data.options ?? [],
          position_x: Math.round(n.position.x),
          position_y: Math.round(n.position.y),
        }));

        const cleanEdges = (updatedTemplate.edges || []).map(e => ({
          source_node_id: e.source,
          target_node_id: e.target,
          edge_type: e.type ?? "",
          label: e.label ?? "",
          source_handle: e.sourceHandle ?? null,
        }));

        const cleanTemplate = {
          name: updatedTemplate.name,
          description: updatedTemplate.description,
          id_contexto: updatedTemplate.id_contexto || flowContextId, // <-- AGREGA ESTA LÍNEA AQUÍ
          nodes: cleanNodes,
          edges: cleanEdges,
        };

  // (Opcional) log para depuración
  console.log("JSON enviado (barra superior):", JSON.stringify(cleanTemplate, null, 2));
  

        if (updatedTemplate.id) {
          await fetch(`/api/templates/${updatedTemplate.id}`, {
            method: "PUT",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(cleanTemplate),
          });
          setAdminTemplates(arr =>
            arr.map(t =>
              t.id === updatedTemplate.id ? { ...t, ...updatedTemplate } : t
            )
          );
        }
        //setEditingTemplate(null);
        setShowTemplateUpdated(true); // <-- Muestra el Snackbar
        setTimeout(() => setShowTemplateUpdated(false), 5000);
}}

        sx={{ bgcolor: "#22c55e", color: "#fff", "&:hover": { bgcolor: "#16a34a" } }}
      >
        <CheckCircleIcon />
      </IconButton>
    </Tooltip>
    <Tooltip title="Cerrar edición de plantilla global" arrow>
      <IconButton
        color="error"
        onClick={() => {
          setEditingTemplate(null);
          confirmNewChatbot(); // <-- Esto inicia un nuevo chatbot
        }}
        sx={{ bgcolor: "#e11d48", color: "#fff", "&:hover": { bgcolor: "#b91c1c" } }}
      >
        <CancelIcon />
      </IconButton>
    </Tooltip>

    {/* <-- Agrega aquí el botón de publicar */}
    <Tooltip title={editingTemplate.is_public ? "Ya publicada" : "Publicar plantilla global"} arrow>
      <span>
        <IconButton
          color="primary"
          disabled={editingTemplate.is_public}
          
          onClick={async () => {
            //const nodes = editingTemplate.nodes || [];
            //const edges = editingTemplate.edges || [];
            // <-- AQUÍ PON EL CÓDIGO DE DEPURACIÓN
            const nodosSinLabel = nodes.filter(n => !n.data?.label || !n.data.label.trim());
            if (nodosSinLabel.length > 0) {
              console.log("Nodos sin label:", nodosSinLabel);
            }
          
            // 1. Al menos 8 nodos
            if (nodes.length < 8) {
              setPublishErrorMsg("La plantilla debe tener al menos 10 nodos.");
              setOpenPublishError(true);
              return;
            }
          
                      
            // Si pasa todas las validaciones, publica
            await fetch(`/api/templates/${editingTemplate.id}/publicar`, {
              method: "POST",
              headers: { "Content-Type": "application/json" },
            });
            setEditingTemplate(et => ({ ...et, is_public: true }));
            setAdminTemplates(arr =>
              arr.map(t =>
                t.id === editingTemplate.id ? { ...t, is_public: true } : t
              )
            );
          }}


          sx={{
            bgcolor: editingTemplate.is_public ? "#a7f3d0" : "#6366f1",
            color: editingTemplate.is_public ? "#334155" : "#fff",
            "&:hover": { bgcolor: "#22c55e" }
          }}
        >
          <CheckCircleIcon />
        </IconButton>
      </span>
    </Tooltip>    

  </Box>
)}

        {/* Separador entre administración y utilidades */}
        <Divider orientation="vertical" flexItem sx={{ mx: 1, borderColor: "#475569", height: 24, alignSelf: "center" }} />


        <Tooltip title="Facturación" arrow placement="bottom" enterDelay={300}>
          <IconButton
            sx={{
              color: "#34b1f0",
              fontSize: 28,
              background: "none",
              "&:hover": { color: "#fff", background: "none" }
            }}
            onClick={handleBillingMenuOpen}
          >
            <AccountBalanceWalletIcon fontSize="inherit" />
          </IconButton>
        </Tooltip>

        <Menu
           anchorEl={anchorBillingMenu}
           open={Boolean(anchorBillingMenu)}
           onClose={handleBillingMenuClose}
           anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
           transformOrigin={{ vertical: "top", horizontal: "left" }}
        >
          <MenuItem onClick={handleBillingMenuClose}>Planes y Precios</MenuItem>
          <MenuItem 
            onClick={async () => {
              handleBillingMenuClose();
              await fetchSubscriptionInfo();
              setOpenSubscriptionDialog(true);
            }}  
          >
            Suscripción
          </MenuItem>
          <MenuItem onClick={handleBillingMenuClose}>Facturas</MenuItem>
        </Menu> 
        
        <Tooltip title="Acercar" arrow placement="bottom" enterDelay={300}>
          <span>
            <IconButton
              size="small"
              onClick={() => reactFlowInstance && reactFlowInstance.zoomIn()}
              disabled={!reactFlowInstance}
              sx={{
                background: "transparent",
                color: "#fff",
                "&:hover": { background: "#334155", color: "#fbbf24" },
                p: 0.5,
                ml: 1
              }}
            >
              <ZoomInIcon fontSize="small" />
            </IconButton>
          </span>
        </Tooltip>

        <Tooltip title="Alejar" arrow placement="bottom" enterDelay={300}>
          <span>
            <IconButton
              size="small"
              onClick={() => reactFlowInstance && reactFlowInstance.zoomOut()}
              disabled={!reactFlowInstance}
              sx={{
                background: "transparent",
                color: "#fff",
                "&:hover": { background: "#334155", color: "#fbbf24" },
                p: 0.5,
              }}
            >
              <ZoomOutIcon fontSize="small" />
            </IconButton>
          </span>
        </Tooltip>

        <Tooltip title="Centrar" arrow placement="bottom" enterDelay={300}>
          <span>
            <IconButton
              size="small"
              onClick={() => reactFlowInstance && reactFlowInstance.fitView()}
              disabled={!reactFlowInstance}
              sx={{
                background: "transparent",
                color: "#fff",
                "&:hover": { background: "#334155", color: "#fbbf24" },
                p: 0.5,
              }}
            >
              <CenterFocusStrongIcon fontSize="small" />
            </IconButton>
          </span>
        </Tooltip>

        <Tooltip title="Vista 100%" arrow placement="bottom" enterDelay={300}>
          <span>
            <IconButton
              size="small"
              onClick={() => reactFlowInstance && reactFlowInstance.fitView()}
              disabled={!reactFlowInstance}
              sx={{
                background: "transparent",
                color: "#fff",
                "&:hover": { background: "#334155", color: "#fbbf24" },
                p: 0.5,
                  }}
                >
                  <span style={{ fontWeight: 700, fontSize: 13 }}>100%</span>
                </IconButton>
              </span>
            </Tooltip>
          
        
        {/* Avatar de usuario */}
        {user && (
          <>
            <IconButton onClick={handleAvatarClick} sx={{ ml: 2 }}>
              <Avatar
                src={firebasePhotoURL || user.photoURL || ""}
                alt={user.displayName || user.email || "Perfil"}
                sx={{ width: 36, height: 36, bgcolor: "#6366f1", fontSize: 18 }}
                imgProps={{ referrerPolicy: "no-referrer" }}
              >
                {user.displayName ? user.displayName[0] : (user.email ? user.email[0] : "U")}
              </Avatar>
            </IconButton>
            <Menu
              anchorEl={anchorUserMenu}
              open={Boolean(anchorUserMenu)}
              onClose={handleUserMenuClose}
              anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
              transformOrigin={{ vertical: "top", horizontal: "right" }}
              TransitionComponent={Fade}
              transitionDuration={200}
              PaperProps={{
                elevation: 0,
                sx: {
                  overflow: "visible",
                  filter: "drop-shadow(0px 4px 20px rgba(0, 0, 0, 0.1))",
                  mt: 1.5,
                  borderRadius: 3,
                  border: "1px solid #e2e8f0",
                  minWidth: 240,
                  "&:before": {
                    content: '""',
                    display: "block",
                    position: "absolute",
                    top: 0,
                    right: 20,
                    width: 12,
                    height: 12,
                    bgcolor: "background.paper",
                    transform: "translateY(-50%) rotate(45deg)",
                    zIndex: 0,
                    borderLeft: "1px solid #e2e8f0",
                    borderTop: "1px solid #e2e8f0",
                  },
                },
              }}
            >
              {/* Header del usuario */}
              <Box sx={{ px: 2.5, py: 2, background: "linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%)" }}>
                <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
                  <Avatar
                    src={firebasePhotoURL || user.photoURL || ""}
                    alt={user.displayName || user.email || "Perfil"}
                    sx={{
                      width: 44,
                      height: 44,
                      bgcolor: "#6366f1",
                      border: "2px solid #fff",
                      boxShadow: "0 2px 8px rgba(99, 102, 241, 0.25)"
                    }}
                    imgProps={{ referrerPolicy: "no-referrer" }}
                  >
                    {user.displayName ? user.displayName[0] : (user.email ? user.email[0] : "U")}
                  </Avatar>
                  <Box sx={{ flex: 1, minWidth: 0 }}>
                    <Box sx={{
                      fontWeight: 700,
                      fontSize: 14,
                      color: "#1e293b",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap"
                    }}>
                      {user.displayName || "Usuario"}
                    </Box>
                    <Box sx={{
                      fontSize: 12,
                      color: "#64748b",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap"
                    }}>
                      {user.email}
                    </Box>
                  </Box>
                </Box>
              </Box>

              <Divider sx={{ borderColor: "#e2e8f0" }} />

              {/* Opciones del menú */}
              <Box sx={{ py: 1 }}>
                <MenuItem
                  onClick={async() => {
                    await fetchUserProfile();
                    setOpenProfileDialog(true);
                    handleUserMenuClose();
                  }}
                  sx={{
                    py: 1.5,
                    px: 2.5,
                    gap: 1.5,
                    transition: "all 0.15s ease",
                    "&:hover": {
                      background: "linear-gradient(135deg, #e0e7ff 0%, #ede9fe 100%)",
                    }
                  }}
                >
                  <Box sx={{
                    width: 32,
                    height: 32,
                    borderRadius: 1.5,
                    background: "#e0e7ff",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center"
                  }}>
                    <PersonOutlineIcon sx={{ fontSize: 18, color: "#6366f1" }} />
                  </Box>
                  <Box>
                    <Box sx={{ fontWeight: 600, fontSize: 14, color: "#334155" }}>
                      Ver perfil
                    </Box>
                    <Box sx={{ fontSize: 11, color: "#94a3b8" }}>
                      Configuración y horarios
                    </Box>
                  </Box>
                </MenuItem>

                <MenuItem
                  onClick={handleLogout}
                  sx={{
                    py: 1.5,
                    px: 2.5,
                    gap: 1.5,
                    transition: "all 0.15s ease",
                    "&:hover": {
                      background: "linear-gradient(135deg, #fee2e2 0%, #fef2f2 100%)",
                    }
                  }}
                >
                  <Box sx={{
                    width: 32,
                    height: 32,
                    borderRadius: 1.5,
                    background: "#fee2e2",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center"
                  }}>
                    <LogoutIcon sx={{ fontSize: 18, color: "#dc2626" }} />
                  </Box>
                  <Box>
                    <Box sx={{ fontWeight: 600, fontSize: 14, color: "#334155" }}>
                      Cerrar sesión
                    </Box>
                    <Box sx={{ fontSize: 11, color: "#94a3b8" }}>
                      Salir de la cuenta
                    </Box>
                  </Box>
                </MenuItem>
              </Box>
            </Menu>
          </>
        )}
      </Box>
            {nodes.length > 0 && !editingTemplate && (
                <Box
          sx={{
            mt: 1,
            mb: 2,
            px: 2.5,
            py: 1,
            borderRadius: 2,
            background: "#f1f5f9",
            color: "#6366f1",
            fontWeight: 700,
            fontSize: 16,
            display: "flex",
            alignItems: "center",
            gap: 1.5,
            boxShadow: "0 1px 6px #6366f122",
            border: "1.5px solid #e0e7ef"
          }}
        >
          <span role="img" aria-label="edit" style={{ fontSize: 16 }}>✏️</span>
          <span>
            Editando: <span style={{ color: "#334155" }}>{flowName || "Flujo sin nombre"}</span>
            {contextOptions.length > 0 && (
              <span style={{
                color: "#10b981",
                fontWeight: 600,
                marginLeft: 12,
                fontSize: 16
              }}>
                Contexto: {
                      flowName
                        ? (contextOptions.find(opt => opt.id === flowContextId)?.nombre || "Sin contexto")
                        : "Sin contexto"
                    }
              </span>
            )}
          </span>
        </Box>
      )}

            {editingTemplate && (
        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
            mt: 1,
            mb: 1,
            pr: 4,
            color: "#6366f1",
            fontWeight: 700,
            fontSize: 17,
            letterSpacing: 0.5,
            textAlign: "right",
          }}
        >
          <span style={{ background: "#f1f5f9", borderRadius: 8, padding: "6px 18px", border: "1.5px solid #e0e7ef", boxShadow: "0 1px 6px #6366f122" }}>
            <span style={{ marginRight: 8 }}>📝</span>
            Editando plantilla global:&nbsp;
            <span style={{ color: "#334155" }}>{editingTemplate.name || "Sin nombre"}</span>
          </span>
        </Box>
      )}


      {/* --- Menú lateral drag-and-drop (Rediseñado) --- */}
      <Box
        sx={{
          position: "fixed",
          left: menuPos.x,
          top: menuPos.y,
          zIndex: 100,
          background: "linear-gradient(180deg, #1e293b 0%, #0f172a 100%)",
          borderRadius: 3,
          boxShadow: "0 8px 32px rgba(0,0,0,0.3), 0 0 0 1px rgba(99,102,241,0.3)",
          display: "flex",
          flexDirection: "column",
          userSelect: "none",
          overflowY: "auto",
          "&::-webkit-scrollbar": { width: 4 },
          "&::-webkit-scrollbar-thumb": { background: "#475569", borderRadius: 2 },

          // ===== PANTALLAS GRANDES (1920x1080+) =====
          width: 165,
          maxHeight: "70vh",
          p: 1.5,
          gap: 0.5,

          // ===== PANTALLAS MEDIANAS (1366x768 - 1919x1079) =====
          "@media (max-width: 1919px)": {
            width: 145,
            maxHeight: "60vh",
            p: 1,
            gap: 0.4,
          },

          // ===== PANTALLAS MEDIANAS-BAJAS (1280x720 - 1365x767) =====
          "@media (max-width: 1365px)": {
            width: 130,
            maxHeight: "55vh",
            p: 0.8,
            gap: 0.3,
          },

          // ===== PANTALLAS PEQUEÑAS / TABLETS (< 1280px) =====
          "@media (max-width: 1279px)": {
            width: 120,
            maxHeight: "50vh",
            p: 0.75,
            gap: 0.3,
          },

          // ===== TABLETS PEQUEÑAS / MÓVILES GRANDES (< 1024px) =====
          "@media (max-width: 1023px)": {
            width: 110,
            maxHeight: "45vh",
            p: 0.5,
            gap: 0.25,
          },
        }}
      >
        {/* Header arrastrable */}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: 1,
            cursor: "move",
            background: draggingMenu ? "rgba(99,102,241,0.3)" : "rgba(99,102,241,0.15)",
            borderRadius: 2,
            py: 0.8,
            mb: 0.5,
            transition: "background 0.2s",
            "&:hover": { background: "rgba(99,102,241,0.25)" },
            // Responsivo
            "@media (max-width: 1919px)": { py: 0.6, mb: 0.4 },
            "@media (max-width: 1365px)": { py: 0.5, mb: 0.3 },
          }}
          onMouseDown={handleMenuMouseDown}
        >
          <Box sx={{
            width: 24, height: 3, background: "#6366f1", borderRadius: 2, opacity: 0.7,
            "@media (max-width: 1919px)": { width: 18 },
            "@media (max-width: 1365px)": { width: 14 },
          }} />
          <Typography sx={{
            fontWeight: 700, color: "#a5b4fc", fontSize: 11, letterSpacing: 1, textTransform: "uppercase",
            "@media (max-width: 1919px)": { fontSize: 10 },
            "@media (max-width: 1365px)": { fontSize: 9, letterSpacing: 0.5 },
          }}>
            Nodos
          </Typography>
          <Box sx={{
            width: 24, height: 3, background: "#6366f1", borderRadius: 2, opacity: 0.7,
            "@media (max-width: 1919px)": { width: 18 },
            "@media (max-width: 1365px)": { width: 14 },
          }} />
        </Box>

        {/* Lista de nodos */}
        {nodeTypeMenu.map((nt, index) => {
          // Colores por categoría de nodo
          const nodeColors = {
            open: { bg: "#3b82f6", hover: "#2563eb" },
            options: { bg: "#8b5cf6", hover: "#7c3aed" },
            message: { bg: "#f59e0b", hover: "#d97706" },
            input_ia: { bg: "#10b981", hover: "#059669" },
            verificar_cliente: { bg: "#06b6d4", hover: "#0891b2" },
            image_input: { bg: "#ec4899", hover: "#db2777" },
            image_analysis: { bg: "#f43f5e", hover: "#e11d48" },
            end: { bg: "#64748b", hover: "#475569" },
            agendar_cita: { bg: "#22c55e", hover: "#16a34a" },
            verificar_datos: { bg: "#14b8a6", hover: "#0d9488" },
            escalacion_humano: { bg: "#a855f7", hover: "#9333ea" },
          };
          const colors = nodeColors[nt.type] || { bg: "#6366f1", hover: "#4f46e5" };

          return (
            <Tooltip
              key={nt.type}
              title={nt.label}
              placement="left"
              arrow
              enterDelay={300}
            >
              <Box
                draggable
                onDragStart={e => e.dataTransfer.setData("application/nodetype", nt.type)}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                  background: "rgba(255,255,255,0.05)",
                  borderRadius: 1.5,
                  px: 1,
                  py: 0.6,
                  cursor: "grab",
                  transition: "all 0.15s ease",
                  border: "1px solid transparent",
                  "&:hover": {
                    background: `${colors.bg}20`,
                    borderColor: `${colors.bg}50`,
                    transform: "translateX(2px)",
                  },
                  "&:active": {
                    cursor: "grabbing",
                    transform: "scale(0.98)",
                  }
                }}
              >
                {/* Icono con color */}
                <Box sx={{
                  width: 26,
                  height: 26,
                  borderRadius: 1,
                  background: `linear-gradient(135deg, ${colors.bg} 0%, ${colors.hover} 100%)`,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: 13,
                  flexShrink: 0,
                  boxShadow: `0 2px 6px ${colors.bg}40`,
                  // Responsivo
                  "@media (max-width: 1919px)": { width: 22, height: 22, fontSize: 11 },
                  "@media (max-width: 1365px)": { width: 20, height: 20, fontSize: 10 },
                  "@media (max-width: 1023px)": { width: 18, height: 18, fontSize: 9 },
                }}>
                  {nt.emoji}
                </Box>
                {/* Texto */}
                <Typography sx={{
                  fontWeight: 500,
                  color: "#e2e8f0",
                  fontSize: 11,
                  lineHeight: 1.2,
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                  // Responsivo
                  "@media (max-width: 1919px)": { fontSize: 10 },
                  "@media (max-width: 1365px)": { fontSize: 9 },
                  "@media (max-width: 1023px)": { fontSize: 8 },
                }}>
                  {nt.label}
                </Typography>
              </Box>
            </Tooltip>
          );
        })}

        {/* Footer decorativo */}
        <Box sx={{
          mt: 0.5,
          pt: 1,
          borderTop: "1px solid rgba(99,102,241,0.2)",
          display: "flex",
          justifyContent: "center"
        }}>
          <Typography sx={{ fontSize: 9, color: "#64748b", letterSpacing: 0.5 }}>
            Arrastra al canvas
          </Typography>
        </Box>

        {/* Botón para abrir panel de emojis */}
        <Box
          onClick={() => setShowEmojiPanel(!showEmojiPanel)}
          sx={{
            mt: 1,
            py: 0.8,
            px: 1,
            background: showEmojiPanel
              ? "linear-gradient(135deg, #fbbf24 0%, #f59e0b 100%)"
              : "rgba(251,191,36,0.15)",
            borderRadius: 2,
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: 1,
            transition: "all 0.2s",
            border: "1px solid rgba(251,191,36,0.3)",
            "&:hover": {
              background: showEmojiPanel
                ? "linear-gradient(135deg, #f59e0b 0%, #d97706 100%)"
                : "rgba(251,191,36,0.25)",
              transform: "scale(1.02)",
            }
          }}
        >
          <span style={{ fontSize: 16 }}>😊</span>
          <Typography sx={{
            fontWeight: 600,
            color: showEmojiPanel ? "#1e293b" : "#fbbf24",
            fontSize: 11,
          }}>
            Emojis
          </Typography>
        </Box>

        {/* Panel de emojis expandible */}
        {showEmojiPanel && (
          <Box sx={{
            mt: 1,
            background: "rgba(255,255,255,0.05)",
            borderRadius: 2,
            p: 1,
            maxHeight: 200,
            overflowY: "auto",
            "&::-webkit-scrollbar": { width: 4 },
            "&::-webkit-scrollbar-thumb": { background: "#fbbf24", borderRadius: 2 },
          }}>
            {emojiCategories.map((cat) => (
              <Box key={cat.name} sx={{ mb: 1 }}>
                <Typography sx={{
                  fontSize: 9,
                  color: "#94a3b8",
                  fontWeight: 600,
                  textTransform: "uppercase",
                  letterSpacing: 0.5,
                  mb: 0.5
                }}>
                  {cat.name}
                </Typography>
                <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.3 }}>
                  {cat.emojis.map((emoji, idx) => (
                    <Box
                      key={`${cat.name}-${idx}`}
                      onClick={() => handleCopyEmoji(emoji)}
                      sx={{
                        width: 24,
                        height: 24,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontSize: 14,
                        cursor: "pointer",
                        borderRadius: 1,
                        background: emojiCopied === emoji ? "#22c55e" : "transparent",
                        transition: "all 0.15s",
                        "&:hover": {
                          background: "rgba(251,191,36,0.3)",
                          transform: "scale(1.2)",
                        },
                      }}
                      title={emojiCopied === emoji ? "¡Copiado!" : "Clic para copiar"}
                    >
                      {emoji}
                    </Box>
                  ))}
                </Box>
              </Box>
            ))}
            <Typography sx={{
              fontSize: 8,
              color: "#64748b",
              textAlign: "center",
              mt: 1,
              pt: 1,
              borderTop: "1px solid rgba(255,255,255,0.1)"
            }}>
              Clic para copiar, luego pega en el nodo
            </Typography>
          </Box>
        )}
      </Box>

      <Box
        sx={{
          height: "100%",
          width: "100%",
          minHeight: 500,
          position: "relative",
          background: "#2a303c",
        }}
        className="rf-background-milimetrado"
        onDrop={onDropNodeType}
        onDragOver={onDragOverNodeType}
      >
      <ReactFlow
        nodes={nodes}
        edges={edges}
        onNodesChange={onNodesChange}
        onEdgesChange={onEdgesChange}
        onConnect={onConnect}
        nodeTypes={nodeTypes}
        edgeTypes={edgeTypes}  // Añade los tipos de edge
        fitView
        minZoom={0.2}
        maxZoom={2}
        onInit={setReactFlowInstance}
        defaultEdgeOptions={{
          type: "custom",
          markerEnd: {
            type: "arrowclosed",
            color: "#cbd5e1",
            width: 8,
            height: 8,
          },
          style: {
            stroke: "#cbd5e1",
            strokeWidth: 1,
          },
          animated: false
        }}
        edgeUpdaterRadius={10}
        edgesFocusable={true}

        

        onEdgeClick={(event, edge) => {
          console.log("Edge clicked:", edge.id); // Añade este log para depuración
          pushToUndoStack();
          setEdges(eds => 
            eds.map(e => ({
              ...e,
              animated: e.id === edge.id,
              selected: e.id === edge.id
            }))
          );
        }}

        


        onPaneClick={() => {
          setEdges(eds => 
            eds.map(e => ({
              ...e,
              animated: false,
              selected: false
            }))
          );
        }}
      >
        
        
        <Background
          gap={5}         // tamaño de la cuadrícula
          size={0.01}         // grosor de la línea
          color="#4c4c4dff"  // color de la cuadrícula
          variant="lines"  // o "dots"
          background="rgba(23, 66, 136, 0.98)"
        />
      </ReactFlow>
      
    

        



        {/* ===== SIMULADOR DE CELULAR ESTILO WHATSAPP ===== */}
        <Box sx={{
          position: "absolute",
          top: 12,
          right: 12,
          zIndex: 10,
          // Ocultar en móviles pequeños
          display: { xs: "none", sm: "block" },
        }}>
          <Box
            className="simulador-celular"
            sx={{
              position: "relative",
              background: "#000",
              overflow: "hidden",
              display: "flex",
              flexDirection: "column",
              transition: "all 0.3s ease",
              boxShadow: "0 20px 40px -12px rgba(0, 0, 0, 0.4), 0 0 0 1px rgba(255,255,255,0.1) inset",

              // ===== PANTALLAS GRANDES (1920x1080+) =====
              width: 280,
              height: 560,
              borderRadius: "36px",
              border: "6px solid #1a1a1a",

              // ===== PANTALLAS MEDIANAS (1366x768 - 1919x1079) =====
              "@media (max-width: 1919px)": {
                width: 180,
                height: 360,
                borderRadius: "24px",
                border: "4px solid #1a1a1a",
              },

              // ===== PANTALLAS MEDIANAS-BAJAS (1280x720 - 1365x767) =====
              "@media (max-width: 1365px)": {
                width: 200,
                height: 400,
                borderRadius: "24px",
                border: "4px solid #1a1a1a",
              },

              // ===== PANTALLAS PEQUEÑAS / TABLETS (< 1280px) =====
              "@media (max-width: 1279px)": {
                width: 180,
                height: 360,
                borderRadius: "22px",
                border: "4px solid #1a1a1a",
              },

              // ===== TABLETS PEQUEÑAS / MÓVILES GRANDES (< 1024px) =====
              "@media (max-width: 1023px)": {
                width: 160,
                height: 320,
                borderRadius: "20px",
                border: "3px solid #1a1a1a",
              },
            }}
          >
            {/* ===== BARRA DE ESTADO iOS ===== */}
            <Box sx={{
              height: "6%",
              minHeight: "22px",
              width: "100%",
              background: "#075E54",
              display: "flex",
              alignItems: "flex-end",
              justifyContent: "space-between",
              px: 1,
              pb: 0.3,
              position: "relative",
            }}>
              {/* Hora */}
              <Box sx={{ fontSize: "clamp(8px, 1.8vw, 11px)", fontWeight: 600, color: "#fff" }}>
                {new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
              </Box>
              {/* Dynamic Island / Notch */}
              <Box sx={{
                position: "absolute",
                top: "15%",
                left: "50%",
                transform: "translateX(-50%)",
                width: "40%",
                height: "60%",
                maxWidth: "80px",
                background: "#000",
                borderRadius: "14px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}>
                <Box sx={{ width: 5, height: 5, borderRadius: "50%", background: "#1a1a1a", border: "1px solid #333" }} />
              </Box>
              {/* Iconos de estado */}
              <Box sx={{ display: "flex", alignItems: "center", gap: 0.3, justifyContent: "flex-end" }}>
                <Box sx={{ fontSize: "clamp(6px, 1.5vw, 9px)", color: "#fff" }}>5G</Box>
                <Box sx={{ width: "clamp(10px, 2.5vw, 14px)", height: "clamp(6px, 1.5vw, 8px)", border: "1px solid #fff", borderRadius: 1, position: "relative" }}>
                  <Box sx={{ position: "absolute", right: 1, top: 1, bottom: 1, width: "80%", background: "#4ade80", borderRadius: 0.5 }} />
                </Box>
              </Box>
            </Box>

            {/* ===== HEADER WHATSAPP ===== */}
            <Box sx={{
              height: "8%",
              minHeight: "32px",
              width: "100%",
              background: "#075E54",
              display: "flex",
              alignItems: "center",
              px: 0.5,
              gap: 0.5,
            }}>
              {/* Botón volver + Avatar */}
              <Box sx={{ display: "flex", alignItems: "center", gap: 0.3 }}>
                <Box sx={{ color: "#fff", fontSize: "clamp(12px, 3vw, 16px)", cursor: "pointer" }}>‹</Box>
                <Avatar
                  sx={{
                    width: "clamp(22px, 5vw, 32px)",
                    height: "clamp(22px, 5vw, 32px)",
                    background: "linear-gradient(135deg, #25D366 0%, #128C7E 100%)",
                    fontSize: "clamp(10px, 2.5vw, 14px)",
                    fontWeight: 600,
                  }}
                >
                  {flowName ? flowName.charAt(0).toUpperCase() : "N"}
                </Avatar>
              </Box>

              {/* Info del contacto */}
              <Box sx={{ flex: 1, minWidth: 0 }}>
                <Box sx={{
                  fontSize: "clamp(10px, 2.2vw, 13px)",
                  fontWeight: 600,
                  color: "#fff",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}>
                  {flowName || "NARA Bot"}
                </Box>
                <Box sx={{
                  fontSize: "clamp(7px, 1.8vw, 10px)",
                  color: "rgba(255,255,255,0.7)",
                }}>
                  {chatLoading ? "escribiendo..." : "en línea"}
                </Box>
              </Box>

              {/* Iconos de acción */}
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <Tooltip title="Nueva conversación" arrow>
                  <IconButton
                    size="small"
                    onClick={resetearSimuladorBackend}
                    sx={{
                      color: "#fff",
                      p: 0.3,
                      "&:hover": { background: "rgba(255,255,255,0.1)" },
                    }}
                  >
                    <RestartAltIcon sx={{ fontSize: "clamp(14px, 3vw, 18px)" }} />
                  </IconButton>
                </Tooltip>
              </Box>
            </Box>

            {/* ===== BARRA DE CONFIGURACIÓN SIMULADOR ===== */}
            <Box sx={{
              height: "5%",
              minHeight: "18px",
              width: "100%",
              background: "#f0f2f5",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              borderBottom: "1px solid #e9edef",
            }}>
              <Box sx={{
                display: "flex",
                alignItems: "center",
                gap: 0.3,
                background: simularClienteExiste ? "#dcf8c6" : "#fff3cd",
                px: 0.8,
                py: 0.1,
                borderRadius: 8,
                cursor: "pointer",
                transition: "all 0.2s ease",
                "&:hover": { transform: "scale(1.02)" },
              }}
              onClick={() => setSimularClienteExiste(!simularClienteExiste)}
              >
                <Box sx={{
                  width: 5,
                  height: 5,
                  borderRadius: "50%",
                  background: simularClienteExiste ? "#25D366" : "#ffc107",
                }} />
                <Box sx={{ fontSize: "clamp(7px, 1.6vw, 9px)", fontWeight: 500, color: "#333", whiteSpace: "nowrap" }}>
                  {simularClienteExiste ? "Registrado" : "Nuevo"}
                </Box>
              </Box>
            </Box>
            {/* ===== ÁREA DE CHAT ===== */}
            <Box
              ref={chatScrollRef}
              sx={{
                flex: 1,
                width: "100%",
                p: 0.5,
                overflowY: "auto",
                overflowX: "hidden",
                background: "#efeae2",
                backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='100' height='100' viewBox='0 0 100 100'%3E%3Cg fill-opacity='0.03'%3E%3Cpath fill='%23000' d='M11 18c3.866 0 7-3.134 7-7s-3.134-7-7-7-7 3.134-7 7 3.134 7 7 7zm48 25c3.866 0 7-3.134 7-7s-3.134-7-7-7-7 3.134-7 7 3.134 7 7 7zm-43-7c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zm63 31c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zM34 90c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zm56-76c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zM12 86c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm28-65c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm23-11c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm-6 60c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm29 22c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zM32 63c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm57-13c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm-9-21c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2zM60 91c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2zM35 41c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2z'/%3E%3C/g%3E%3C/svg%3E")`,
                "&::-webkit-scrollbar": {
                  width: 3,
                },
                "&::-webkit-scrollbar-thumb": {
                  background: "rgba(0,0,0,0.2)",
                  borderRadius: 3,
                },
              }}
            >
              {/* Mensaje inicial si no hay historial */}
              {chatHistory.length === 0 && (
                <Box sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  height: "100%",
                  textAlign: "center",
                }}>
                  <Box sx={{
                    background: "rgba(255,255,255,0.9)",
                    borderRadius: 1.5,
                    p: 1,
                    boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
                  }}>
                    <Box sx={{
                      width: "clamp(28px, 8vw, 48px)",
                      height: "clamp(28px, 8vw, 48px)",
                      borderRadius: "50%",
                      background: "linear-gradient(135deg, #25D366 0%, #128C7E 100%)",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      mx: "auto",
                      mb: 0.75,
                    }}>
                      <WhatsAppIcon sx={{ fontSize: "clamp(16px, 4vw, 26px)", color: "#fff" }} />
                    </Box>
                    <Box sx={{ fontSize: "clamp(9px, 2vw, 12px)", fontWeight: 600, color: "#1f2937", mb: 0.25 }}>
                      {currentFlowId ? "Prueba tu flujo" : "Guarda primero"}
                    </Box>
                    <Box sx={{ fontSize: "clamp(7px, 1.6vw, 10px)", color: "#667781" }}>
                      {currentFlowId
                        ? "Escribe para comenzar"
                        : "Guarda el flujo primero"
                      }
                    </Box>
                  </Box>
                </Box>
              )}

              {/* Historial de mensajes */}
              {chatHistory.map((msg, idx) => (
                <Box
                  key={idx}
                  sx={{
                    display: "flex",
                    justifyContent: msg.from === "user" ? "flex-end" : "flex-start",
                    mb: 0.3,
                    px: 0.25,
                    animation: "fadeInUp 0.3s ease-out",
                    "@keyframes fadeInUp": {
                      from: { opacity: 0, transform: "translateY(10px)" },
                      to: { opacity: 1, transform: "translateY(0)" },
                    },
                  }}
                >
                  <Box
                    sx={{
                      maxWidth: "88%",
                      background: msg.from === "user" ? "#d9fdd3" : "#fff",
                      color: msg.type === "error" ? "#dc2626" : "#111b21",
                      borderRadius: msg.from === "user"
                        ? "6px 6px 0 6px"
                        : "6px 6px 6px 0",
                      px: 0.6,
                      py: 0.35,
                      fontSize: "clamp(9px, 2vw, 12px)",
                      lineHeight: 1.3,
                      boxShadow: "0 1px 0.5px rgba(11, 20, 26, 0.13)",
                      position: "relative",
                      // Colita del mensaje
                      "&::before": msg.from === "user" ? {
                        content: '""',
                        position: "absolute",
                        bottom: 0,
                        right: -4,
                        width: 0,
                        height: 0,
                        borderStyle: "solid",
                        borderWidth: "0 0 5px 5px",
                        borderColor: "transparent transparent transparent #d9fdd3",
                      } : {
                        content: '""',
                        position: "absolute",
                        bottom: 0,
                        left: -4,
                        width: 0,
                        height: 0,
                        borderStyle: "solid",
                        borderWidth: "0 5px 5px 0",
                        borderColor: "transparent #fff transparent transparent",
                      },
                    }}
                  >
                    {/* Icono de tipo de mensaje */}
                    {msg.type === "imagen" && (
                      <Box sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 0.25,
                        mb: 0.2,
                        p: 0.4,
                        background: "rgba(0,0,0,0.05)",
                        borderRadius: 0.5,
                      }}>
                        <ImageIcon sx={{ fontSize: "clamp(10px, 2.2vw, 14px)", color: "#667781" }} />
                        <span style={{ fontSize: "clamp(7px, 1.5vw, 9px)", color: "#667781" }}>Imagen</span>
                      </Box>
                    )}
                    {msg.type === "voz" && (
                      <Box sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 0.4,
                        mb: 0.2,
                        p: 0.3,
                        background: "rgba(37, 211, 102, 0.1)",
                        borderRadius: 10,
                      }}>
                        <Box sx={{
                          width: "clamp(16px, 3.5vw, 22px)",
                          height: "clamp(16px, 3.5vw, 22px)",
                          borderRadius: "50%",
                          background: "#25D366",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}>
                          <MicIcon sx={{ fontSize: "clamp(8px, 1.8vw, 12px)", color: "#fff" }} />
                        </Box>
                        <Box sx={{
                          flex: 1,
                          height: 2,
                          background: "rgba(0,0,0,0.1)",
                          borderRadius: 1,
                          position: "relative",
                          "&::after": {
                            content: '""',
                            position: "absolute",
                            left: 0,
                            top: 0,
                            height: "100%",
                            width: "60%",
                            background: "#25D366",
                            borderRadius: 1,
                          },
                        }} />
                        <Box sx={{ fontSize: "clamp(6px, 1.4vw, 9px)", color: "#667781" }}>0:05</Box>
                      </Box>
                    )}

                    {/* Texto del mensaje */}
                    <Box sx={{ whiteSpace: "pre-wrap", wordBreak: "break-word" }}>
                      {msg.text}
                    </Box>

                    {/* Hora y check del mensaje */}
                    <Box sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "flex-end",
                      gap: 0.15,
                      mt: 0.1,
                    }}>
                      <Box sx={{ fontSize: "clamp(6px, 1.4vw, 9px)", color: "#667781" }}>
                        {msg.time}
                      </Box>
                      {msg.from === "user" && (
                        <Box sx={{ fontSize: "clamp(7px, 1.6vw, 10px)", color: "#53bdeb", ml: 0.1 }}>✓✓</Box>
                      )}
                    </Box>
                  </Box>
                </Box>
              ))}

              {/* Indicador de escribiendo */}
              {chatLoading && (
                <Box sx={{
                  display: "flex",
                  justifyContent: "flex-start",
                  mb: 0.25,
                  px: 0.25,
                  animation: "fadeIn 0.2s ease-out",
                  "@keyframes fadeIn": {
                    from: { opacity: 0 },
                    to: { opacity: 1 },
                  },
                }}>
                  <Box sx={{
                    background: "#fff",
                    borderRadius: "6px 6px 6px 0",
                    px: 0.6,
                    py: 0.4,
                    display: "flex",
                    alignItems: "center",
                    gap: 0.25,
                    boxShadow: "0 1px 0.5px rgba(11, 20, 26, 0.13)",
                    position: "relative",
                    "&::before": {
                      content: '""',
                      position: "absolute",
                      bottom: 0,
                      left: -4,
                      width: 0,
                      height: 0,
                      borderStyle: "solid",
                      borderWidth: "0 5px 5px 0",
                      borderColor: "transparent #fff transparent transparent",
                    },
                  }}>
                    <Box sx={{
                      width: "clamp(4px, 1vw, 6px)",
                      height: "clamp(4px, 1vw, 6px)",
                      borderRadius: "50%",
                      background: "#8696a0",
                      animation: "typing 1.4s infinite",
                      "@keyframes typing": {
                        "0%, 60%, 100%": { transform: "translateY(0)" },
                        "30%": { transform: "translateY(-3px)" },
                      },
                    }} />
                    <Box sx={{
                      width: "clamp(4px, 1vw, 6px)",
                      height: "clamp(4px, 1vw, 6px)",
                      borderRadius: "50%",
                      background: "#8696a0",
                      animation: "typing 1.4s infinite 0.2s",
                    }} />
                    <Box sx={{
                      width: "clamp(4px, 1vw, 6px)",
                      height: "clamp(4px, 1vw, 6px)",
                      borderRadius: "50%",
                      background: "#8696a0",
                      animation: "typing 1.4s infinite 0.4s",
                    }} />
                  </Box>
                </Box>
              )}
            </Box>

            {/* ===== BARRA DE INPUT ESTILO WHATSAPP ===== */}
            <Box sx={{
              height: "8%",
              minHeight: "32px",
              width: "100%",
              background: "#f0f2f5",
              display: "flex",
              alignItems: "center",
              px: 0.4,
              py: 0.3,
              gap: 0.25,
            }}>
              {/* Botón adjuntar */}
              <Tooltip title="Imagen" arrow>
                <IconButton
                  size="small"
                  onClick={() => {
                    const texto = prompt("Texto con la imagen (opcional):");
                    enviarMensajeSimulador(texto || "", true, false);
                  }}
                  disabled={chatLoading || !currentFlowId}
                  sx={{
                    color: "#54656f",
                    p: 0.25,
                    "&:hover": { background: "rgba(0,0,0,0.05)" },
                  }}
                >
                  <ImageIcon sx={{ fontSize: "clamp(14px, 3vw, 18px)" }} />
                </IconButton>
              </Tooltip>

              {/* Campo de texto */}
              <Box
                component="input"
                value={chatInput}
                onChange={e => setChatInput(e.target.value)}
                onKeyDown={e => {
                  if (e.key === "Enter" && !chatLoading && chatInput.trim()) {
                    enviarMensajeSimulador(chatInput, false, false);
                  }
                }}
                placeholder={currentFlowId ? "Mensaje" : "Guarda"}
                disabled={chatLoading || !currentFlowId}
                sx={{
                  flex: 1,
                  minWidth: 0,
                  border: "none",
                  outline: "none",
                  background: "#fff",
                  borderRadius: "5px",
                  px: 0.6,
                  py: 0.5,
                  fontSize: "clamp(10px, 2vw, 12px)",
                  color: "#111b21",
                  "&::placeholder": {
                    color: "#8696a0",
                  },
                  "&:disabled": {
                    background: "#f5f5f5",
                    color: "#999",
                  },
                }}
              />

              {/* Botón de micrófono o enviar */}
              {chatInput.trim() ? (
                <IconButton
                  size="small"
                  onClick={() => enviarMensajeSimulador(chatInput, false, false)}
                  disabled={chatLoading || !currentFlowId}
                  sx={{
                    width: "clamp(22px, 4.5vw, 28px)",
                    height: "clamp(22px, 4.5vw, 28px)",
                    color: "#fff",
                    background: "#00a884",
                    "&:hover": { background: "#008f72" },
                    "&:disabled": { background: "#ccc" },
                    transition: "all 0.2s ease",
                  }}
                >
                  <SendIcon sx={{ fontSize: "clamp(12px, 2.5vw, 16px)" }} />
                </IconButton>
              ) : (
                <Tooltip title="Voz" arrow>
                  <IconButton
                    size="small"
                    onClick={() => {
                      const texto = prompt("¿Qué dirías en la nota de voz?");
                      if (texto) {
                        enviarMensajeSimulador(texto, false, true);
                      }
                    }}
                    disabled={chatLoading || !currentFlowId}
                    sx={{
                      width: "clamp(22px, 4.5vw, 28px)",
                      height: "clamp(22px, 4.5vw, 28px)",
                      color: "#54656f",
                      "&:hover": { background: "rgba(0,0,0,0.05)" },
                    }}
                  >
                    <MicIcon sx={{ fontSize: "clamp(14px, 3vw, 18px)" }} />
                  </IconButton>
                </Tooltip>
              )}
            </Box>

            {/* Barra inferior del iPhone (home indicator) */}
            <Box sx={{
              height: "3%",
              minHeight: "10px",
              width: "100%",
              background: "#f0f2f5",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}>
              <Box sx={{
                width: "40%",
                maxWidth: "80px",
                height: 3,
                background: "#000",
                borderRadius: 1.5,
                opacity: 0.2,
              }} />
            </Box>
          </Box>
        </Box>
      </Box>
      <Button
        variant="outlined"
        onClick={handleUndo}
        disabled={undoStack.length === 0}
      >
        ⬅️ Deshacer
      </Button>
      <Button
        variant="outlined"
        onClick={handleRedo}
        disabled={redoStack.length === 0}
      >
        Rehacer ➡️
      </Button>
      <Dialog open={openNewDialog} onClose={cancelNewChatbot}>
        <DialogTitle sx={{ color: "rgba(23,66,136,0.98)", fontWeight: 800 }}>
          ¿Comenzar un nuevo chatbot?
        </DialogTitle>
        <DialogContent>
          <Box sx={{ 
            color: "rgba(23,66,136,0.98)", 
            fontWeight: 500, 
            fontSize: 16
          }}>
            Si continúas, perderás el flujo actual si no lo has guardado.<br />
            ¿Deseas crear un nuevo chatbot?
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={cancelNewChatbot} color="primary">
            Cancelar
          </Button>
          <Button onClick={confirmNewChatbot} color="error" variant="contained">
            Sí, crear nuevo
          </Button>
        </DialogActions>
      </Dialog>

            <Dialog open={openPublishError} onClose={() => setOpenPublishError(false)}>
  <DialogTitle>Error al publicar plantilla global</DialogTitle>
  <DialogContent>
    {publishErrorMsg}
  </DialogContent>
  <DialogActions>
    <Button onClick={() => setOpenPublishError(false)} color="primary" variant="contained">
      Entendido
    </Button>
  </DialogActions>
</Dialog>

{/*Inicio de dialogo para guardar flujo*/}
<GuardarFlujoDialog
  open={openFlowDialog}
  onClose={handleFlowDialogClose}
  onSave={handleFlowDialogSave}
  flowName={flowName}
  setFlowName={setFlowName}
  flowDescription={flowDescription}
  setFlowDescription={setFlowDescription}
  flowContextId={flowContextId}
  setFlowContextId={setFlowContextId}
  contextOptions={contextOptions}
  flowWhatsappNumber={flowWhatsappNumber}
  setFlowWhatsappNumber={setFlowWhatsappNumber}
/>
{/*Fin de dialogo para guardar flujo*/}

{/* Diálogo para cargar flujos existentes */}
<CargarFlujoDialog
  open={openLoadDialog}
  onClose={() => setOpenLoadDialog(false)}
  availableFlows={availableFlows}
  contextOptions={contextOptions}
  onLoadFlow={handleLoadFlow}
  onDeleteFlow={setFlowToDelete}
  // Props para Super Admin
  isSuperAdmin={isSuperAdmin}
  empresas={empresas}
  selectedEmpresaFilter={selectedEmpresaFilter}
  onEmpresaFilterChange={handleEmpresaFilterChange}
/>      
{/* Fin del Diálogo para cargar flujos existentes */}

{/* Diálogo para eliminar flujos existentes */}
<EliminarFlujoDialog
  open={!!flowToDelete}
  flowToDelete={flowToDelete}
  onClose={() => setFlowToDelete(null)}
  onConfirmDelete={handleConfirmDeleteFlow}
/>
{/* fin para eliminar flujos existentes */}

      <Box sx={{ position: "fixed", bottom: 24, right: 24, zIndex: 2000 }}>

        <Tooltip title="Ver historial de cambios" arrow>
          <IconButton
            color="primary"
            size="large"
            sx={{
              mr: 2, // margen izquierdo para separarlo del botón de ayuda
              background: "#fff",
              boxShadow: "0 2px 8px #33415522",
              border: "1px solid #e0e7ef",
              "&:hover": { background: "#f1f5f9" }
            }}
            onClick={handleOpenChangelogDialog} // función que abrirá el modal o panel de changelog
          >
            <HistoryIcon fontSize="inherit" />
          </IconButton>
        </Tooltip>    

        <Tooltip title="Ayuda y guía rápida" arrow>
          <IconButton
            color="primary"
            size="large"
            sx={{
              background: "#fff",
              boxShadow: "0 2px 8px #33415522",
              border: "1px solid #e0e7ef",
              "&:hover": { background: "#f1f5f9" }
            }}
            onClick={() => setOpenHelp(true)}
          >
            <HelpOutlineIcon fontSize="inherit" />
          </IconButton>
        </Tooltip>
      </Box>
      <Dialog open={openHelp} onClose={() => setOpenHelp(false)} maxWidth="sm" fullWidth>
        <DialogTitle>¿Cómo usar el Constructor de Chatbots?</DialogTitle>
        <DialogContent dividers>
          <ul style={{ paddingLeft: 20 }}>
            <li>
              <b>Agregar nodo de mensaje:</b>
              <AddCommentIcon sx={{ fontSize: 18, color: "#fbbf24", verticalAlign: "middle", ml: 1, mr: 0.5 }} />
              Usa este botón para crear un mensaje en tu flujo.
            </li>
            <li>
              <b>Agregar pregunta abierta:</b>
              <QuestionAnswerIcon sx={{ fontSize: 18, color: "#60a5fa", verticalAlign: "middle", ml: 1, mr: 0.5 }} />
              Permite que el usuario escriba una respuesta.
            </li>
            <li>
              <b>Agregar pregunta con opciones:</b>
              <ListAltIcon sx={{ fontSize: 18, color: "#a78bfa", verticalAlign: "middle", ml: 1, mr: 0.5 }} />
              Permite que el usuario elija entre varias opciones.
            </li>
            <li>
              <b>Deshacer:</b>
              <ArrowBackIosNewIcon sx={{ fontSize: 18, color: "#f87171", verticalAlign: "middle", ml: 1, mr: 0.5 }} />
              y <b>Rehacer:</b>
              <ArrowForwardIosIcon sx={{ fontSize: 18, color: "#34d399", verticalAlign: "middle", ml: 0.5, mr: 0.5 }} />
              Usa estos botones o <b>Ctrl+Z</b> y <b>Ctrl+Y</b>.
            </li>
            <li>
              <b>Guardar flujo:</b>
              <SaveIcon sx={{ fontSize: 18, color: "#22c55e", verticalAlign: "middle", ml: 1, mr: 0.5 }} />
              Haz clic aquí para guardar tu flujo.
            </li>
            <li>
              <b>Nuevo chatbot:</b>
              <AddBoxIcon sx={{ fontSize: 18, color: "#38bdf8", verticalAlign: "middle", ml: 1, mr: 0.5 }} />
              Crea un flujo nuevo (¡guarda antes de continuar!).
            </li>
            <li>
              <b>Zoom y centrar:</b>
              <ZoomInIcon sx={{ fontSize: 18, color: "#fbbf24", verticalAlign: "middle", ml: 1, mr: 0.5 }} />
              <ZoomOutIcon sx={{ fontSize: 18, color: "#fbbf24", verticalAlign: "middle", ml: 0.5, mr: 0.5 }} />
              <CenterFocusStrongIcon sx={{ fontSize: 18, color: "#fbbf24", verticalAlign: "middle", ml: 0.5, mr: 0.5 }} />
              Usa estos botones para acercar, alejar o centrar el flujo.
            </li>
            <li>
              <b>Simulador:</b> Visualiza cómo se verá el flujo en un celular a la derecha.
            </li>
            <li>
              <b>Conectar nodos:</b> Arrastra desde los círculos verdes para conectar los pasos y definir el orden de la conversación.
            </li>
            <li>
              <b>Editar nodos:</b> Haz doble clic en un nodo para editar su contenido o pregunta.
            </li>
          </ul>
          <p style={{ marginTop: 16, color: "#6366f1" }}>
            ¿Tienes dudas? ¡Contáctanos para soporte!
          </p>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenHelp(false)} color="primary" variant="contained">
            Cerrar
          </Button>
        </DialogActions>
      </Dialog>
            <Dialog open={openTemplateDialog} onClose={() => setOpenTemplateDialog(false)} maxWidth="sm" fullWidth>
        <DialogTitle>Selecciona una plantilla preconstruida</DialogTitle>
        <DialogContent>
          {publicTemplates.length === 0 ? (
            <Box sx={{ p: 3, textAlign: "center", color: "#6366f1" }}>
              No hay plantillas globales publicadas aún.
            </Box>
          ) : (
            publicTemplates.map(tpl => (
              <Box key={tpl.id} sx={{ mb: 3, p: 2, border: "1px solid #e0e7ef", borderRadius: 2, background: "#fff" }}>
                <Box sx={{ fontWeight: 700, color: "#6366f1", fontSize: 18 }}>{tpl.name}</Box>
                <Box sx={{ color: "#334155", fontSize: 14, mb: 1 }}>{tpl.description}</Box>
                <Button
                  variant="contained"
                  sx={{ background: "#6366f1", color: "#fff", borderRadius: 2, fontWeight: 700, mt: 1 }}
                  onClick={() => handleUseTemplate(tpl)}
                >
                  Usar esta plantilla
                </Button>
              </Box>
            ))
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenTemplateDialog(false)}>Cancelar</Button>
        </DialogActions>
      </Dialog>

      {/* Botón flotante para abrir el asistente */}
      <Box sx={{ position: "fixed", bottom: 8, left: 24, zIndex: 3000 }}>
        <Tooltip title="Asistente Inteligente con IA" arrow>
          <IconButton
            color="primary"
            size="medium"
            sx={{
              background: "linear-gradient(135deg, #1e3a5f 0%, #2d5a87 100%)",
              color: "#fff",
              border: "2px solid #fbbf24",
              boxShadow: "0 3px 15px rgba(99, 102, 241, 0.4)",
              position: "relative",
              width: 44,
              height: 44,
              "&:hover": {
                background: "linear-gradient(135deg, #2d5a87 0%, #4338ca 100%)",
                transform: "scale(1.08)",
                boxShadow: "0 4px 18px rgba(99, 102, 241, 0.5)"
              },
              transition: "all 0.2s ease"
            }}
            onClick={() => setAssistantOpen(true)}
          >
            <img
              src="/images/logo-nara-png.png"
              alt="Nara Logo"
              style={{
                position: "absolute",
                left: "50%",
                top: "50%",
                transform: "translate(-50%, -50%)",
                width: 52,
                height: 52,
                objectFit: "contain",
                pointerEvents: "none"
              }}
            />
          </IconButton>
        </Tooltip>
        <Box sx={{
          mt: 0.5,
          textAlign: "center",
          background: "rgba(99, 102, 241, 0.1)",
          borderRadius: 1,
          px: 0.8,
          py: 0.2
        }}>
          <Typography sx={{ fontSize: 9, color: "#6366f1", fontWeight: 600 }}>
            Asistente IA
          </Typography>
        </Box>
      </Box>

      {/* Diálogo del Asistente Inteligente */}
      <AsistenteFlujosDialog
        open={assistantOpen}
        onClose={() => setAssistantOpen(false)}
        messages={assistantMessages}
        loading={assistantLoading}
        nodes={nodes}
        user={user}
        onSendMessage={async (mensaje) => {
          // Agregar mensaje del usuario
          const userMsg = { from: "user", text: mensaje };
          setAssistantMessages(msgs => [...msgs, userMsg]);
          setAssistantLoading(true);

          // Preparar datos del flujo actual para contexto
          const flujoActual = nodes.map(n => ({
            type: n.data.type,
            label: n.data.label,
            variable: n.data.variable
          }));

          try {
            let token = null;
            if (user?.uid && user.getIdToken) {
              token = await user.getIdToken();
            }

            const headers = { "Content-Type": "application/json" };
            if (token) headers["Authorization"] = `Bearer ${token}`;
            if (user?.id) headers["X-User-Id"] = String(user.id);

            const response = await fetch("/api/asistente-flujos/", {
              method: "POST",
              headers,
              body: JSON.stringify({
                mensaje,
                flujo_actual: flujoActual,
                historial: assistantMessages.slice(-10)
              })
            });

            const data = await response.json();

            if (data.action === "generate_flow" && data.nodes && data.nodes.length > 0) {
              // Guardar nodos en estado para que el botón pueda accederlos
              const nodesToAdd = [...data.nodes];
              setPendingAINodes(nodesToAdd);

              // Preview de nodos
              const previewText = nodesToAdd.map((n, i) =>
                `${i + 1}. [${n.type}] ${n.label.substring(0, 50)}${n.label.length > 50 ? '...' : ''}`
              ).join('\n');

              setAssistantMessages(msgs => [
                ...msgs,
                {
                  from: "bot",
                  text: `${data.message || "He generado el flujo."}\n\n📋 **Nodos propuestos:**\n${previewText}`,
                  options: [
                    {
                      label: "✅ Agregar al canvas",
                      action: () => {
                        generateNodesFromAI(nodesToAdd);
                        setPendingAINodes(null);
                        setAssistantMessages(msgs => [
                          ...msgs,
                          { from: "bot", text: `¡Listo! Se agregaron ${nodesToAdd.length} nodos al canvas. Puedes cerrar este diálogo para verlos.` }
                        ]);
                      }
                    },
                    {
                      label: "🔄 Modificar",
                      action: () => {
                        setAssistantMessages(msgs => [
                          ...msgs,
                          { from: "bot", text: "Descríbeme qué cambios quieres hacer al flujo propuesto." }
                        ]);
                      }
                    },
                    {
                      label: "❌ Descartar",
                      action: () => {
                        setPendingAINodes(null);
                        setAssistantMessages(msgs => [
                          ...msgs,
                          { from: "bot", text: "Descartado. ¿En qué más puedo ayudarte?" }
                        ]);
                      }
                    }
                  ]
                }
              ]);
            } else if (data.action === "suggest" && data.suggestions) {
              setAssistantMessages(msgs => [
                ...msgs,
                {
                  from: "bot",
                  text: data.message || "Tengo sugerencias:",
                  options: data.suggestions.slice(0, 3).map(sug => ({
                    label: sug.length > 25 ? sug.substring(0, 25) + "..." : sug,
                    action: () => setAssistantInput(sug)
                  }))
                }
              ]);
            } else {
              setAssistantMessages(msgs => [
                ...msgs,
                { from: "bot", text: data.message || "¿En qué más puedo ayudarte?" }
              ]);
            }
          } catch (error) {
            console.error("Error:", error);
            setAssistantMessages(msgs => [
              ...msgs,
              { from: "bot", text: "Hubo un problema de conexión. Intenta de nuevo." }
            ]);
          } finally {
            setAssistantLoading(false);
          }
        }}
      />

        <Dialog open={openProfileDialog} onClose={() => setOpenProfileDialog(false)}>
          <DialogTitle>Perfil de usuario</DialogTitle>
          <DialogContent>
            <Box sx={{ display: "flex", alignItems: "center", gap: 2, mb: 2 }}>
            <Avatar
                src={firebasePhotoURL || user?.photoURL || ""}
                alt={user?.displayName || user?.email || "Perfil"}
                sx={{ width: 56, height: 56, bgcolor: "#6366f1", fontSize: 28 }}
                imgProps={{ referrerPolicy: "no-referrer" }}
              >
              {user?.displayName ? user.displayName[0] : (user?.email ? user.email[0] : "U")}
              </Avatar>
              <Box>
                <Box sx={{ fontWeight: 700, fontSize: 18, color: "#334155" }}>
                  {user?.displayName || "Usuario"}
                </Box>
                <Box sx={{ color: "#6366f1", fontSize: 15 }}>
                  {user?.email}
                </Box>
                {/* Muestra el nombre de la empresa */}
                <Box sx={{ color: "#334155", fontSize: 15, mt: 0.5 }}>
                  <b>Empresa:</b> {subscriptionInfo?.empresa?.company || "No asignada"}
                </Box>
            </Box>
          </Box>
          <Box sx={{ mb: 1, fontWeight: 500, color: "#334155" }}>
              <b>Plan actual:</b> {userPlan || "Cargando..."}
            </Box>

            {/* Horario de atención */}
            <Box sx={{
              mt: 2,
              pt: 2,
              borderTop: "1px solid #e2e8f0",
              color: "#334155"
            }}>
              <Box sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                mb: 2
              }}>
                <Box sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                  fontWeight: 600,
                  fontSize: 15,
                  color: "#1e3a5f"
                }}>
                  <ScheduleIcon sx={{ fontSize: 20, color: "#6366f1" }} />
                  Horario de Atención
                </Box>
                {!editingAgenda && (
                  <IconButton
                    size="small"
                    onClick={startEditingAgenda}
                    sx={{
                      color: "#6366f1",
                      "&:hover": { background: "#e0e7ff" }
                    }}
                  >
                    <EditIcon sx={{ fontSize: 18 }} />
                  </IconButton>
                )}
              </Box>

              {editingAgenda ? (
                /* Modo edición */
                <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                  {/* Selector de días */}
                  <Box>
                    <Box sx={{ fontSize: 13, fontWeight: 600, color: "#475569", mb: 1 }}>
                      Días de atención
                    </Box>
                    <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                      {DIAS_SEMANA.map(dia => (
                        <Chip
                          key={dia.id}
                          label={dia.label}
                          size="small"
                          onClick={() => toggleDia(dia.id)}
                          sx={{
                            fontWeight: 600,
                            fontSize: 12,
                            cursor: "pointer",
                            transition: "all 0.2s",
                            ...(editAgendaDias.includes(dia.id) ? {
                              background: "linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)",
                              color: "#fff",
                              "&:hover": {
                                background: "linear-gradient(135deg, #4f46e5 0%, #7c3aed 100%)"
                              }
                            } : {
                              background: "#f1f5f9",
                              color: "#64748b",
                              border: "1px solid #e2e8f0",
                              "&:hover": {
                                background: "#e2e8f0",
                                borderColor: "#6366f1"
                              }
                            })
                          }}
                        />
                      ))}
                    </Box>
                  </Box>

                  {/* Horario inicio/fin */}
                  <Box sx={{ display: "flex", gap: 2 }}>
                    <Box sx={{ flex: 1 }}>
                      <Box sx={{ fontSize: 13, fontWeight: 600, color: "#475569", mb: 0.5, display: "flex", alignItems: "center", gap: 0.5 }}>
                        <AccessTimeIcon sx={{ fontSize: 14 }} />
                        Hora inicio
                      </Box>
                      <TextField
                        type="time"
                        size="small"
                        fullWidth
                        value={editAgendaHoraInicio}
                        onChange={(e) => setEditAgendaHoraInicio(e.target.value)}
                        sx={{
                          "& .MuiOutlinedInput-root": {
                            borderRadius: 2,
                            background: "#f8fafc"
                          }
                        }}
                      />
                    </Box>
                    <Box sx={{ flex: 1 }}>
                      <Box sx={{ fontSize: 13, fontWeight: 600, color: "#475569", mb: 0.5, display: "flex", alignItems: "center", gap: 0.5 }}>
                        <AccessTimeIcon sx={{ fontSize: 14 }} />
                        Hora fin
                      </Box>
                      <TextField
                        type="time"
                        size="small"
                        fullWidth
                        value={editAgendaHoraFin}
                        onChange={(e) => setEditAgendaHoraFin(e.target.value)}
                        sx={{
                          "& .MuiOutlinedInput-root": {
                            borderRadius: 2,
                            background: "#f8fafc"
                          }
                        }}
                      />
                    </Box>
                  </Box>

                  {/* Intervalo */}
                  <Box>
                    <Box sx={{ fontSize: 13, fontWeight: 600, color: "#475569", mb: 0.5, display: "flex", alignItems: "center", gap: 0.5 }}>
                      <TimerIcon sx={{ fontSize: 14 }} />
                      Duración de citas
                    </Box>
                    <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                      {INTERVALOS.map(int => (
                        <Chip
                          key={int.value}
                          label={int.label}
                          size="small"
                          onClick={() => setEditAgendaIntervalo(int.value)}
                          sx={{
                            fontWeight: 500,
                            fontSize: 12,
                            cursor: "pointer",
                            transition: "all 0.2s",
                            ...(editAgendaIntervalo === int.value ? {
                              background: "linear-gradient(135deg, #10b981 0%, #059669 100%)",
                              color: "#fff",
                              "&:hover": {
                                background: "linear-gradient(135deg, #059669 0%, #047857 100%)"
                              }
                            } : {
                              background: "#f1f5f9",
                              color: "#64748b",
                              border: "1px solid #e2e8f0",
                              "&:hover": {
                                background: "#e2e8f0",
                                borderColor: "#10b981"
                              }
                            })
                          }}
                        />
                      ))}
                    </Box>
                  </Box>

                  {/* Botones de acción */}
                  <Box sx={{ display: "flex", gap: 1, justifyContent: "flex-end", mt: 1 }}>
                    <Button
                      size="small"
                      variant="outlined"
                      onClick={cancelEditingAgenda}
                      disabled={savingAgenda}
                      sx={{
                        borderRadius: 2,
                        textTransform: "none",
                        fontWeight: 600,
                        borderColor: "#e2e8f0",
                        color: "#64748b",
                        "&:hover": { background: "#f1f5f9", borderColor: "#94a3b8" }
                      }}
                    >
                      Cancelar
                    </Button>
                    <Button
                      size="small"
                      variant="contained"
                      onClick={saveAgenda}
                      disabled={savingAgenda}
                      sx={{
                        borderRadius: 2,
                        textTransform: "none",
                        fontWeight: 600,
                        background: "linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)",
                        "&:hover": {
                          background: "linear-gradient(135deg, #4f46e5 0%, #7c3aed 100%)"
                        }
                      }}
                    >
                      {savingAgenda ? "Guardando..." : "Guardar"}
                    </Button>
                  </Box>
                </Box>
              ) : (
                /* Modo visualización */
                userAgenda ? (
                  <Box sx={{
                    display: "flex",
                    flexDirection: "column",
                    gap: 1.5,
                    p: 2,
                    background: "#f8fafc",
                    borderRadius: 2,
                    border: "1px solid #e2e8f0"
                  }}>
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1, fontSize: 14 }}>
                      <Box sx={{
                        width: 28,
                        height: 28,
                        borderRadius: 1,
                        background: "#e0e7ff",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center"
                      }}>
                        <ScheduleIcon sx={{ fontSize: 16, color: "#6366f1" }} />
                      </Box>
                      <Box>
                        <Box sx={{ fontSize: 11, color: "#64748b", fontWeight: 500 }}>Días</Box>
                        <Box sx={{ fontWeight: 600, color: "#334155" }}>
                          {userAgenda.dias || "No configurado"}
                        </Box>
                      </Box>
                    </Box>
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1, fontSize: 14 }}>
                      <Box sx={{
                        width: 28,
                        height: 28,
                        borderRadius: 1,
                        background: "#dcfce7",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center"
                      }}>
                        <AccessTimeIcon sx={{ fontSize: 16, color: "#16a34a" }} />
                      </Box>
                      <Box>
                        <Box sx={{ fontSize: 11, color: "#64748b", fontWeight: 500 }}>Horario</Box>
                        <Box sx={{ fontWeight: 600, color: "#334155" }}>
                          {userAgenda.hora_inicio || "—"} - {userAgenda.hora_fin || "—"}
                        </Box>
                      </Box>
                    </Box>
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1, fontSize: 14 }}>
                      <Box sx={{
                        width: 28,
                        height: 28,
                        borderRadius: 1,
                        background: "#fef3c7",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center"
                      }}>
                        <TimerIcon sx={{ fontSize: 16, color: "#d97706" }} />
                      </Box>
                      <Box>
                        <Box sx={{ fontSize: 11, color: "#64748b", fontWeight: 500 }}>Duración citas</Box>
                        <Box sx={{ fontWeight: 600, color: "#334155" }}>
                          {userAgenda.intervalo ? `${userAgenda.intervalo} minutos` : "No configurado"}
                        </Box>
                      </Box>
                    </Box>
                  </Box>
                ) : (
                  <Box sx={{
                    p: 3,
                    textAlign: "center",
                    background: "#f8fafc",
                    borderRadius: 2,
                    border: "1px dashed #cbd5e1"
                  }}>
                    <ScheduleIcon sx={{ fontSize: 36, color: "#94a3b8", mb: 1 }} />
                    <Box sx={{ fontSize: 14, color: "#64748b", mb: 1.5 }}>
                      No hay horario configurado
                    </Box>
                    <Button
                      size="small"
                      variant="contained"
                      onClick={startEditingAgenda}
                      sx={{
                        borderRadius: 2,
                        textTransform: "none",
                        fontWeight: 600,
                        background: "linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)",
                        "&:hover": {
                          background: "linear-gradient(135deg, #4f46e5 0%, #7c3aed 100%)"
                        }
                      }}
                    >
                      Configurar horario
                    </Button>
                  </Box>
                )
              )}
            </Box>
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2 }}>
          <Button
            onClick={() => { setOpenProfileDialog(false); setEditingAgenda(false); }}
            variant="outlined"
            sx={{
              borderRadius: 2,
              textTransform: "none",
              fontWeight: 600,
              borderColor: "#e2e8f0",
              color: "#64748b",
              "&:hover": { background: "#f1f5f9", borderColor: "#94a3b8" }
            }}
          >
            Cerrar
          </Button>
        </DialogActions>
        </Dialog>

        <Dialog open={openSubscriptionDialog} onClose={() => setOpenSubscriptionDialog(false)}>
  <DialogTitle>Detalles de Suscripción</DialogTitle>
  <DialogContent>
    {loadingSubscription ? (
      <Box>Cargando...</Box>
    ) : !subscriptionInfo ? (
      <Box>No se pudo cargar la información de suscripción.</Box>
    ) : (
      <Box sx={{ minWidth: 280 }}>
        <Box sx={{ mb: 1 }}>
          <b>Plan actual:</b> {subscriptionInfo.plan?.name || "Desconocido"}
        </Box>
        <Box sx={{ mb: 1 }}>
          <b>Licencias usadas:</b> {subscriptionInfo.empresa?.licencias_ocupadas ?? "N/A"} / {subscriptionInfo.plan?.num_licencias ?? "N/A"}
        </Box>
        <Box sx={{ mb: 1 }}>
          <b>Chatbots permitidos:</b> {subscriptionInfo.plan?.num_chatbots ?? "N/A"}
        </Box>
        <Box sx={{ mb: 1 }}>
          <b>Números de WhatsApp permitidos:</b> {subscriptionInfo.plan?.num_whatsapp ?? "N/A"}
        </Box>
        <Box sx={{ mb: 1 }}>
          <b>Conversaciones usadas:</b> {subscriptionInfo.empresa?.conversaciones_usadas ?? "N/A"} / {subscriptionInfo.plan?.num_conversaciones ?? "N/A"}
        </Box>
        <Box sx={{ mb: 1 }}>
          <b>Tokens usados:</b> {subscriptionInfo.empresa?.tokens_usados ?? "N/A"} / {subscriptionInfo.plan?.num_tokens ?? "N/A"}
        </Box>
      </Box>
    )}
  </DialogContent>
  <DialogActions>
    <Button onClick={() => setOpenSubscriptionDialog(false)} color="primary" variant="contained">
      Cerrar
    </Button>
  </DialogActions>
</Dialog>

  <Dialog 
    open={openAdminTemplates} 
    onClose={() => setOpenAdminTemplates(false)} 
    maxWidth="md" 
    fullWidth
    slotProps={{
    paper: {
      sx: {
        maxWidth: 700,
        borderRadius: 4,
        background: "#f8fafc",
        boxShadow: "0 4px 24px #6366f122",
        border: "none",
        p: 0,
        overflow: "hidden"
      }
    }
  }}
    
  >
      <DialogTitle>Administrar plantillas globales</DialogTitle>
      <DialogContent>
      <Button
      variant="outlined"
      sx={{ mb: 2 }}
      onClick={() => {
        setSelectedTemplate({ name: "", description: "", nodes: [], edges: [] });
      }}
    >
      + Nueva plantilla
    </Button>
    {adminTemplates.length === 0 ? (
      <Box sx={{ p: 2, color: "#6366f1" }}>No hay plantillas globales aún.</Box>
    ) : (
      adminTemplates.map(tpl => (
        <Box key={tpl.id} sx={{ mb: 2, p: 2, border: "1px solid #e0e7ef", borderRadius: 2 }}>
          <Box sx={{ fontWeight: 700, color: "#6366f1", fontSize: 18 }}>{tpl.name}</Box>
          <Box sx={{ color: "#334155", fontSize: 14, mb: 1 }}>{tpl.description}</Box>
          <Button
            variant="outlined"
            sx={{ mr: 1 }}
            onClick={() => {
              setSelectedTemplate(tpl);
            }}
          >
            Editar
          </Button>

          <Button
      variant="outlined"
      sx={{ mr: 1 }}
      onClick={() => {
        // Inicializa nodos y edges para edición visual
        const initialNodes = tpl?.nodes?.length
          ? tpl.nodes.map(n => ({
              id: n.node_id || n.id,
              type: "custom",
              position: {
                x: n.position_x ?? (n.position?.x ?? 100),
                y: n.position_y ?? (n.position?.y ?? 100),
              },
              data: {
                type: n.type ?? n.data?.type,
                label: n.label ?? n.data?.label,
                variable: n.variable ?? n.data?.variable,
                tipo_dato: n.tipo_dato ?? n.data?.tipo_dato ?? "texto",
                options: n.options ?? n.data?.options ?? [],
                onChange: handleNodeDataChange,
                onDelete: handleDeleteNode,
              }
            }))
          : [{
              id: "1",
              type: "custom",
              position: { x: 100, y: 100 },
              data: { type: "message", label: "Inicio de conversación", onChange: handleNodeDataChange, onDelete: handleDeleteNode },
            }];
        const initialEdges = tpl?.edges?.length
          ? tpl.edges.map(e => ({
              id: `${e.source_node_id || e.source}-${e.target_node_id || e.target}`,
              source: e.source_node_id || e.source,
              target: e.target_node_id || e.target,
              sourceHandle: e.source_handle ?? e.sourceHandle ?? undefined,
              label: e.label ?? "",
              type: e.edge_type ?? e.type ?? "step",
            }))
          : [];
        setNodes(initialNodes);
        setEdges(initialEdges);
        setEditingTemplate({ ...tpl, nodes: initialNodes, edges: initialEdges });
          setFlowContextId(tpl.id_contexto || (contextOptions[0] && contextOptions[0].id)); // <-- AGREGA ESTA LÍNEA
        setOpenAdminTemplates(false);
        setSelectedTemplate(null);
        setUndoStack([]);
        setRedoStack([]);
      }}
    >
      Editar flujo visualmente
    </Button>  
     

     <Button
    variant="outlined"
    color="warning"
    sx={{ mr: 1 }}
    disabled={!tpl.is_public}
    onClick={async () => {
      // Llama al endpoint de despublicar
      await fetch(`/api/templates/${tpl.id}/despublicar`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
      });
      // Actualiza el estado local para reflejar el cambio
      setAdminTemplates(arr =>
        arr.map(t =>
          t.id === tpl.id ? { ...t, is_public: false } : t
        )
      );
      setUnpublishedTemplateName(tpl.name);
      setShowUnpublishDialog(true);

    }}
  >
    Despublicar
  </Button>
    
     
    <Button
      variant="outlined"
      color="error"
      onClick={() => setTplToDelete(tpl)}
    >
      Eliminar
    </Button>
         
    </Box>
      ))
    )}
  </DialogContent>
  <DialogActions>
    <Button onClick={() => setOpenAdminTemplates(false)}>Cerrar</Button>
  </DialogActions>
</Dialog>

<Dialog
  open={!!selectedTemplate}
  onClose={() => setSelectedTemplate(null)}
  maxWidth="sm"
  fullWidth
>
  <DialogTitle>
    {selectedTemplate?.id ? "Editar plantilla global" : "Nueva plantilla global"}
  </DialogTitle>

    <DialogContent>
    <Box
      sx={{
        p: 2,
        background: "#fff",
        border: "1px solid #e0e7ef",
        borderRadius: 2,
        mb: 2,
        boxShadow: "0 1px 6px #6366f122",
        display: "flex",
        flexDirection: "column",
        gap: 2,
      }}
    >
      <TextField
        label="Nombre"
        fullWidth
        sx={{ mb: 2 }}
        value={selectedTemplate?.name || ""}
        onChange={e =>
          setSelectedTemplate(tpl => ({ ...tpl, name: e.target.value }))
        }
      />
      <TextField
        label="Descripción"
        fullWidth
        multiline
        minRows={2}
        sx={{ mb: 2 }}
        value={selectedTemplate?.description || ""}
        onChange={e =>
          setSelectedTemplate(tpl => ({ ...tpl, description: e.target.value }))
        }
      />

      
      <Autocomplete
        options={[...contextOptions].sort((a, b) => a.nombre.localeCompare(b.nombre, 'es', { sensitivity: 'base' }))}
        getOptionLabel={opt => opt.nombre}
        value={contextOptions.find(opt => opt.id === selectedTemplate?.id_contexto) || null}
        onChange={(e, newValue) =>
          setSelectedTemplate(tpl => ({
            ...tpl,
            id_contexto: newValue ? newValue.id : ""
          }))
        }
        filterOptions={(options, { inputValue }) =>
          options.filter(opt =>
            opt.nombre.toLowerCase().startsWith(inputValue.trim().toLowerCase())
          )
        }
        renderInput={params => (
          <TextField
            {...params}
            label="Contexto"
            fullWidth
            required
            sx={{ mb: 2 }}
          />
        )}
      />


  
      <Box sx={{ display: "flex", gap: 2 }}>
        <Button
          variant="outlined"
          onClick={() => {
            // Si no hay nodos/edges, inicializa con un nodo de inicio
            const initialNodes = selectedTemplate?.nodes?.length
              ? selectedTemplate.nodes.map(n => ({
                  id: n.node_id || n.id,
                  type: "custom",
                  position: {
                    x: n.position_x ?? (n.position?.x ?? 100),
                    y: n.position_y ?? (n.position?.y ?? 100),
                  },
                  data: {
                    type: n.type ?? n.data?.type,
                    label: n.label ?? n.data?.label,
                    variable: n.variable ?? n.data?.variable,
                    tipo_dato: n.tipo_dato ?? n.data?.tipo_dato ?? "texto",
                    options: n.options ?? n.data?.options ?? [],
                    onChange: handleNodeDataChange,
                    onDelete: handleDeleteNode,
                  }
                }))
              : [{
                  id: "1",
                  type: "custom",
                  position: { x: 100, y: 100 },
                  data: { type: "message", label: "Inicio de conversación", onChange: handleNodeDataChange, onDelete: handleDeleteNode },
                }];
            const initialEdges = selectedTemplate?.edges?.length
              ? selectedTemplate.edges.map(e => ({
                  id: `${e.source_node_id || e.source}-${e.target_node_id || e.target}`,
                  source: e.source_node_id || e.source,
                  target: e.target_node_id || e.target,
                  sourceHandle: e.source_handle ?? e.sourceHandle ?? undefined,
                  label: e.label ?? "",
                  type: e.edge_type ?? e.type ?? "step",
                }))
              : [];
          
            setNodes(initialNodes);
            setEdges(initialEdges);
            setEditingTemplate({ ...selectedTemplate, nodes: initialNodes, edges: initialEdges });
            setOpenAdminTemplates(false);
            setSelectedTemplate(null);
            setUndoStack([]);
            setRedoStack([]);
          }}

           disabled={
            !selectedTemplate?.name?.trim() ||
            !selectedTemplate?.description?.trim() ||
            !selectedTemplate?.id_contexto
         }
        >
          Editar flujo visualmente
        </Button>
        <Button
          variant="outlined"
          onClick={() => {
            setSelectedTemplate(tpl => ({
              ...tpl,
              nodes: nodes,
              edges: edges
            }));
            alert("¡Flujo del editor copiado a la plantilla! No olvides Guardar.");
          }}
           disabled={
            !selectedTemplate?.name?.trim() ||
            !selectedTemplate?.description?.trim() ||
            !selectedTemplate?.id_contexto
          }
        >
          Copiar flujo actual a plantilla
        </Button>
      </Box>
    </Box>
  </DialogContent>

  <DialogActions>
    <Button onClick={() => setSelectedTemplate(null)}>Cancelar</Button>
      <Button
        variant="contained"
                // Dentro del Dialog de plantilla global, botón Guardar
        onClick={async () => {
          if (!selectedTemplate.name?.trim()) {
            alert("El nombre es obligatorio");
            return;
          }
        
          // Limpia los nodos y edges antes de enviar
          const cleanNodes = (selectedTemplate.nodes || []).map(n => ({
            node_id: n.id,
            type: n.data?.type ?? n.type,
            label: n.data?.label ?? n.label ?? "",
            variable: n.data?.variable ?? n.variable ?? "",
            options: n.data?.options ?? n.options ?? [],
            position_x: n.position?.x ?? n.position_x ?? 100,
            position_y: n.position?.y ?? n.position_y ?? 100,
          }));
        
          const cleanEdges = (selectedTemplate.edges || []).map(e => ({
            source_node_id: e.source ?? e.source_node_id,
            target_node_id: e.target ?? e.target_node_id,
            edge_type: e.type ?? e.edge_type ?? "",
            label: e.label ?? "",
            source_handle: e.sourceHandle ?? e.source_handle ?? null,
          }));
        
          const payload = {
            name: selectedTemplate.name,
            description: selectedTemplate.description,
            id_contexto: selectedTemplate.id_contexto || flowContextId,
            is_public: selectedTemplate.is_public ?? false,
            nodes: cleanNodes,
            edges: cleanEdges,
          };
        
          if (selectedTemplate.id) {
            const res = await fetch(`/api/templates/${selectedTemplate.id}`, {
              method: "PUT",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify(payload),
            });
            const text = await res.text();
            try {
              const data = JSON.parse(text);
              setAdminTemplates(arr =>
                arr.map(t =>
                  t.id === selectedTemplate.id ? { ...t, ...payload } : t
                )
              );
            } catch (e) {
              alert("Error al guardar plantilla: " + text);
            }
          } else {
            const res = await fetch("/api/templates/", {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify(payload),
            });
            const text = await res.text();
            try {
              const data = JSON.parse(text);
              setAdminTemplates(arr => [...arr, data]);
            } catch (e) {
              alert("Error al guardar plantilla: " + text);
            }
          }
          setSelectedTemplate(null);
        }}


        disabled={
           !selectedTemplate?.name?.trim() ||
           !selectedTemplate?.description?.trim() ||
           !selectedTemplate?.id_contexto
      }
      >
        Guardar
      </Button>
  </DialogActions>
</Dialog>

{/* ...todo tu JSX anterior... */}

{/* Snackbar de éxito para plantilla actualizada */}
<Snackbar
  open={showTemplateUpdated}
  autoHideDuration={5000}
  onClose={() => setShowTemplateUpdated(false)}
  anchorOrigin={{ vertical: "top", horizontal: "center" }}
>
  <MuiAlert
    elevation={6}
    variant="filled"
    severity="success"
    sx={{
      fontWeight: 700,
      fontSize: 18,
      background: "#22c55e",
      color: "#fff",
      borderRadius: 2,
      boxShadow: "0 8px 32px #22c55e22",
      border: "1.5px solid #22c55e",
      alignItems: "center",
      justifyContent: "center",
      display: "flex",
      gap: 1,
    }}
    icon={<span role="img" aria-label="check" style={{ fontSize: 28, marginRight: 8 }}>✅</span>}
  >
    ¡Los cambios en la plantilla global se guardaron correctamente!
  </MuiAlert>
</Snackbar>

{/* Snackbar para AI Agent */}
<Snackbar
  open={showAgentSaved}
  autoHideDuration={4000}
  onClose={() => setShowAgentSaved(false)}
  anchorOrigin={{ vertical: "top", horizontal: "center" }}
>
  <MuiAlert
    elevation={6}
    variant="filled"
    severity="success"
    sx={{
      fontWeight: 700,
      fontSize: 16,
      background: "#a855f7",
      color: "#fff",
      borderRadius: 2,
      boxShadow: "0 8px 32px #a855f722",
      border: "1.5px solid #a855f7",
      alignItems: "center",
      justifyContent: "center",
      display: "flex",
      gap: 1,
    }}
    icon={<span role="img" aria-label="robot" style={{ fontSize: 24, marginRight: 8 }}>🤖</span>}
  >
    {agentSavedMessage}
  </MuiAlert>
</Snackbar>

<Dialog
  open={!!tplToDelete}
  onClose={() => setTplToDelete(null)}
>
  <DialogTitle>¿Eliminar plantilla global?</DialogTitle>
  <DialogContent>
    ¿Seguro que deseas eliminar la plantilla <b>{tplToDelete?.name}</b>?<br />
    Esta acción no se puede deshacer.
  </DialogContent>
  <DialogActions>
    <Button onClick={() => setTplToDelete(null)} color="primary">
      Cancelar
    </Button>
    <Button
      onClick={async () => {
        await fetch(`/api/templates/${tplToDelete.id}`, { method: "DELETE" });
        setAdminTemplates(adminTemplates.filter(t => t.id !== tplToDelete.id));
        setTplToDelete(null);
      }}
      color="error"
      variant="contained"
    >
      Eliminar
    </Button>
  </DialogActions>
</Dialog>

{/* <-- AQUÍ AGREGA EL DIALOGO DE DESPUBLICAR */}
<Dialog open={showUnpublishDialog} onClose={() => setShowUnpublishDialog(false)}>
  <DialogTitle>Plantilla despublicada</DialogTitle>
  <DialogContent>
    La plantilla <b>{unpublishedTemplateName}</b> ha sido despublicada correctamente.
  </DialogContent>
  <DialogActions>
    <Button onClick={() => setShowUnpublishDialog(false)} color="primary" variant="contained">
      Entendido
    </Button>
  </DialogActions>
</Dialog>

<Dialog open={openIaConnectDialog} onClose={() => setOpenIaConnectDialog(false)}>
  <DialogTitle>Conexión no permitida</DialogTitle>
  <DialogContent>
    Los nodos IA solo pueden recibir conexiones desde una opción de un nodo de pregunta con opciones.
  </DialogContent>
  <DialogActions>
    <Button onClick={() => setOpenIaConnectDialog(false)} color="primary" variant="contained">
      Entendido
    </Button>
  </DialogActions>
</Dialog>

{/* ===== DIALOG DE CONFIGURACIÓN AI AGENT - DISEÑO MEJORADO ===== */}
<Dialog
  open={openAgentDialog}
  onClose={() => { setOpenAgentDialog(false); clearAgentChat(); }}
  maxWidth="lg"
  fullWidth
  TransitionComponent={Slide}
  TransitionProps={{ direction: "up" }}
  PaperProps={{
    sx: {
      borderRadius: 4,
      background: "linear-gradient(180deg, #f8fafc 0%, #fff 100%)",
      boxShadow: "0 25px 50px -12px rgba(0, 0, 0, 0.25)",
      border: "none",
      overflow: "hidden",
      minHeight: "85vh",
      maxHeight: "90vh"
    }
  }}
>
  {/* Header estilo CargarFlujoDialog */}
  <DialogTitle
    sx={{
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      background: "linear-gradient(135deg, #1e3a5f 0%, #2d5a87 100%)",
      color: "#fff",
      py: 2,
      px: 3
    }}
  >
    <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
      <AutoAwesomeIcon sx={{ fontSize: 26, color: "#fbbf24" }} />
      <Typography sx={{ fontWeight: 700, fontSize: 20, letterSpacing: 0.5 }}>
        AI Agent Híbrido
      </Typography>
      {agentConfig.enabled && (
        <Chip
          label="Activo"
          size="small"
          sx={{
            ml: 1,
            background: "rgba(255,255,255,0.2)",
            color: "#fff",
            fontWeight: 600,
            fontSize: 11
          }}
        />
      )}
    </Box>
    {currentFlowId && (
      <Chip
        label={`Chatbot #${currentFlowId}`}
        size="small"
        sx={{
          background: "rgba(255,255,255,0.2)",
          color: "#fff",
          fontWeight: 500,
          fontSize: 11
        }}
      />
    )}
  </DialogTitle>

  <DialogContent sx={{ p: 0 }}>
    {!currentFlowId ? (
      <Box sx={{ p: 6, textAlign: "center", color: "#64748b" }}>
        <AutoAwesomeIcon sx={{ fontSize: 56, opacity: 0.3, mb: 2 }} />
        <Typography sx={{ fontWeight: 600, fontSize: 16, mb: 1 }}>
          No hay flujo cargado
        </Typography>
        <Typography sx={{ fontSize: 14 }}>
          Primero guarda el flujo para poder configurar el AI Agent.
        </Typography>
      </Box>
    ) : (
      <Box sx={{ display: "flex", height: "calc(85vh - 140px)", minHeight: 550 }}>
        {/* Panel izquierdo: Configuración */}
        <Box sx={{
          flex: 1,
          overflowY: "auto",
          background: "#fff",
          scrollbarWidth: "thin",
          scrollbarColor: "#cbd5e1 #f1f5f9",
          "&::-webkit-scrollbar": { width: 8 },
          "&::-webkit-scrollbar-track": { background: "#f1f5f9" },
          "&::-webkit-scrollbar-thumb": { background: "#cbd5e1", borderRadius: 4 }
        }}>
          {/* Toggle Activar/Desactivar */}
          <Box sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            px: 3,
            py: 2,
            borderBottom: "1px solid #e2e8f0",
            background: agentConfig.enabled ? "linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%)" : "#f8fafc"
          }}>
            <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
              <Box sx={{
                width: 40,
                height: 40,
                borderRadius: 2,
                background: agentConfig.enabled
                  ? "linear-gradient(135deg, #1e3a5f 0%, #2d5a87 100%)"
                  : "#e2e8f0",
                display: "flex",
                alignItems: "center",
                justifyContent: "center"
              }}>
                <AutoAwesomeIcon sx={{ fontSize: 22, color: agentConfig.enabled ? "#fbbf24" : "#94a3b8" }} />
              </Box>
              <Box>
                <Typography sx={{ fontWeight: 700, color: "#1e293b", fontSize: 15 }}>
                  {agentConfig.enabled ? "Agente Activo" : "Agente Desactivado"}
                </Typography>
                <Typography sx={{ fontSize: 12, color: "#64748b" }}>
                  Responde preguntas fuera del flujo estructurado
                </Typography>
              </Box>
            </Box>
            <Switch
              checked={agentConfig.enabled}
              onChange={(e) => setAgentConfig({ ...agentConfig, enabled: e.target.checked })}
              sx={{
                '& .MuiSwitch-switchBase.Mui-checked': { color: '#2d5a87' },
                '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': { backgroundColor: '#2d5a87' }
              }}
            />
          </Box>

          {agentConfig.enabled && (
            <Box sx={{ p: 3 }}>
              {/* Plantillas Médicas - Mejorado */}
              <Paper
                elevation={0}
                sx={{
                  mb: 3,
                  p: 2,
                  borderRadius: 3,
                  border: "1px solid #e2e8f0",
                  background: "linear-gradient(135deg, #fefce8 0%, #fff 100%)"
                }}
              >
                <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, mb: 2 }}>
                  <Box sx={{
                    width: 32,
                    height: 32,
                    borderRadius: 2,
                    background: "linear-gradient(135deg, #eab308 0%, #ca8a04 100%)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center"
                  }}>
                    <MenuBookIcon sx={{ fontSize: 18, color: "#fff" }} />
                  </Box>
                  <Box>
                    <Typography sx={{ fontWeight: 700, color: "#1e293b", fontSize: 14 }}>
                      Plantillas por Especialidad
                    </Typography>
                    <Typography sx={{ fontSize: 11, color: "#64748b" }}>
                      Configura rapidamente segun tu area
                    </Typography>
                  </Box>
                </Box>
                <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
                  {medicalTemplates.map((template) => (
                    <Chip
                      key={template.id}
                      label={`${template.icon} ${template.name}`}
                      onClick={() => applyMedicalTemplate(template)}
                      variant="outlined"
                      size="small"
                      sx={{
                        cursor: "pointer",
                        borderColor: "#e2e8f0",
                        fontWeight: 500,
                        background: "#fff",
                        "&:hover": {
                          bgcolor: "#eff6ff",
                          borderColor: "#2d5a87",
                          color: "#1e3a5f",
                          transform: "translateY(-1px)"
                        },
                        transition: "all 0.2s ease"
                      }}
                    />
                  ))}
                </Box>
              </Paper>

              {/* Máximo de turnos - Mejorado */}
              <Paper
                elevation={0}
                sx={{
                  mb: 3,
                  p: 2,
                  borderRadius: 3,
                  border: "1px solid #e2e8f0",
                  background: "#fff"
                }}
              >
                <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", flexWrap: "wrap", gap: 2 }}>
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
                    <Box sx={{
                      width: 32,
                      height: 32,
                      borderRadius: 2,
                      background: "linear-gradient(135deg, #8b5cf6 0%, #7c3aed 100%)",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center"
                    }}>
                      <TimerIcon sx={{ fontSize: 18, color: "#fff" }} />
                    </Box>
                    <Box>
                      <Typography sx={{ fontWeight: 700, color: "#1e293b", fontSize: 14 }}>
                        Maximo de turnos
                      </Typography>
                      <Typography sx={{ fontSize: 11, color: "#64748b" }}>
                        Antes de volver al flujo principal
                      </Typography>
                    </Box>
                  </Box>
                  <Box sx={{ display: "flex", gap: 0.75 }}>
                    {[1, 2, 3, 4, 5].map((num) => (
                      <Button
                        key={num}
                        variant={agentConfig.max_agent_turns === num ? "contained" : "outlined"}
                        size="small"
                        onClick={() => setAgentConfig({ ...agentConfig, max_agent_turns: num })}
                        sx={{
                          minWidth: 40,
                          height: 40,
                          fontWeight: 700,
                          borderRadius: 2,
                          fontSize: 15,
                          ...(agentConfig.max_agent_turns === num ? {
                            background: "linear-gradient(135deg, #1e3a5f 0%, #2d5a87 100%)",
                            border: "none",
                            boxShadow: "0 2px 8px rgba(30,58,95,0.3)",
                            "&:hover": { background: "linear-gradient(135deg, #1e3a5f 0%, #3b6a9b 100%)" }
                          } : {
                            borderColor: "#e2e8f0",
                            color: "#64748b",
                            background: "#f8fafc",
                            "&:hover": { borderColor: "#2d5a87", color: "#1e3a5f", bgcolor: "#eff6ff" }
                          })
                        }}
                      >
                        {num}
                      </Button>
                    ))}
                  </Box>
                </Box>
              </Paper>

              {/* Instrucciones de comportamiento - Mejorado con Card */}
              <Paper
                elevation={0}
                sx={{
                  mb: 3,
                  p: 2.5,
                  borderRadius: 3,
                  border: "1px solid #e2e8f0",
                  background: "linear-gradient(180deg, #fff 0%, #fafbfc 100%)"
                }}
              >
                <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, mb: 2 }}>
                  <Box sx={{
                    width: 32,
                    height: 32,
                    borderRadius: 2,
                    background: "linear-gradient(135deg, #1e3a5f 0%, #2d5a87 100%)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center"
                  }}>
                    <EditNoteIcon sx={{ fontSize: 18, color: "#fff" }} />
                  </Box>
                  <Box>
                    <Typography sx={{ fontWeight: 700, color: "#1e293b", fontSize: 14 }}>
                      Instrucciones de Comportamiento
                    </Typography>
                    <Typography sx={{ fontSize: 11, color: "#64748b" }}>
                      Define como debe responder el agente
                    </Typography>
                  </Box>
                </Box>
                <TextField
                  fullWidth
                  multiline
                  rows={3}
                  placeholder="Ej: Sé amable y profesional. Si preguntan sobre síntomas, sugiere agendar cita..."
                  value={agentConfig.system_prompt}
                  onChange={(e) => setAgentConfig({ ...agentConfig, system_prompt: e.target.value })}
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      borderRadius: 2.5,
                      fontSize: 13,
                      background: "#fff",
                      border: "1px solid #e2e8f0",
                      '& fieldset': { border: "none" },
                      '&:hover': { borderColor: '#2d5a87' },
                      '&.Mui-focused': { borderColor: '#2d5a87', borderWidth: 2 }
                    }
                  }}
                />
              </Paper>

              {/* ===== BASE DE CONOCIMIENTOS ESTRUCTURADA ===== */}
              <Paper
                elevation={0}
                sx={{
                  mt: 3,
                  p: 2.5,
                  borderRadius: 3,
                  border: "1px solid #e2e8f0",
                  background: "#fff"
                }}
              >
                <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", mb: 2 }}>
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
                    <Box sx={{
                      width: 32,
                      height: 32,
                      borderRadius: 2,
                      background: "linear-gradient(135deg, #8b5cf6 0%, #6d28d9 100%)",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center"
                    }}>
                      <LibraryBooksIcon sx={{ fontSize: 18, color: "#fff" }} />
                    </Box>
                    <Box>
                      <Typography sx={{ fontWeight: 700, color: "#1e293b", fontSize: 14 }}>
                        Base de Conocimientos Estructurada
                      </Typography>
                      <Typography sx={{ fontSize: 11, color: "#64748b" }}>
                        Entradas organizadas por categoria para respuestas precisas
                      </Typography>
                    </Box>
                  </Box>
                  <Button
                    size="small"
                    variant="contained"
                    startIcon={<AddIcon />}
                    onClick={() => openKbEntryEditor()}
                    sx={{
                      textTransform: "none",
                      fontWeight: 600,
                      fontSize: 12,
                      background: "linear-gradient(135deg, #8b5cf6 0%, #6d28d9 100%)",
                      borderRadius: 2,
                      px: 2,
                      "&:hover": { background: "linear-gradient(135deg, #7c3aed 0%, #5b21b6 100%)" }
                    }}
                  >
                    Nueva Entrada
                  </Button>
                </Box>

                {/* Lista de entradas */}
                {kbLoading ? (
                  <Box sx={{ display: "flex", justifyContent: "center", py: 3 }}>
                    <CircularProgress size={24} />
                  </Box>
                ) : kbEntries.length === 0 ? (
                  <Box sx={{
                    textAlign: "center",
                    py: 4,
                    background: "#f8fafc",
                    borderRadius: 2,
                    border: "1px dashed #e2e8f0"
                  }}>
                    <LibraryBooksIcon sx={{ fontSize: 40, color: "#cbd5e1", mb: 1 }} />
                    <Typography sx={{ fontSize: 13, color: "#94a3b8" }}>
                      No hay entradas en la base de conocimientos
                    </Typography>
                    <Typography sx={{ fontSize: 11, color: "#cbd5e1", mt: 0.5 }}>
                      Agrega informacion sobre precios, horarios, servicios, etc.
                    </Typography>
                  </Box>
                ) : (
                  <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
                    {kbEntries.map((entry) => (
                      <Box
                        key={entry.id}
                        sx={{
                          display: "flex",
                          alignItems: "flex-start",
                          justifyContent: "space-between",
                          p: 1.5,
                          borderRadius: 2,
                          border: "1px solid #e2e8f0",
                          background: entry.enabled ? "#fff" : "#f8fafc",
                          opacity: entry.enabled ? 1 : 0.6,
                          "&:hover": { borderColor: "#8b5cf6", background: "#faf5ff" }
                        }}
                      >
                        <Box sx={{ flex: 1 }}>
                          <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 0.5 }}>
                            <Chip
                              label={kbCategories[entry.category] || entry.category}
                              size="small"
                              sx={{
                                fontSize: 10,
                                height: 20,
                                background: "#ede9fe",
                                color: "#6d28d9",
                                fontWeight: 600
                              }}
                            />
                            {entry.priority > 0 && (
                              <Chip
                                label={`Prioridad ${entry.priority}`}
                                size="small"
                                sx={{ fontSize: 9, height: 18, background: "#fef3c7", color: "#92400e" }}
                              />
                            )}
                          </Box>
                          <Typography sx={{ fontWeight: 600, fontSize: 13, color: "#1e293b" }}>
                            {entry.title}
                          </Typography>
                          <Typography sx={{ fontSize: 11, color: "#64748b", mt: 0.5 }} noWrap>
                            {entry.content.substring(0, 100)}{entry.content.length > 100 ? "..." : ""}
                          </Typography>
                          {entry.keywords && (
                            <Box sx={{ display: "flex", gap: 0.5, mt: 1, flexWrap: "wrap" }}>
                              {entry.keywords.split(",").slice(0, 3).map((kw, i) => (
                                <Chip
                                  key={i}
                                  label={kw.trim()}
                                  size="small"
                                  sx={{ fontSize: 9, height: 16, background: "#f1f5f9" }}
                                />
                              ))}
                            </Box>
                          )}
                        </Box>
                        <Box sx={{ display: "flex", gap: 0.5 }}>
                          <IconButton
                            size="small"
                            onClick={() => openKbEntryEditor(entry)}
                            sx={{ color: "#64748b", "&:hover": { color: "#8b5cf6" } }}
                          >
                            <EditIcon sx={{ fontSize: 16 }} />
                          </IconButton>
                          <IconButton
                            size="small"
                            onClick={() => deleteKbEntry(entry.id)}
                            sx={{ color: "#64748b", "&:hover": { color: "#ef4444" } }}
                          >
                            <DeleteIcon sx={{ fontSize: 16 }} />
                          </IconButton>
                        </Box>
                      </Box>
                    ))}
                  </Box>
                )}
              </Paper>
            </Box>
          )}
        </Box>

        {/* Panel derecho: Mini-chat de prueba - Mejorado */}
        {agentConfig.enabled && (
          <Box sx={{
            width: 420,
            minWidth: 380,
            display: "flex",
            flexDirection: "column",
            borderLeft: "2px solid #e2e8f0",
            background: "linear-gradient(180deg, #f1f5f9 0%, #f8fafc 100%)",
            boxShadow: "-4px 0 16px rgba(0,0,0,0.03)"
          }}>
            {/* Header del chat - Mejorado */}
            <Box sx={{
              px: 2.5,
              py: 2,
              borderBottom: "none",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              background: "linear-gradient(135deg, #1e3a5f 0%, #2d5a87 100%)",
              boxShadow: "0 4px 12px rgba(30,58,95,0.15)"
            }}>
              <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
                <Box sx={{
                  width: 36,
                  height: 36,
                  borderRadius: "50%",
                  background: "rgba(255,255,255,0.15)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center"
                }}>
                  <ChatIcon sx={{ fontSize: 20, color: "#fff" }} />
                </Box>
                <Box>
                  <Typography sx={{ fontWeight: 700, fontSize: 15, color: "#fff" }}>
                    Probar Agente
                  </Typography>
                  <Typography sx={{ fontSize: 11, color: "rgba(255,255,255,0.7)" }}>
                    Simula una conversacion
                  </Typography>
                </Box>
              </Box>
              <Tooltip title="Limpiar chat" arrow>
                <IconButton size="small" onClick={clearAgentChat} sx={{
                  color: "rgba(255,255,255,0.8)",
                  background: "rgba(255,255,255,0.1)",
                  "&:hover": { color: "#fff", background: "rgba(255,255,255,0.2)" }
                }}>
                  <RestartAltIcon sx={{ fontSize: 18 }} />
                </IconButton>
              </Tooltip>
            </Box>

            {/* Mensajes - Mejorado */}
            <Box sx={{
              flex: 1,
              p: 2.5,
              overflowY: "auto",
              display: "flex",
              flexDirection: "column",
              gap: 2,
              scrollbarWidth: "thin",
              scrollbarColor: "#cbd5e1 transparent",
              "&::-webkit-scrollbar": { width: 6 },
              "&::-webkit-scrollbar-track": { background: "transparent" },
              "&::-webkit-scrollbar-thumb": { background: "#cbd5e1", borderRadius: 3 }
            }}>
              {agentChatHistory.length === 0 && (
                <Box sx={{
                  textAlign: "center",
                  py: 6,
                  px: 3,
                  background: "#fff",
                  borderRadius: 3,
                  border: "1px dashed #e2e8f0",
                  mt: 2
                }}>
                  <Box sx={{
                    width: 64,
                    height: 64,
                    borderRadius: "50%",
                    background: "linear-gradient(135deg, #e2e8f0 0%, #f1f5f9 100%)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    margin: "0 auto",
                    mb: 2.5
                  }}>
                    <ChatIcon sx={{ fontSize: 30, color: "#64748b" }} />
                  </Box>
                  <Typography sx={{ fontSize: 14, color: "#475569", fontWeight: 600, mb: 1 }}>
                    Prueba tu agente
                  </Typography>
                  <Typography sx={{ fontSize: 12, color: "#94a3b8", lineHeight: 1.5 }}>
                    Escribe un mensaje para simular una conversacion y verificar el comportamiento del agente
                  </Typography>
                  <Box sx={{ mt: 2, display: "flex", flexWrap: "wrap", gap: 0.5, justifyContent: "center" }}>
                    <Chip label="¿Cuanto cuesta?" size="small" sx={{ fontSize: 10, bgcolor: "#f1f5f9" }} />
                    <Chip label="Quiero una cita" size="small" sx={{ fontSize: 10, bgcolor: "#f1f5f9" }} />
                    <Chip label="¿Que horario tienen?" size="small" sx={{ fontSize: 10, bgcolor: "#f1f5f9" }} />
                  </Box>
                </Box>
              )}
              {agentChatHistory.map((msg, idx) => (
                <Box
                  key={idx}
                  sx={{
                    alignSelf: msg.role === "user" ? "flex-end" : "flex-start",
                    maxWidth: "85%"
                  }}
                >
                  <Box sx={{
                    p: 1.5,
                    borderRadius: 2,
                    bgcolor: msg.role === "user"
                      ? "linear-gradient(135deg, #1e3a5f 0%, #2d5a87 100%)"
                      : msg.role === "error" ? "#fee2e2" : "#fff",
                    background: msg.role === "user"
                      ? "linear-gradient(135deg, #1e3a5f 0%, #2d5a87 100%)"
                      : msg.role === "error" ? "#fee2e2" : "#fff",
                    color: msg.role === "user" ? "#fff" : msg.role === "error" ? "#dc2626" : "#1e293b",
                    boxShadow: "0 1px 3px rgba(0,0,0,0.08)"
                  }}>
                    {/* Respuesta principal */}
                    <Typography sx={{ fontSize: 13, whiteSpace: "pre-wrap", lineHeight: 1.5 }}>
                      {msg.content?.split("\n\n[Accion:")[0] || msg.content}
                    </Typography>

                    {/* Badge de acción si existe */}
                    {msg.actionType && (
                      <Box sx={{
                        mt: 1.5,
                        pt: 1,
                        borderTop: "1px solid rgba(0,0,0,0.08)",
                        display: "flex",
                        alignItems: "center",
                        gap: 0.75
                      }}>
                        <Chip
                          size="small"
                          icon={msg.actionType === "IR_A_NODO" ? <ArrowForwardIosIcon sx={{ fontSize: "12px !important" }} /> : <CheckCircleIcon sx={{ fontSize: "12px !important" }} />}
                          label={
                            msg.actionType === "IR_A_NODO"
                              ? `Ir a: ${nodes.find(n => n.id === msg.targetNode)?.data?.label || msg.targetNode}`
                              : msg.actionType === "FINALIZAR_CONVERSACION"
                                ? "Finalizar conversacion"
                                : "Responder"
                          }
                          sx={{
                            height: 22,
                            fontSize: 10,
                            fontWeight: 600,
                            background: msg.actionType === "IR_A_NODO"
                              ? "linear-gradient(135deg, #10b981 0%, #059669 100%)"
                              : msg.actionType === "FINALIZAR_CONVERSACION"
                                ? "linear-gradient(135deg, #f59e0b 0%, #d97706 100%)"
                                : "#6366f1",
                            color: "#fff",
                            "& .MuiChip-icon": { color: "#fff" }
                          }}
                        />
                      </Box>
                    )}
                  </Box>
                  <Typography sx={{
                    fontSize: 10,
                    mt: 0.5,
                    color: "#94a3b8",
                    textAlign: msg.role === "user" ? "right" : "left"
                  }}>
                    {msg.role === "user" ? "Tú" : msg.role === "error" ? "Error" : msg.actionType ? "🎯 Accion detectada" : "🤖 AI Agent"}
                  </Typography>
                </Box>
              ))}
              {agentTestLoading && (
                <Box sx={{ alignSelf: "flex-start", display: "flex", alignItems: "center", gap: 1, p: 1.5 }}>
                  <CircularProgress size={14} sx={{ color: "#2d5a87" }} />
                  <Typography sx={{ fontSize: 12, color: "#64748b" }}>
                    Pensando...
                  </Typography>
                </Box>
              )}
            </Box>

            {/* Input de mensaje - Mejorado */}
            <Box sx={{
              p: 2.5,
              borderTop: "1px solid #e2e8f0",
              background: "#fff",
              boxShadow: "0 -4px 12px rgba(0,0,0,0.03)"
            }}>
              <Box sx={{
                display: "flex",
                gap: 1.5,
                alignItems: "center",
                background: "#f8fafc",
                p: 1,
                borderRadius: 3,
                border: "1px solid #e2e8f0"
              }}>
                <TextField
                  fullWidth
                  size="small"
                  placeholder="Escribe un mensaje de prueba..."
                  value={agentTestMessage}
                  onChange={(e) => setAgentTestMessage(e.target.value)}
                  onKeyPress={(e) => e.key === "Enter" && !e.shiftKey && testAgentResponse()}
                  disabled={agentTestLoading}
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      borderRadius: 2,
                      fontSize: 13,
                      background: "#fff",
                      '& fieldset': { borderColor: 'transparent' },
                      '&:hover fieldset': { borderColor: '#2d5a87' },
                      '&.Mui-focused fieldset': { borderColor: '#2d5a87' }
                    }
                  }}
                />
                <IconButton
                  onClick={testAgentResponse}
                  disabled={agentTestLoading || !agentTestMessage.trim()}
                  sx={{
                    background: "linear-gradient(135deg, #1e3a5f 0%, #2d5a87 100%)",
                    color: "#fff",
                    borderRadius: 2.5,
                    width: 42,
                    height: 42,
                    boxShadow: "0 2px 8px rgba(30,58,95,0.3)",
                    "&:hover": {
                      background: "linear-gradient(135deg, #1e3a5f 0%, #3b6a9b 100%)",
                      transform: "scale(1.05)"
                    },
                    "&:disabled": { background: "#e2e8f0", color: "#94a3b8", boxShadow: "none" },
                    transition: "all 0.2s ease"
                  }}
                >
                  <SendIcon sx={{ fontSize: 18 }} />
                </IconButton>
              </Box>
              <Typography sx={{ fontSize: 10, color: "#94a3b8", mt: 1, textAlign: "center" }}>
                Presiona Enter para enviar
              </Typography>
            </Box>
          </Box>
        )}
      </Box>
    )}
  </DialogContent>

  <DialogActions sx={{
    px: 3,
    py: 2.5,
    borderTop: "1px solid #e2e8f0",
    background: "linear-gradient(180deg, #fff 0%, #f8fafc 100%)",
    gap: 1.5
  }}>
    <Button
      onClick={() => { setOpenAgentDialog(false); clearAgentChat(); }}
      variant="outlined"
      sx={{
        borderRadius: 2.5,
        fontWeight: 600,
        px: 4,
        py: 1,
        borderColor: "#e2e8f0",
        color: "#64748b",
        "&:hover": { background: "#f1f5f9", borderColor: "#94a3b8" }
      }}
    >
      Cerrar
    </Button>
    {currentFlowId && (
      <Button
        onClick={saveAgentConfig}
        variant="contained"
        disabled={agentLoading}
        sx={{
          borderRadius: 2.5,
          fontWeight: 600,
          px: 4,
          py: 1,
          background: "linear-gradient(135deg, #1e3a5f 0%, #2d5a87 100%)",
          boxShadow: "0 4px 12px rgba(30,58,95,0.25)",
          "&:hover": {
            background: "linear-gradient(135deg, #1e3a5f 0%, #3b6a9b 100%)",
            boxShadow: "0 6px 16px rgba(30,58,95,0.35)"
          },
          "&:disabled": { background: "#e2e8f0", boxShadow: "none" }
        }}
        startIcon={agentLoading ? <CircularProgress size={18} sx={{ color: "#fff" }} /> : <SaveIcon />}
      >
        {agentLoading ? "Guardando..." : "Guardar Configuracion"}
      </Button>
    )}
  </DialogActions>
</Dialog>

{/* ===== DIALOG EDITOR DE KB ESTRUCTURADA ===== */}
<Dialog
  open={openKbEditor}
  onClose={() => { setOpenKbEditor(false); resetKbForm(); }}
  maxWidth="sm"
  fullWidth
  PaperProps={{
    sx: {
      borderRadius: 3,
      background: "#f8fafc",
      boxShadow: "0 8px 32px rgba(30, 58, 95, 0.15)",
      border: "none",
      overflow: "hidden"
    }
  }}
>
  {/* Header - Estilo Flujos Guardados */}
  <DialogTitle
    sx={{
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      background: "linear-gradient(135deg, #1e3a5f 0%, #2d5a87 100%)",
      color: "#fff",
      py: 2,
      px: 3
    }}
  >
    <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
      <LibraryBooksIcon sx={{ fontSize: 26, color: "#fbbf24" }} />
      <Typography sx={{ fontWeight: 700, fontSize: 18, letterSpacing: 0.5 }}>
        {editingKbEntry ? "Editar Entrada" : "Nueva Entrada"}
      </Typography>
      <Chip
        label="Base de Conocimiento"
        size="small"
        sx={{
          ml: 1,
          background: "rgba(255,255,255,0.2)",
          color: "#fff",
          fontWeight: 600,
          fontSize: 11
        }}
      />
    </Box>
    <IconButton
      size="small"
      onClick={() => { setOpenKbEditor(false); resetKbForm(); }}
      sx={{
        color: "rgba(255,255,255,0.7)",
        "&:hover": { color: "#fff", background: "rgba(255,255,255,0.1)" }
      }}
    >
      <CancelIcon sx={{ fontSize: 22 }} />
    </IconButton>
  </DialogTitle>

  <DialogContent sx={{ p: 0 }}>
    {/* Sección de categoría destacada */}
    <Box sx={{
      px: 3,
      py: 2,
      borderBottom: "1px solid #e2e8f0",
      background: "#fff"
    }}>
      <FormControl fullWidth size="small">
        <InputLabel>Categoria</InputLabel>
        <Select
          value={kbFormData.category}
          label="Categoria"
          onChange={(e) => setKbFormData({ ...kbFormData, category: e.target.value })}
          sx={{ borderRadius: 2, background: "#f8fafc" }}
        >
          {Object.entries(kbCategories).map(([key, label]) => (
            <MenuItem key={key} value={key}>
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <Box sx={{
                  width: 8,
                  height: 8,
                  borderRadius: "50%",
                  background: key === "faq" ? "#3b82f6" :
                             key === "precios" ? "#10b981" :
                             key === "horarios" ? "#f59e0b" :
                             key === "servicios" ? "#8b5cf6" : "#64748b"
                }} />
                {label}
              </Box>
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>

    {/* Contenido del formulario */}
    <Box sx={{ p: 3, display: "flex", flexDirection: "column", gap: 2.5 }}>
      {/* Título */}
      <Box>
        <Typography sx={{ fontSize: 12, fontWeight: 600, color: "#1e3a5f", mb: 1, display: "flex", alignItems: "center", gap: 0.5 }}>
          <Box component="span" sx={{ color: "#fbbf24" }}>*</Box> Titulo / Pregunta
        </Typography>
        <TextField
          fullWidth
          size="small"
          placeholder="Ej: ¿Cual es el horario de atencion?"
          value={kbFormData.title}
          onChange={(e) => setKbFormData({ ...kbFormData, title: e.target.value })}
          sx={{
            '& .MuiOutlinedInput-root': {
              borderRadius: 2,
              background: "#fff",
              '&:hover fieldset': { borderColor: "#2d5a87" },
              '&.Mui-focused fieldset': { borderColor: "#1e3a5f" }
            }
          }}
        />
      </Box>

      {/* Contenido */}
      <Box>
        <Typography sx={{ fontSize: 12, fontWeight: 600, color: "#1e3a5f", mb: 1, display: "flex", alignItems: "center", gap: 0.5 }}>
          <Box component="span" sx={{ color: "#fbbf24" }}>*</Box> Contenido / Respuesta
        </Typography>
        <TextField
          fullWidth
          multiline
          rows={4}
          placeholder="Ej: Nuestro horario de atencion es de lunes a viernes de 8am a 6pm..."
          value={kbFormData.content}
          onChange={(e) => setKbFormData({ ...kbFormData, content: e.target.value })}
          sx={{
            '& .MuiOutlinedInput-root': {
              borderRadius: 2,
              background: "#fff",
              '&:hover fieldset': { borderColor: "#2d5a87" },
              '&.Mui-focused fieldset': { borderColor: "#1e3a5f" }
            }
          }}
        />
      </Box>

      {/* Keywords - Sistema de Chips */}
      <Box>
        <Typography sx={{ fontSize: 12, fontWeight: 600, color: "#1e3a5f", mb: 1 }}>
          Palabras clave
        </Typography>

        {/* Chips de keywords existentes */}
        {getKeywordsArray().length > 0 && (
          <Box sx={{
            display: "flex",
            flexWrap: "wrap",
            gap: 0.5,
            mb: 1.5,
            p: 1.5,
            background: "#f8fafc",
            borderRadius: 2,
            border: "1px solid #e2e8f0"
          }}>
            {getKeywordsArray().map((keyword, idx) => (
              <Chip
                key={idx}
                label={keyword}
                size="small"
                onDelete={() => removeKeyword(keyword)}
                sx={{
                  background: "linear-gradient(135deg, #e0e7ff 0%, #c7d2fe 100%)",
                  color: "#3730a3",
                  fontWeight: 500,
                  fontSize: 12,
                  '& .MuiChip-deleteIcon': {
                    color: "#6366f1",
                    '&:hover': { color: "#4338ca" }
                  }
                }}
              />
            ))}
          </Box>
        )}

        {/* Input para agregar nueva keyword */}
        <Box sx={{ display: "flex", gap: 1 }}>
          <TextField
            fullWidth
            size="small"
            placeholder="Escribe una palabra clave y presiona Enter"
            value={kbKeywordInput}
            onChange={(e) => setKbKeywordInput(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                e.preventDefault();
                addKeyword(kbKeywordInput);
              }
            }}
            sx={{
              '& .MuiOutlinedInput-root': {
                borderRadius: 2,
                background: "#fff",
                '&:hover fieldset': { borderColor: "#2d5a87" },
                '&.Mui-focused fieldset': { borderColor: "#1e3a5f" }
              }
            }}
          />
          <Button
            variant="contained"
            size="small"
            onClick={() => addKeyword(kbKeywordInput)}
            disabled={!kbKeywordInput.trim()}
            sx={{
              minWidth: 80,
              borderRadius: 2,
              textTransform: "none",
              fontWeight: 600,
              background: "linear-gradient(135deg, #6366f1 0%, #4f46e5 100%)",
              "&:hover": { background: "linear-gradient(135deg, #4f46e5 0%, #4338ca 100%)" },
              "&:disabled": { background: "#e2e8f0" }
            }}
          >
            Agregar
          </Button>
        </Box>
        <Typography sx={{ fontSize: 11, color: "#94a3b8", mt: 0.5 }}>
          Ayudan a encontrar esta entrada mas rapido. Presiona Enter o clic en Agregar.
        </Typography>
      </Box>

      {/* Prioridad - Diseño mejorado */}
      <Box sx={{
        p: 2,
        borderRadius: 2,
        background: "linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%)",
        border: "1px solid #e2e8f0"
      }}>
        <Typography sx={{ fontSize: 12, fontWeight: 600, color: "#1e3a5f", mb: 1.5 }}>
          Prioridad de la entrada
        </Typography>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          {[
            { value: 0, label: "Baja", color: "#94a3b8" },
            { value: 1, label: "Normal", color: "#3b82f6" },
            { value: 2, label: "Alta", color: "#f59e0b" },
            { value: 3, label: "Critica", color: "#ef4444" }
          ].map((p) => (
            <Button
              key={p.value}
              size="small"
              variant={kbFormData.priority === p.value ? "contained" : "outlined"}
              onClick={() => setKbFormData({ ...kbFormData, priority: p.value })}
              sx={{
                flex: 1,
                borderRadius: 2,
                fontSize: 11,
                fontWeight: 600,
                textTransform: "none",
                py: 1,
                ...(kbFormData.priority === p.value ? {
                  background: p.color,
                  borderColor: p.color,
                  color: "#fff",
                  "&:hover": { background: p.color, filter: "brightness(0.9)" }
                } : {
                  borderColor: "#e2e8f0",
                  color: "#64748b",
                  "&:hover": { borderColor: p.color, color: p.color, background: "transparent" }
                })
              }}
            >
              {p.label}
            </Button>
          ))}
        </Box>
        <Typography sx={{ fontSize: 10, color: "#94a3b8", mt: 1, textAlign: "center" }}>
          Mayor prioridad = aparece primero en busquedas
        </Typography>
      </Box>
    </Box>
  </DialogContent>

  <DialogActions sx={{ px: 3, py: 2, borderTop: "1px solid #e2e8f0", background: "#fff" }}>
    <Button
      onClick={() => { setOpenKbEditor(false); resetKbForm(); }}
      variant="outlined"
      sx={{
        borderRadius: 2,
        fontWeight: 600,
        px: 3,
        borderColor: "#e2e8f0",
        color: "#64748b",
        "&:hover": { background: "#f1f5f9", borderColor: "#94a3b8" }
      }}
    >
      Cancelar
    </Button>
    <Button
      onClick={saveKbEntry}
      variant="contained"
      disabled={!kbFormData.title || !kbFormData.content}
      sx={{
        borderRadius: 2,
        fontWeight: 600,
        px: 3,
        background: "linear-gradient(135deg, #1e3a5f 0%, #2d5a87 100%)",
        "&:hover": { background: "linear-gradient(135deg, #2d5a87 0%, #3b6a9b 100%)" },
        "&:disabled": { background: "#e2e8f0", color: "#94a3b8" }
      }}
      startIcon={<SaveIcon />}
    >
      {editingKbEntry ? "Actualizar" : "Guardar"}
    </Button>
  </DialogActions>
</Dialog>

<Dialog
  open={openVariablesDialog}
  onClose={() => setOpenVariablesDialog(false)}
  maxWidth="sm"
  fullWidth
>
  <DialogTitle sx={{ fontWeight: 800, color: "#6366f1", fontSize: 22 }}>
    Variables por contexto
  </DialogTitle>
  <DialogContent>
    
    <Autocomplete
      options={[...contextOptions].sort((a, b) => a.nombre.localeCompare(b.nombre, 'es', { sensitivity: 'base' }))}
      getOptionLabel={opt => opt.nombre}
      value={contextOptions.find(opt => opt.id === selectedContext) || null}
      onChange={(e, newValue) => setSelectedContext(newValue ? newValue.id : "")}
      filterOptions={(options, { inputValue }) =>
        options.filter(opt =>
          opt.nombre.toLowerCase().startsWith(inputValue.trim().toLowerCase())
        )
      }
      renderInput={params => (
        <TextField
          {...params}
          label="Selecciona contexto"
          size="small"
          sx={{ mb: 3, maxWidth: 260 }}
          InputLabelProps={{ sx: { fontWeight: 700, color: "#6366f1" } }}
        />
      )}
    />

    {selectedContext && (
      <>
        <Box sx={{ mb: 3 }}>
          <Box sx={{ fontWeight: 700, color: "#334155", mb: 1.5, fontSize: 17 }}>
            Variables existentes
          </Box>
          {variablesList.length === 0 ? (
            <Box sx={{ color: "#6366f1", mt: 1, fontWeight: 500 }}>No hay variables para este contexto.</Box>
          ) : (
            <Box sx={{
              border: "1px solid #e0e7ef",
              borderRadius: 2,
              background: "#f8fafc",
              p: 1.5,
              mb: 1,
              maxHeight: 180,
              overflowY: "auto"
            }}>
              {variablesList.map(v => (
  <Box key={v.id} sx={{
    py: 0.7,
    px: 1,
    borderBottom: "1px solid #e0e7ef",
    display: "flex",
    alignItems: "center",
    gap: 1
  }}>
    <b style={{ color: "#6366f1", minWidth: 90, display: "inline-block" }}>{v.nombre_variable}</b>
    <span style={{ color: "#10b981", fontWeight: 600, minWidth: 90 }}>{v.tipo_dato}</span>
    <span style={{ color: "#334155", opacity: 0.8, flex: 1 }}>{v.descripcion}</span>
    <IconButton
      size="small"
      color="error"
      sx={{
        ml: 1,
        borderRadius: "50%",
        background: "#fee2e2",
        border: "1.5px solid #f87171",
        transition: "background 0.2s, border 0.2s",
        "&:hover": {
          background: "#f87171",
          borderColor: "#e11d48",
          color: "#fff"
        }
      }}
      onClick={() => setVariableToDelete(v)}
      title="Eliminar variable"
    >
      <DeleteOutlineIcon fontSize="small" />
    </IconButton>
  </Box>
))}
            </Box>
          )}
        </Box>
        <Box sx={{
          mb: 2,
          p: 2,
          borderRadius: 3,
          background: "#fff",
          border: "1.5px solid #e0e7ef",
          boxShadow: "0 2px 12px #6366f122"
        }}>
          <Box sx={{ fontWeight: 700, color: "#334155", mb: 2, fontSize: 17 }}>
            Agregar nueva variable
          </Box>
          <Grid container spacing={2} alignItems="flex-start">
            <Grid item xs={2.5}>
              <TextField
                label="Nombre"
                value={newVariable.nombre_variable}
                onChange={e =>
                  setNewVariable(v => ({
                    ...v,
                    nombre_variable: e.target.value.toLowerCase().replace(/[^a-z0-9_]/g, "")
                  }))
                }
                fullWidth
                size="small"
                inputProps={{ style: { textTransform: "lowercase" } }}
                InputLabelProps={{ sx: { fontWeight: 600 } }}
                placeholder="nombre"
              />
            </Grid>
            <Grid item xs={2.5}>
              <TextField
                select
                label="Tipo"
                value={newVariable.tipo_dato}
                onChange={e => setNewVariable(v => ({ ...v, tipo_dato: e.target.value }))}
                fullWidth
                size="small"
                InputLabelProps={{ sx: { fontWeight: 600 } }}
              >
                <MenuItem value="texto">Texto</MenuItem>
                <MenuItem value="entero">Número entero</MenuItem>
                <MenuItem value="decimal">Número decimal</MenuItem>
                <MenuItem value="fecha">Fecha</MenuItem>
              </TextField>
            </Grid>
            <Grid item xs={12}>
              <TextField
                label="Descripción"
                value={newVariable.descripcion}
                onChange={e =>
                  setNewVariable(v => ({
                    ...v,
                    descripcion: e.target.value.toLowerCase()
                  }))
                }
                fullWidth
                size="small"
                multiline
                minRows={2}
                inputProps={{ style: { textTransform: "lowercase" } }}
                InputLabelProps={{ sx: { fontWeight: 600 } }}
                placeholder="descripción de la variable"
                sx={{ minWidth: 220, maxWidth: "100%" }}
              />
              <Button
                variant="contained"
                color="success"
                sx={{ mt: 1, fontWeight: 700, fontSize: 15, alignSelf: "flex-start" }}
                onClick={async () => {
                  const resp = await fetch("/api/input_variables/", {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({ ...newVariable, id_contexto: selectedContext }),
                  });
                  const data = await resp.json();
                  console.log("Respuesta al agregar variable:", data); // <-- Agrega esto

                  setNewVariable({ nombre_variable: "", tipo_dato: "texto", descripcion: "" });
                  // Recarga la lista
                  const res = await fetch(`/api/input_variables/?id_contexto=${selectedContext}`);
                  setVariablesList(await res.json());
                }}
                disabled={!newVariable.nombre_variable.trim() || !newVariable.descripcion.trim()}
              >
                Agregar
              </Button>
            </Grid>
          </Grid>
        </Box>
      </>
    )}
  </DialogContent>
  <DialogActions>
    <Button onClick={() => setOpenVariablesDialog(false)}>Cerrar</Button>
  </DialogActions>
</Dialog>

        {/* Diálogo de confirmación para eliminar variable */}
        <Dialog open={!!variableToDelete} onClose={() => setVariableToDelete(null)}>
          <DialogTitle>¿Eliminar variable?</DialogTitle>
          <DialogContent>
            ¿Seguro que deseas eliminar la variable <b>{variableToDelete?.nombre_variable}</b>?<br />
            Esta acción no se puede deshacer.
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setVariableToDelete(null)} color="primary">
              Cancelar
            </Button>
            <Button
              onClick={async () => {
                await fetch(`/api/input_variables/${variableToDelete.id}`, { method: "DELETE" });
                const res = await fetch(`/api/input_variables/?id_contexto=${selectedContext}`);
                setVariablesList(await res.json());
                setVariableToDelete(null);
              }}
              color="error"
              variant="contained"
            >
              Eliminar
            </Button>
          </DialogActions>
        </Dialog>

{/* Diálogo para administrar contextos 
Noviembre 10 de 2025
Autor:@elingerauli.dev
*/}
<AdministrarContextosDialog
  open={openContextosDialog}
  onClose={() => setOpenContextosDialog(false)}
  contextOptions={contextOptions}
  setContextOptions={setContextOptions}
  user={user}
  selectedContext={selectedContext}
  setSelectedContext={setSelectedContext}
  editingContext={editingContext}
  setEditingContext={setEditingContext}
  newContext={newContext}
  setNewContext={setNewContext}
  contextToDelete={contextToDelete}
  setContextToDelete={setContextToDelete}
  iaLoading={iaLoading}
  setIaLoading={setIaLoading}
/>
{/* Fin de diálogo para administrar contextos */}        

{/* Inicio de Diálogo para administrar tipos de mensaje 
Fecha: 10 de Noviembre de 2025
Autor: @elingerauli.dev
*/}
<AdministrarTiposMensajeDialog
  open={openTiposMensajeDialog}
  onClose={() => setOpenTiposMensajeDialog(false)}
  tiposMensaje={tiposMensaje}
  selectedTipoMensaje={selectedTipoMensaje}
  setSelectedTipoMensaje={setSelectedTipoMensaje}
  newTipoMensaje={newTipoMensaje}
  setNewTipoMensaje={setNewTipoMensaje}
  showTipoMensajeForm={showTipoMensajeForm}
  setShowTipoMensajeForm={setShowTipoMensajeForm}
  onSaveTipoMensaje={handleSaveTipoMensaje}
  onDeleteTipoMensaje={setTipoMensajeToDelete}
/> 

{/* Diálogo de confirmación para eliminar tipo de mensaje */}
<EliminarTipoMensajeDialog
  open={!!tipoMensajeToDelete}
  tipoMensajeToDelete={tipoMensajeToDelete}
  onClose={() => setTipoMensajeToDelete(null)}
  onConfirmDelete={handleDeleteTipoMensaje}
/>
{/* Fin de diálogo de confirmación para eliminar tipo de mensaje */}

{/* Inicio de Diálogo para administrar mensajes */}
<AdministrarMensajesDialog
  open={openMensajesDialog}
  onClose={() => setOpenMensajesDialog(false)}
  contextOptions={contextOptions}
  tiposMensaje={tiposMensaje}
  mensajes={mensajes}
  loadingMensajes={loadingMensajes}
  selectedMensaje={selectedMensaje}
  showMensajeForm={showMensajeForm}
  newMensaje={newMensaje}
  onNewMensajeChange={setNewMensaje}
  onSaveMensaje={handleSaveMensaje}
  onCancelMensajeForm={handleCancelMensajeForm}
  onEditMensaje={handleEditMensaje}
  onToggleActivoMensaje={handleToggleActivoMensaje}
  onDeleteMensaje={setMensajeToDelete}
  onCreateNew={() => {
    setSelectedMensaje(null);
    setNewMensaje({
      id_contexto: "",
      id_tipo_mensaje: "",
      mensaje: "",
      activo: true
    });
    setShowMensajeForm(true);
  }}
/>
{/* Fin de Diálogo para administrar mensajes */}

{/* Diálogo para confirmar eliminación de mensaje */}
<EliminarMensajeDialog
  open={!!mensajeToDelete}
  mensajeToDelete={mensajeToDelete}
  onClose={() => setMensajeToDelete(null)}
  onConfirmDelete={handleDeleteMensaje}
/>
{/* Fin de diálogo para confirmar eliminación de mensaje */}

<PreguntasPredefinidas
  open={openPreguntasDialog}
  onClose={() => setOpenPreguntasDialog(false)}
  user={user}
  contextOptions={contextOptions}
  predefinedQuestions={predefinedQuestions}
  preguntaVariables={preguntaVariables}
  loadingQuestions={loadingQuestions}
  onRefreshData={fetchPreguntas}
  showOnlyActive={showOnlyActive}
  setShowOnlyActive={setShowOnlyActive}
/>

{/* Diálogo para confirmar eliminación de pregunta
 Minicomponete EliminarPreguntaDialog.jsx
*/}
<EliminarPreguntaDialog
  open={!!preguntaToDelete}
  preguntaToDelete={preguntaToDelete}
  onClose={cancelDeletePregunta}
  onConfirmDelete={confirmDeletePregunta}
/>
{/* Fin de diálogo para confirmar eliminación de pregunta */}

{/* Inicio del popover para gestionar los contexto que aplican a las preguntas predefinidas*/ }
<ContextosPreguntaPopover
  open={Boolean(contextPopoverAnchor)}
  anchorEl={contextPopoverAnchor}
  onClose={() => {
    setContextPopoverAnchor(null);
    setSelectedPreguntaContextos([]);
  }}
  selectedPreguntaContextos={selectedPreguntaContextos}
  predefinedQuestions={predefinedQuestions}
  preguntaVariables={preguntaVariables}
  user={user}
  onUpdateContextos={setSelectedPreguntaContextos}
  onUpdatePreguntaVariables={setPreguntaVariables}
/>
{/* Fin del popover para gestionar los contexto que aplican a las preguntas predefinidas*/ }

<Dialog open={changelogOpen} onClose={handleCloseChangelogDialog} maxWidth="md" fullWidth>
      <DialogTitle>Changelog de la Plataforma</DialogTitle>
      <DialogContent>
        <div>
          <p>Próximamente: aquí podrás ver, crear, editar y borrar registros del changelog.</p>
        </div>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleCloseChangelogDialog} color="primary">Cerrar</Button>
      </DialogActions>
    </Dialog>

    {/* === DIÁLOGO DE VALIDACIÓN DEL FLUJO === */}
    <Dialog
      open={!!flowValidationResults}
      onClose={() => setFlowValidationResults(null)}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          bgcolor: "#1e293b",
          color: "#fff",
          borderRadius: 3,
          border: "1px solid #334155",
        }
      }}
    >
      <DialogTitle sx={{ borderBottom: "1px solid #334155", display: "flex", alignItems: "center", gap: 1 }}>
        <FactCheckIcon sx={{ color: "#10b981" }} />
        Resultados de Validación
      </DialogTitle>
      <DialogContent sx={{ mt: 2 }}>
        {flowValidationResults && (
          <>
            {flowValidationResults.errors.length === 0 && flowValidationResults.warnings.length === 0 ? (
              <Box sx={{ textAlign: "center", py: 3 }}>
                <CheckCircleOutlineIcon sx={{ fontSize: 60, color: "#10b981", mb: 2 }} />
                <Typography variant="h6" sx={{ color: "#10b981" }}>
                  ¡El flujo es válido!
                </Typography>
                <Typography variant="body2" sx={{ color: "#94a3b8", mt: 1 }}>
                  No se encontraron errores ni advertencias.
                </Typography>
              </Box>
            ) : (
              <>
                {flowValidationResults.errors.length > 0 && (
                  <Box sx={{ mb: 2 }}>
                    <Typography variant="subtitle2" sx={{ color: "#ef4444", mb: 1, display: "flex", alignItems: "center", gap: 1 }}>
                      <ErrorOutlineIcon fontSize="small" />
                      Errores ({flowValidationResults.errors.length})
                    </Typography>
                    {flowValidationResults.errors.map((error, i) => (
                      <Box key={i} sx={{ bgcolor: "rgba(239,68,68,0.1)", p: 1.5, borderRadius: 1, mb: 1, borderLeft: "3px solid #ef4444" }}>
                        <Typography variant="body2">{error}</Typography>
                      </Box>
                    ))}
                  </Box>
                )}
                {flowValidationResults.warnings.length > 0 && (
                  <Box>
                    <Typography variant="subtitle2" sx={{ color: "#f59e0b", mb: 1, display: "flex", alignItems: "center", gap: 1 }}>
                      <WarningAmberIcon fontSize="small" />
                      Advertencias ({flowValidationResults.warnings.length})
                    </Typography>
                    {flowValidationResults.warnings.map((warning, i) => (
                      <Box key={i} sx={{ bgcolor: "rgba(245,158,11,0.1)", p: 1.5, borderRadius: 1, mb: 1, borderLeft: "3px solid #f59e0b" }}>
                        <Typography variant="body2">{warning}</Typography>
                      </Box>
                    ))}
                  </Box>
                )}
              </>
            )}
          </>
        )}
      </DialogContent>
      <DialogActions sx={{ borderTop: "1px solid #334155", p: 2 }}>
        <Button onClick={() => setFlowValidationResults(null)} variant="contained" sx={{ bgcolor: "#334155" }}>
          Cerrar
        </Button>
      </DialogActions>
    </Dialog>

    {/* === DIÁLOGO DE ESTADÍSTICAS DEL FLUJO === */}
    <Dialog
      open={openStatsDialog}
      onClose={() => setOpenStatsDialog(false)}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          bgcolor: "#1e293b",
          color: "#fff",
          borderRadius: 3,
          border: "1px solid #334155",
        }
      }}
    >
      <DialogTitle sx={{ borderBottom: "1px solid #334155", display: "flex", alignItems: "center", gap: 1 }}>
        <QueryStatsIcon sx={{ color: "#0ea5e9" }} />
        Estadísticas del Flujo
      </DialogTitle>
      <DialogContent sx={{ mt: 2 }}>
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <Box sx={{ bgcolor: "#334155", p: 2, borderRadius: 2, textAlign: "center" }}>
              <Typography variant="h4" sx={{ color: "#10b981", fontWeight: 700 }}>{nodes.length}</Typography>
              <Typography variant="body2" sx={{ color: "#94a3b8" }}>Total Nodos</Typography>
            </Box>
          </Grid>
          <Grid item xs={6}>
            <Box sx={{ bgcolor: "#334155", p: 2, borderRadius: 2, textAlign: "center" }}>
              <Typography variant="h4" sx={{ color: "#0ea5e9", fontWeight: 700 }}>{edges.length}</Typography>
              <Typography variant="body2" sx={{ color: "#94a3b8" }}>Conexiones</Typography>
            </Box>
          </Grid>
          <Grid item xs={12}>
            <Typography variant="subtitle2" sx={{ color: "#94a3b8", mb: 1 }}>Tipos de Nodos:</Typography>
            <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
              {Object.entries(
                nodes.reduce((acc, n) => {
                  acc[n.data.type] = (acc[n.data.type] || 0) + 1;
                  return acc;
                }, {})
              ).map(([type, count]) => (
                <Chip
                  key={type}
                  label={`${type}: ${count}`}
                  size="small"
                  sx={{ bgcolor: "#475569", color: "#fff" }}
                />
              ))}
            </Box>
          </Grid>
          <Grid item xs={12}>
            <Typography variant="subtitle2" sx={{ color: "#94a3b8", mb: 1 }}>Variables definidas:</Typography>
            <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
              {nodes.filter(n => n.data.variable).map(n => (
                <Chip
                  key={n.id}
                  label={n.data.variable}
                  size="small"
                  sx={{ bgcolor: "#6366f1", color: "#fff" }}
                />
              ))}
              {nodes.filter(n => n.data.variable).length === 0 && (
                <Typography variant="body2" sx={{ color: "#64748b" }}>No hay variables definidas</Typography>
              )}
            </Box>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions sx={{ borderTop: "1px solid #334155", p: 2 }}>
        <Button onClick={() => setOpenStatsDialog(false)} variant="contained" sx={{ bgcolor: "#334155" }}>
          Cerrar
        </Button>
      </DialogActions>
    </Dialog>

    {/* === DIÁLOGO DE ATAJOS DE TECLADO === */}
    <Dialog
      open={openShortcutsDialog}
      onClose={() => setOpenShortcutsDialog(false)}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          bgcolor: "#1e293b",
          color: "#fff",
          borderRadius: 3,
          border: "1px solid #334155",
        }
      }}
    >
      <DialogTitle sx={{ borderBottom: "1px solid #334155", display: "flex", alignItems: "center", gap: 1 }}>
        <KeyboardIcon sx={{ color: "#8b5cf6" }} />
        Atajos de Teclado
      </DialogTitle>
      <DialogContent sx={{ mt: 2 }}>
        <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5 }}>
          {[
            { keys: "Ctrl + Z", action: "Deshacer última acción" },
            { keys: "Ctrl + Y", action: "Rehacer acción" },
            { keys: "Ctrl + S", action: "Guardar flujo" },
            { keys: "Delete / Backspace", action: "Eliminar nodo/conexión seleccionada" },
            { keys: "Ctrl + A", action: "Seleccionar todos los nodos" },
            { keys: "Ctrl + C", action: "Copiar nodo seleccionado" },
            { keys: "Ctrl + V", action: "Pegar nodo copiado" },
            { keys: "Scroll / Pinch", action: "Zoom in/out" },
            { keys: "Click + Arrastrar", action: "Mover canvas" },
            { keys: "Shift + Click", action: "Selección múltiple" },
          ].map((shortcut, i) => (
            <Box key={i} sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", py: 1, borderBottom: "1px solid #334155" }}>
              <Typography variant="body2" sx={{ color: "#94a3b8" }}>{shortcut.action}</Typography>
              <Box sx={{ display: "flex", gap: 0.5 }}>
                {shortcut.keys.split(" + ").map((key, j) => (
                  <Box
                    key={j}
                    sx={{
                      bgcolor: "#475569",
                      px: 1.5,
                      py: 0.5,
                      borderRadius: 1,
                      fontSize: "12px",
                      fontFamily: "monospace",
                      fontWeight: 600,
                      border: "1px solid #64748b",
                      boxShadow: "0 2px 0 #334155",
                    }}
                  >
                    {key.trim()}
                  </Box>
                ))}
              </Box>
            </Box>
          ))}
        </Box>
      </DialogContent>
      <DialogActions sx={{ borderTop: "1px solid #334155", p: 2 }}>
        <Button onClick={() => setOpenShortcutsDialog(false)} variant="contained" sx={{ bgcolor: "#334155" }}>
          Cerrar
        </Button>
      </DialogActions>
    </Dialog>

    {/* === SNACKBAR DE HERRAMIENTAS === */}
    <Snackbar
      open={toolsSnackbar.open}
      autoHideDuration={4000}
      onClose={() => setToolsSnackbar({ ...toolsSnackbar, open: false })}
      anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
    >
      <MuiAlert
        elevation={6}
        variant="filled"
        severity={toolsSnackbar.severity}
        onClose={() => setToolsSnackbar({ ...toolsSnackbar, open: false })}
        sx={{ borderRadius: 2 }}
      >
        {toolsSnackbar.message}
      </MuiAlert>
    </Snackbar>

    </Box>
  );
}



// Reemplaza la función isNodeVisible alrededor de la línea 4800:

// Reemplaza la función isNodeVisible alrededor de la línea 4800:

// ...existing code...

// Reemplaza la función isNodeVisible (alrededor de la línea 4800):
// ...existing code...

// Reemplaza la función isNodeVisible (alrededor de la línea 4800):
function isNodeVisible(node, edges, nodes) {
  // El primer nodo siempre es visible
  if (node.id === "1") return true;

  // Si es el primer nodo después del nodo inicial, también debe ser visible
  const incomingEdges = edges.filter(e => e.target === node.id);
  const isDirectlyAfterStart = incomingEdges.some(e => e.source === "1");
  
  if (isDirectlyAfterStart) {
    return true;
  }

  // Si no tiene edges entrantes, no es visible
  if (incomingEdges.length === 0) return false;

  // Verifica que al menos uno de los nodos padre haya sido completado
  for (const edge of incomingEdges) {
    const parentNode = nodes.find(n => n.id === edge.source);
    if (!parentNode) continue;

    // Si el padre es un nodo de opciones
    if (parentNode.data.type === "options") {
      const selected = parentNode.data.selectedOption;
      const expectedHandle = `option-${selected}`;
      if (typeof selected === "number" && edge.sourceHandle === expectedHandle) return true;
    } 
    // Si el padre es un nodo de menú
    else if (parentNode.data.type === "menu") {
      const selected = parentNode.data.selectedOption;
      const expectedHandle = `option-${selected}`;
      if (typeof selected === "number" && edge.sourceHandle === expectedHandle) return true;
    }
    // Si el padre es una pregunta abierta
    else if (parentNode.data.type === "open") {
      if (parentNode.data.respondido === true) return true;
    }
    // Si el padre es un nodo de mensaje
    else if (parentNode.data.type === "message") {
      return true;
    }
    // Si el padre es un nodo input
    else if (parentNode.data.type === "input") {
      if (parentNode.data.iaExtracted !== undefined && parentNode.data.iaExtracted !== null) return true;
    }
    // Si el padre es un nodo input_ia
    else if (parentNode.data.type === "input_ia") {
      if (parentNode.data.iaExtracted !== undefined && parentNode.data.iaExtracted !== null) return true;
    }
    // Si el padre es un nodo IA
    else if (parentNode.data.type === "ia") {
      if (parentNode.data.iaResponse && parentNode.data.iaResponse !== "Consultando a la IA...") return true;
    }
    // Si el padre es un nodo de finalización
    else if (parentNode.data.type === "end") {
      return true;
    }
  }

  return false;
}
// Definición del edge personalizado - Diseño compacto y elegante
function CustomEdge({ id, source, target, sourceX, sourceY, targetX, targetY, sourcePosition, targetPosition, style = {}, markerEnd, data, animated, selected }) {
  const { setEdges } = useReactFlow();
  const [isHovered, setIsHovered] = useState(false);

  // Path con curvas bezier suaves
  const [edgePath, labelX, labelY] = getSmoothStepPath({
    sourceX,
    sourceY,
    sourcePosition,
    targetX,
    targetY,
    targetPosition,
    borderRadius: 8,
  });

  // Colores elegantes según estado
  const getEdgeColor = () => {
    if (selected) return '#6366f1';
    if (isHovered) return '#a78bfa';
    return style.stroke || '#cbd5e1';
  };

  const getStrokeWidth = () => {
    if (selected) return 1.5;
    if (isHovered) return 1.2;
    return style.strokeWidth || 1;
  };

  return (
    <>
      {/* Área de interacción invisible */}
      <path
        d={edgePath}
        fill="none"
        stroke="transparent"
        strokeWidth={12}
        style={{ cursor: 'pointer' }}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      />

      {/* Edge principal */}
      <path
        d={edgePath}
        fill="none"
        stroke={getEdgeColor()}
        strokeWidth={getStrokeWidth()}
        strokeLinecap="round"
        style={{
          transition: 'all 0.15s ease',
          pointerEvents: 'none',
        }}
        markerEnd={markerEnd}
      />

      {/* Línea de flujo animada (solo cuando seleccionado) */}
      {selected && (
        <path
          d={edgePath}
          fill="none"
          stroke="#c7d2fe"
          strokeWidth={1}
          strokeLinecap="round"
          strokeDasharray="4 6"
          style={{
            animation: 'edgeFlowAnim 0.8s linear infinite',
            pointerEvents: 'none',
          }}
        />
      )}

      {/* Botón eliminar compacto */}
      {(animated || selected) && (
        <foreignObject
          width={14}
          height={14}
          x={labelX - 7}
          y={labelY - 7}
          style={{ overflow: 'visible' }}
        >
          <div
            style={{
              width: 14,
              height: 14,
              background: '#fff',
              borderRadius: '50%',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              cursor: 'pointer',
              boxShadow: '0 1px 3px rgba(0,0,0,0.12)',
              border: '1px solid #fca5a5',
              transition: 'all 0.15s ease',
            }}
            onClick={(event) => {
              event.stopPropagation();
              setEdges(edges => edges.filter(e => e.id !== id));
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'scale(1.2)';
              e.currentTarget.style.background = '#fef2f2';
              e.currentTarget.style.borderColor = '#ef4444';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'scale(1)';
              e.currentTarget.style.background = '#fff';
              e.currentTarget.style.borderColor = '#fca5a5';
            }}
            title="Eliminar"
          >
            <span style={{ fontSize: 8, color: '#ef4444', fontWeight: 700, lineHeight: 1 }}>×</span>
          </div>
        </foreignObject>
      )}

      <style>
        {`
          @keyframes edgeFlowAnim {
            from { stroke-dashoffset: 10; }
            to { stroke-dashoffset: 0; }
          }
        `}
      </style>
    </>
  );
}

const optionColors = [
  "#fbbf24", // amarillo
  "#34d399", // verde
  "#60a5fa", // azul
  "#f472b6", // rosa
  "#a78bfa", // violeta
  "#f87171", // rojo
  "#38bdf8", // celeste
  "#facc15", // dorado
];

